export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Map is a dictionary with string keys. */
  Map: { input: any; output: any; }
  /** Timestamp represents timestamp field. */
  Time: { input: any; output: any; }
};

/** Input type of ActivateOrganizationMembership */
export type ActivateOrganizationMembershipInput = {
  /** ID of the membership. */
  readonly id: Scalars['ID']['input'];
};

/** Return type of ActivateOrganizationMembership */
export type ActivateOrganizationMembershipPayload = {
  /** The new organizationMembership. */
  readonly organizationMembership: Maybe<OrganizationMembership>;
};

/** Agent represents single Agent instance. */
export type Agent = Node & {
  /** Agent Group of the Agent. */
  readonly agentGroup: Scalars['String']['output'];
  /** The agent API key used to register this agent. */
  readonly agentKey: AgentKey;
  /** Commit Hash of the Agent. */
  readonly commitSha: Scalars['String']['output'];
  /** Controller that Agent belongs to. */
  readonly controller: Maybe<Controller>;
  /** Current health details of the Agent. */
  readonly healthDetails: Scalars['String']['output'];
  /** Hostname discovered by the Agent. */
  readonly hostname: Scalars['String']['output'];
  /** ID of the Agent. */
  readonly id: Scalars['ID']['output'];
  /** InstallationMode of the Agent. */
  readonly installationMode: Maybe<Scalars['String']['output']>;
  /** Last seen UTC timestamp of the Agent. */
  readonly lastSeen: Scalars['Time']['output'];
  /** Project to which the Agent belongs. */
  readonly project: Project;
  /** Current status of the Agent. */
  readonly status: Scalars['String']['output'];
  /** Version of the Agent. */
  readonly version: Scalars['String']['output'];
};

/** order by aggregate values of Agent */
export type AgentAggregateOrderBy = {
  readonly count: InputMaybe<OrderBy>;
  readonly max: InputMaybe<AgentMaxOrderBy>;
  readonly min: InputMaybe<AgentMinOrderBy>;
};

/** Boolean expression to filter rows from the table "Agent". */
export type AgentBoolExp = {
  /** Agent agentGroup predicate. */
  readonly agentGroup: InputMaybe<StringComparisonExp>;
  /** Agent agent key predicate. */
  readonly agentKey: InputMaybe<AgentKeyBoolExp>;
  /** Agent agent key id predicate. */
  readonly agentKeyID: InputMaybe<IdComparisonExp>;
  /** Logical and. */
  readonly and: InputMaybe<ReadonlyArray<AgentBoolExp>>;
  /** Agent commit hash predicate. */
  readonly commitSha: InputMaybe<StringComparisonExp>;
  /** Agent controller predicate. */
  readonly controller: InputMaybe<ControllerBoolExp>;
  /** Agent controller id predicate. */
  readonly controllerID: InputMaybe<IdComparisonExp>;
  /** Agent health details predicate. */
  readonly healthDetails: InputMaybe<StringComparisonExp>;
  /** Agent hostname predicate. */
  readonly hostname: InputMaybe<StringComparisonExp>;
  /** Agent id predicate. */
  readonly id: InputMaybe<IdComparisonExp>;
  /** Agent installationMode predicate. */
  readonly installationMode: InputMaybe<StringComparisonExp>;
  /** Agent lastSeen timestamp predicate. */
  readonly lastSeen: InputMaybe<TimeComparisonExp>;
  /** Logical not. */
  readonly not: InputMaybe<AgentBoolExp>;
  /** Logical or. */
  readonly or: InputMaybe<ReadonlyArray<AgentBoolExp>>;
  /** Agent project predicate. */
  readonly project: InputMaybe<ProjectBoolExp>;
  /** Agent project id predicate. */
  readonly projectID: InputMaybe<IdComparisonExp>;
  /** Agent status predicate. */
  readonly status: InputMaybe<StringComparisonExp>;
  /** Agent version predicate. */
  readonly version: InputMaybe<StringComparisonExp>;
};

/** Look up Agents */
export type AgentConnection = {
  /** A list of edges. */
  readonly edges: ReadonlyArray<AgentEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AgentEdge = {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node: Agent;
};

/** An Agent Key. */
export type AgentKey = Node & {
  /** Agents registered with this agent key. */
  readonly agents: AgentConnection;
  /** Controllers registered with this agent key. */
  readonly controllers: ControllerConnection;
  /** Timestamp at which the Agent Key was created. */
  readonly createdAt: Scalars['Time']['output'];
  /** User who created this key. */
  readonly createdBy: Maybe<User>;
  /** Timestamp at which the Agent Key expires. */
  readonly expiresAt: Maybe<Scalars['Time']['output']>;
  /** ID of the Agent Key. */
  readonly id: Scalars['ID']['output'];
  /** Key string value. */
  readonly key: Scalars['String']['output'];
  /** Permissions granted to this agent key. */
  readonly permissions: Scalars['Map']['output'];
  /** Project to which the key is assigned to. */
  readonly project: Project;
};


/** An Agent Key. */
export type AgentKeyAgentsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<AgentSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<AgentOrderBy>>>;
  where: InputMaybe<AgentBoolExp>;
};


/** An Agent Key. */
export type AgentKeyControllersArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<ControllerSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<ControllerOrderBy>>>;
  where: InputMaybe<ControllerBoolExp>;
};

/** order by aggregate values of AgentKey */
export type AgentKeyAggregateOrderBy = {
  readonly count: InputMaybe<OrderBy>;
  readonly max: InputMaybe<AgentKeyMaxOrderBy>;
  readonly min: InputMaybe<AgentKeyMinOrderBy>;
};

/** Boolean expression to filter rows from the table "agent_key". */
export type AgentKeyBoolExp = {
  /** agent key agent predicate. */
  readonly agents: InputMaybe<AgentBoolExp>;
  /** Logical and. */
  readonly and: InputMaybe<ReadonlyArray<AgentKeyBoolExp>>;
  /** agent key controller predicate. */
  readonly controllers: InputMaybe<ControllerBoolExp>;
  /** Agent createdAt timestamp predicate. */
  readonly createdAt: InputMaybe<TimeComparisonExp>;
  /** agent key creator predicate. */
  readonly createdBy: InputMaybe<UserBoolExp>;
  /** agent key creator id predicate. */
  readonly createdByID: InputMaybe<IdComparisonExp>;
  /** Agent expiresAt timestamp predicate. */
  readonly expiresAt: InputMaybe<TimeComparisonExp>;
  /** agent key id predicate. */
  readonly id: InputMaybe<IdComparisonExp>;
  /** agent key value predicate. */
  readonly key: InputMaybe<StringComparisonExp>;
  /** Logical not. */
  readonly not: InputMaybe<AgentKeyBoolExp>;
  /** Logical or. */
  readonly or: InputMaybe<ReadonlyArray<AgentKeyBoolExp>>;
  /** agent key permission predicate. */
  readonly permissions: InputMaybe<JsonbComparisonExp>;
  /** agent key project predicate. */
  readonly project: InputMaybe<ProjectBoolExp>;
  /** agent key project id predicate. */
  readonly projectID: InputMaybe<IdComparisonExp>;
};

/** Look up Agent Keys. */
export type AgentKeyConnection = {
  /** A list of edges. */
  readonly edges: ReadonlyArray<AgentKeyEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AgentKeyEdge = {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node: AgentKey;
};

/** order by max() on columns of AgentKey */
export type AgentKeyMaxOrderBy = {
  readonly createdAt: InputMaybe<OrderBy>;
  readonly createdByID: InputMaybe<OrderBy>;
  readonly expiresAt: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly key: InputMaybe<OrderBy>;
  readonly permissions: InputMaybe<OrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
};

/** order by min() on columns of AgentKey */
export type AgentKeyMinOrderBy = {
  readonly createdAt: InputMaybe<OrderBy>;
  readonly createdByID: InputMaybe<OrderBy>;
  readonly expiresAt: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly key: InputMaybe<OrderBy>;
  readonly permissions: InputMaybe<OrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
};

/** Ordering options when querying AgentKeys. */
export type AgentKeyOrderBy = {
  readonly agentsAggregate: InputMaybe<AgentAggregateOrderBy>;
  readonly controllersAggregate: InputMaybe<ControllerAggregateOrderBy>;
  readonly createdAt: InputMaybe<OrderBy>;
  readonly createdBy: InputMaybe<UserOrderBy>;
  readonly createdByID: InputMaybe<OrderBy>;
  readonly expiresAt: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly key: InputMaybe<OrderBy>;
  readonly permissions: InputMaybe<OrderBy>;
  readonly project: InputMaybe<ProjectOrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
};

/** Select columns of Agent Keys. */
export enum AgentKeySelectColumn {
  /** Column name. */
  CreatedAt = 'createdAt',
  /** Column name. */
  CreatedById = 'createdByID',
  /** Column name. */
  ExpiresAt = 'expiresAt',
  /** Column name. */
  Id = 'id',
  /** Column name. */
  Key = 'key',
  /** Column name. */
  Permissions = 'permissions',
  /** Column name. */
  ProjectId = 'projectID'
}

/** order by max() on columns of Agent */
export type AgentMaxOrderBy = {
  readonly agentGroup: InputMaybe<OrderBy>;
  readonly agentKeyID: InputMaybe<OrderBy>;
  readonly commitSha: InputMaybe<OrderBy>;
  readonly controllerID: InputMaybe<OrderBy>;
  readonly healthDetails: InputMaybe<OrderBy>;
  readonly hostname: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly installationMode: InputMaybe<OrderBy>;
  readonly lastSeen: InputMaybe<OrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly status: InputMaybe<OrderBy>;
  readonly version: InputMaybe<OrderBy>;
};

/** order by min() on columns of Agent */
export type AgentMinOrderBy = {
  readonly agentGroup: InputMaybe<OrderBy>;
  readonly agentKeyID: InputMaybe<OrderBy>;
  readonly commitSha: InputMaybe<OrderBy>;
  readonly controllerID: InputMaybe<OrderBy>;
  readonly healthDetails: InputMaybe<OrderBy>;
  readonly hostname: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly installationMode: InputMaybe<OrderBy>;
  readonly lastSeen: InputMaybe<OrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly status: InputMaybe<OrderBy>;
  readonly version: InputMaybe<OrderBy>;
};

/** Ordering options when querying Agents. */
export type AgentOrderBy = {
  readonly agentGroup: InputMaybe<OrderBy>;
  readonly agentKey: InputMaybe<AgentKeyOrderBy>;
  readonly agentKeyID: InputMaybe<OrderBy>;
  readonly commitSha: InputMaybe<OrderBy>;
  readonly controller: InputMaybe<ControllerOrderBy>;
  readonly controllerID: InputMaybe<OrderBy>;
  readonly healthDetails: InputMaybe<OrderBy>;
  readonly hostname: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly installationMode: InputMaybe<OrderBy>;
  readonly lastSeen: InputMaybe<OrderBy>;
  readonly project: InputMaybe<ProjectOrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly status: InputMaybe<OrderBy>;
  readonly version: InputMaybe<OrderBy>;
};

/** Select columns of Agents. */
export enum AgentSelectColumn {
  /** Column name. */
  AgentGroup = 'agentGroup',
  /** Column name. */
  AgentKeyId = 'agentKeyID',
  /** Column name. */
  CommitSha = 'commitSha',
  /** Column name. */
  ControllerId = 'controllerID',
  /** Column name. */
  HealthDetails = 'healthDetails',
  /** Column name. */
  Hostname = 'hostname',
  /** Column name. */
  Id = 'id',
  /** Column name. */
  InstallationMode = 'installationMode',
  /** Column name. */
  LastSeen = 'lastSeen',
  /** Column name. */
  ProjectId = 'projectID',
  /** Column name. */
  Status = 'status',
  /** Column name. */
  Version = 'version'
}

/** Alert represents single Alert instance. */
export type Alert = Node & {
  /** Alert channels assigned to the alert. */
  readonly alertsChannelAssignments: AlertsChannelAssignmentConnection;
  /** Annotations attached to the Alert. */
  readonly annotations: Scalars['Map']['output'];
  /** Timestamp when Alert was resolved in RFC3339 format. Not present when alert is firing. */
  readonly endsAt: Maybe<Scalars['Time']['output']>;
  /** Fingerprint is unique identifier of Alert. */
  readonly fingerprint: Scalars['String']['output'];
  /** Generator URL identifies the entity that caused the Alert. */
  readonly generatorURL: Scalars['String']['output'];
  /** ID of the Alert. */
  readonly id: Scalars['ID']['output'];
  /** Labels attached to the Alert. */
  readonly labels: Scalars['Map']['output'];
  /** Timestamp when Alert was last reported by the Alertmanager in RFC3339 format. */
  readonly lastReported: Scalars['Time']['output'];
  /** Name is short description of the Alert. */
  readonly name: Scalars['String']['output'];
  /** Project to which the Alert belongs. */
  readonly project: Project;
  /** Severity of the Alert. */
  readonly severity: Scalars['String']['output'];
  /** Timestamp when Alert was created in RFC3339 format. */
  readonly startsAt: Scalars['Time']['output'];
  /** Status of the Alert. May be `resolved` or `firing`. */
  readonly status: Scalars['String']['output'];
};


/** Alert represents single Alert instance. */
export type AlertAlertsChannelAssignmentsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<AlertsChannelAssignmentSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<AlertsChannelAssignmentOrderBy>>>;
  where: InputMaybe<AlertsChannelAssignmentBoolExp>;
};

/** order by aggregate values of Alert */
export type AlertAggregateOrderBy = {
  readonly count: InputMaybe<OrderBy>;
  readonly max: InputMaybe<AlertMaxOrderBy>;
  readonly min: InputMaybe<AlertMinOrderBy>;
};

/** Boolean expression to filter rows from the table "Alert". */
export type AlertBoolExp = {
  /** Alerts channel assignment predicate. */
  readonly alertsChannelAssignments: InputMaybe<AlertsChannelAssignmentBoolExp>;
  /** Logical and. */
  readonly and: InputMaybe<ReadonlyArray<AlertBoolExp>>;
  /** Alert annotations predicate. */
  readonly annotations: InputMaybe<JsonbComparisonExp>;
  /** Alert ends at predicate. */
  readonly endsAt: InputMaybe<TimeComparisonExp>;
  /** Alert fingerprint predicate. */
  readonly fingerprint: InputMaybe<StringComparisonExp>;
  /** Alert generator URL predicate. */
  readonly generatorURL: InputMaybe<StringComparisonExp>;
  /** Alert id predicate. */
  readonly id: InputMaybe<IdComparisonExp>;
  /** Alert labels predicate. */
  readonly labels: InputMaybe<JsonbComparisonExp>;
  /** Alert last reported predicate. */
  readonly lastReported: InputMaybe<TimeComparisonExp>;
  /** Alert name predicate. */
  readonly name: InputMaybe<StringComparisonExp>;
  /** Logical not. */
  readonly not: InputMaybe<AlertBoolExp>;
  /** Logical or. */
  readonly or: InputMaybe<ReadonlyArray<AlertBoolExp>>;
  /** Alert project predicate. */
  readonly project: InputMaybe<ProjectBoolExp>;
  /** Alert project id predicate. */
  readonly projectID: InputMaybe<IdComparisonExp>;
  /** Alert severity predicate. */
  readonly severity: InputMaybe<StringComparisonExp>;
  /** Alert starts at preficate. */
  readonly startsAt: InputMaybe<TimeComparisonExp>;
  /** Alert status predicate. */
  readonly status: InputMaybe<StringComparisonExp>;
};

/** Look up Alerts */
export type AlertConnection = {
  /** A list of edges. */
  readonly edges: ReadonlyArray<AlertEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AlertEdge = {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node: Alert;
};

/** order by max() on columns of Alert */
export type AlertMaxOrderBy = {
  readonly alertsChannelAssignmentAggregate: InputMaybe<AlertsChannelAssignmentAggregateOrderBy>;
  readonly annotations: InputMaybe<OrderBy>;
  readonly endsAt: InputMaybe<OrderBy>;
  readonly fingerprint: InputMaybe<OrderBy>;
  readonly generatorURL: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly labels: InputMaybe<OrderBy>;
  readonly lastReported: InputMaybe<OrderBy>;
  readonly name: InputMaybe<OrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly severity: InputMaybe<OrderBy>;
  readonly startsAt: InputMaybe<OrderBy>;
  readonly status: InputMaybe<OrderBy>;
};

/** order by min() on columns of Alert */
export type AlertMinOrderBy = {
  readonly alertsChannelAssignmentAggregate: InputMaybe<AlertsChannelAssignmentAggregateOrderBy>;
  readonly annotations: InputMaybe<OrderBy>;
  readonly endsAt: InputMaybe<OrderBy>;
  readonly fingerprint: InputMaybe<OrderBy>;
  readonly generatorURL: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly labels: InputMaybe<OrderBy>;
  readonly lastReported: InputMaybe<OrderBy>;
  readonly name: InputMaybe<OrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly severity: InputMaybe<OrderBy>;
  readonly startsAt: InputMaybe<OrderBy>;
  readonly status: InputMaybe<OrderBy>;
};

/** Ordering options when querying Alerts. */
export type AlertOrderBy = {
  readonly alertsChannelAssignmentAggregate: InputMaybe<AlertsChannelAssignmentAggregateOrderBy>;
  readonly annotations: InputMaybe<OrderBy>;
  readonly endsAt: InputMaybe<OrderBy>;
  readonly fingerprint: InputMaybe<OrderBy>;
  readonly generatorURL: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly labels: InputMaybe<OrderBy>;
  readonly lastReported: InputMaybe<OrderBy>;
  readonly name: InputMaybe<OrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly severity: InputMaybe<OrderBy>;
  readonly startsAt: InputMaybe<OrderBy>;
  readonly status: InputMaybe<OrderBy>;
};

/** Select columns of Alerts. */
export enum AlertSelectColumn {
  /** Column name. */
  Annotations = 'annotations',
  /** Column name. */
  EndsAt = 'endsAt',
  /** Column name. */
  Fingerprint = 'fingerprint',
  /** Column name. */
  GeneratorUrl = 'generatorURL',
  /** Column name. */
  Id = 'id',
  /** Column name. */
  Labels = 'labels',
  /** Column name. */
  LastReported = 'lastReported',
  /** Column name. */
  Name = 'name',
  /** Column name. */
  ProjectId = 'projectID',
  /** Column name. */
  Severity = 'severity',
  /** Column name. */
  StartsAt = 'startsAt',
  /** Column name. */
  Status = 'status'
}

/** An alerts channel. */
export type AlertsChannel = Node & {
  /** Email notifiers connected to this alerts channel. */
  readonly alertsEmailNotifiers: AlertsEmailNotifierConnection;
  /** Alerts organization config to which alerts channel belongs. */
  readonly alertsOrganizationConfig: AlertsOrganizationConfig;
  /** Slack notifiers connected to this alerts channel. */
  readonly alertsSlackNotifiers: AlertsSlackNotifierConnection;
  /** Webhook notifiers connected to this alerts channel. */
  readonly alertsWebhookNotifiers: AlertsWebhookNotifierConnection;
  /** ID of the alerts channel. */
  readonly id: Scalars['ID']['output'];
  /** Name of the alerts channel. */
  readonly name: Scalars['String']['output'];
  /** Project to which the alerts channel belongs. */
  readonly project: Project;
  /** Timestamp (in RFC3339 format) until alert channel is silenced. */
  readonly silencedUntil: Maybe<Scalars['Time']['output']>;
};


/** An alerts channel. */
export type AlertsChannelAlertsEmailNotifiersArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<AlertsEmailNotifierSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<AlertsEmailNotifierOrderBy>>>;
  where: InputMaybe<AlertsEmailNotifierBoolExp>;
};


/** An alerts channel. */
export type AlertsChannelAlertsSlackNotifiersArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<AlertsSlackNotifierSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<AlertsSlackNotifierOrderBy>>>;
  where: InputMaybe<AlertsSlackNotifierBoolExp>;
};


/** An alerts channel. */
export type AlertsChannelAlertsWebhookNotifiersArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<AlertsWebhookNotifierSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<AlertsWebhookNotifierOrderBy>>>;
  where: InputMaybe<AlertsWebhookNotifierBoolExp>;
};

/** order by aggregate values of AlertsChannel */
export type AlertsChannelAggregateOrderBy = {
  readonly count: InputMaybe<OrderBy>;
  readonly max: InputMaybe<AlertsChannelMaxOrderBy>;
  readonly min: InputMaybe<AlertsChannelMinOrderBy>;
};

/** An alert channel assignment. */
export type AlertsChannelAssignment = Node & {
  /** Alert. */
  readonly alert: Maybe<Alert>;
  /** Alert channel. */
  readonly alertsChannel: Maybe<AlertsChannel>;
  /** Alert channel name. */
  readonly alertsChannelName: Scalars['String']['output'];
  /** ID of the assignment. */
  readonly id: Scalars['ID']['output'];
};

/** order by aggregate values of AlertsChannelAssignment */
export type AlertsChannelAssignmentAggregateOrderBy = {
  readonly count: InputMaybe<OrderBy>;
  readonly max: InputMaybe<AlertsChannelAssignmentMaxOrderBy>;
  readonly min: InputMaybe<AlertsChannelAssignmentMinOrderBy>;
};

/** Boolean expression to filter rows from the table "AlertsChannelAssignment". */
export type AlertsChannelAssignmentBoolExp = {
  /** User group membership status predicate. */
  readonly alert: InputMaybe<AlertBoolExp>;
  /** User group membership start predicate. */
  readonly alertsChannel: InputMaybe<AlertsChannelBoolExp>;
  /** User group membership end predicate. */
  readonly alertsChannelName: InputMaybe<StringComparisonExp>;
  /** Logical and. */
  readonly and: InputMaybe<ReadonlyArray<AlertsChannelAssignmentBoolExp>>;
  /** User group membership id predicate. */
  readonly id: InputMaybe<IdComparisonExp>;
  /** Logical not. */
  readonly not: InputMaybe<AlertsChannelAssignmentBoolExp>;
  /** Logical or. */
  readonly or: InputMaybe<ReadonlyArray<AlertsChannelAssignmentBoolExp>>;
};

/** Look up AlertsChannelAssignments */
export type AlertsChannelAssignmentConnection = {
  /** A list of edges. */
  readonly edges: ReadonlyArray<AlertsChannelAssignmentEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AlertsChannelAssignmentEdge = {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node: AlertsChannelAssignment;
};

/** order by max() on columns of AlertsChannelAssignment */
export type AlertsChannelAssignmentMaxOrderBy = {
  readonly alert: InputMaybe<AlertOrderBy>;
  readonly alertID: InputMaybe<OrderBy>;
  readonly alertsChannel: InputMaybe<AlertsChannelOrderBy>;
  readonly alertsChannelID: InputMaybe<OrderBy>;
  readonly alertsChannelName: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly start: InputMaybe<OrderBy>;
  readonly status: InputMaybe<OrderBy>;
};

/** order by min() on columns of AlertsChannelAssignment */
export type AlertsChannelAssignmentMinOrderBy = {
  readonly alert: InputMaybe<AlertOrderBy>;
  readonly alertID: InputMaybe<OrderBy>;
  readonly alertsChannel: InputMaybe<AlertsChannelOrderBy>;
  readonly alertsChannelID: InputMaybe<OrderBy>;
  readonly alertsChannelName: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly start: InputMaybe<OrderBy>;
  readonly status: InputMaybe<OrderBy>;
};

/** Ordering options when querying AlertsChannelAssignments. */
export type AlertsChannelAssignmentOrderBy = {
  readonly alert: InputMaybe<AlertOrderBy>;
  readonly alertID: InputMaybe<OrderBy>;
  readonly alertsChannel: InputMaybe<AlertsChannelOrderBy>;
  readonly alertsChannelID: InputMaybe<OrderBy>;
  readonly alertsChannelName: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly start: InputMaybe<OrderBy>;
  readonly status: InputMaybe<OrderBy>;
};

/** Select columns of User Group Memberships. */
export enum AlertsChannelAssignmentSelectColumn {
  /** Column name. */
  AlertId = 'alertID',
  /** Column name. */
  AlertsChannelId = 'alertsChannelID',
  /** Column name. */
  AlertsChannelName = 'alertsChannelName',
  /** Column name. */
  Id = 'id'
}

/** Boolean expression to filter rows from the table "alertsChannel". */
export type AlertsChannelBoolExp = {
  /** Alerts channel alertsOrganizationConfig predicate. */
  readonly alertsOrganizationConfig: InputMaybe<AlertsOrganizationConfigBoolExp>;
  /** Alerts channel alertsOrganizationConfig id predicate. */
  readonly alertsOrganizationConfigID: InputMaybe<IdComparisonExp>;
  /** Logical and. */
  readonly and: InputMaybe<ReadonlyArray<AlertsChannelBoolExp>>;
  /** Alerts channel id predicate. */
  readonly id: InputMaybe<IdComparisonExp>;
  /** Alerts channel name predicate. */
  readonly name: InputMaybe<StringComparisonExp>;
  /** Logical not. */
  readonly not: InputMaybe<AlertsChannelBoolExp>;
  /** Logical or. */
  readonly or: InputMaybe<ReadonlyArray<AlertsChannelBoolExp>>;
  /** Alerts channel project predicate. */
  readonly project: InputMaybe<ProjectBoolExp>;
  /** Alerts channel project id predicate. */
  readonly projectID: InputMaybe<IdComparisonExp>;
  /** Alert channel silence end time predicate. */
  readonly silencedUntil: InputMaybe<TimeComparisonExp>;
};

/** Look up AlertsChannels */
export type AlertsChannelConnection = {
  /** A list of edges. */
  readonly edges: ReadonlyArray<AlertsChannelEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AlertsChannelEdge = {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node: AlertsChannel;
};

/** order by max() on columns of AlertsChannel */
export type AlertsChannelMaxOrderBy = {
  readonly alertsOrganizationConfigID: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly name: InputMaybe<OrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly silencedUntil: InputMaybe<OrderBy>;
};

/** order by min() on columns of AlertsChannel */
export type AlertsChannelMinOrderBy = {
  readonly alertsOrganizationConfigID: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly name: InputMaybe<OrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly silencedUntil: InputMaybe<OrderBy>;
};

/** Ordering options when querying AlertsChannels. */
export type AlertsChannelOrderBy = {
  readonly alertsAggregate: InputMaybe<AlertAggregateOrderBy>;
  readonly alertsEmailNotifiersAggregate: InputMaybe<AlertsEmailNotifierAggregateOrderBy>;
  readonly alertsOrganizationConfig: InputMaybe<AlertsOrganizationConfigOrderBy>;
  readonly alertsOrganizationConfigID: InputMaybe<OrderBy>;
  readonly alertsSlackNotifiersAggregate: InputMaybe<AlertsSlackNotifierAggregateOrderBy>;
  readonly alertsWebhookNotifiersAggregate: InputMaybe<AlertsWebhookNotifierAggregateOrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly name: InputMaybe<OrderBy>;
  readonly project: InputMaybe<ProjectOrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly silencedUntil: InputMaybe<OrderBy>;
};

/** Select columns of Alerts Channel. */
export enum AlertsChannelSelectColumn {
  /** Column name. */
  AlertsOrganizationConfigId = 'alertsOrganizationConfigID',
  /** Column name. */
  Id = 'id',
  /** Column name. */
  Name = 'name',
  /** Column name. */
  ProjectId = 'projectID',
  /** Column name. */
  SilencedUntil = 'silencedUntil'
}

/** An AlertsCount */
export type AlertsCount = {
  /** Number of alerts counted in this service. */
  readonly count: Scalars['Int']['output'];
  /** Severity of the alerts counted in this service. */
  readonly severity: Scalars['String']['output'];
};

/** An alerts email notifier. */
export type AlertsEmailNotifier = Node & {
  /** Alerts channel to which the alerts email notifier belongs. */
  readonly alertsChannel: AlertsChannel;
  /** The email address to send notifications to. */
  readonly email: Scalars['String']['output'];
  /** ID of the alerts email notifier. */
  readonly id: Scalars['ID']['output'];
  /** Project to which the alerts email notifier belongs. */
  readonly project: Project;
  /** Whether to notify about resolved alerts. */
  readonly sendResolved: Scalars['Boolean']['output'];
};

/** order by aggregate values of AlertsEmailNotifier */
export type AlertsEmailNotifierAggregateOrderBy = {
  readonly count: InputMaybe<OrderBy>;
  readonly max: InputMaybe<AlertsEmailNotifierMaxOrderBy>;
  readonly min: InputMaybe<AlertsEmailNotifierMinOrderBy>;
};

/** Boolean expression to filter rows from the table "alertsEmailNotifier". */
export type AlertsEmailNotifierBoolExp = {
  /** Alerts email notifier alertsChannel predicate. */
  readonly alertsChannel: InputMaybe<AlertsChannelBoolExp>;
  /** Alerts email notifier alertsChannel id predicate. */
  readonly alertsChannelID: InputMaybe<IdComparisonExp>;
  /** Logical and. */
  readonly and: InputMaybe<ReadonlyArray<AlertsEmailNotifierBoolExp>>;
  /** Alerts email notifier email predicate. */
  readonly email: InputMaybe<StringComparisonExp>;
  /** Alerts email notifier id predicate. */
  readonly id: InputMaybe<IdComparisonExp>;
  /** Logical not. */
  readonly not: InputMaybe<AlertsEmailNotifierBoolExp>;
  /** Logical or. */
  readonly or: InputMaybe<ReadonlyArray<AlertsEmailNotifierBoolExp>>;
  /** Alerts email notifier project predicate. */
  readonly project: InputMaybe<ProjectBoolExp>;
  /** Alerts email notifier project id predicate. */
  readonly projectID: InputMaybe<IdComparisonExp>;
  /** Alerts email notifier sendResolved predicate. */
  readonly sendResolved: InputMaybe<BooleanComparisonExp>;
};

/** Look up AlertsEmailNotifiers */
export type AlertsEmailNotifierConnection = {
  /** A list of edges. */
  readonly edges: ReadonlyArray<AlertsEmailNotifierEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AlertsEmailNotifierEdge = {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node: AlertsEmailNotifier;
};

/** order by max() on columns of AlertsEmailNotifier */
export type AlertsEmailNotifierMaxOrderBy = {
  readonly alertsChannelID: InputMaybe<OrderBy>;
  readonly email: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly sendResolved: InputMaybe<OrderBy>;
};

/** order by min() on columns of AlertsEmailNotifier */
export type AlertsEmailNotifierMinOrderBy = {
  readonly alertsChannelID: InputMaybe<OrderBy>;
  readonly email: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly sendResolved: InputMaybe<OrderBy>;
};

/** Ordering options when querying AlertsEmailNotifiers. */
export type AlertsEmailNotifierOrderBy = {
  readonly alertsChannel: InputMaybe<AlertsChannelOrderBy>;
  readonly alertsChannelID: InputMaybe<OrderBy>;
  readonly email: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly project: InputMaybe<ProjectOrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly sendResolved: InputMaybe<OrderBy>;
};

/** Select columns of Alerts Channel. */
export enum AlertsEmailNotifierSelectColumn {
  /** Column name. */
  AlertsChannelId = 'alertsChannelID',
  /** Column name. */
  Email = 'email',
  /** Column name. */
  Id = 'id',
  /** Column name. */
  ProjectId = 'projectID',
  /** Column name. */
  SendResolved = 'sendResolved'
}

/** An alerts organization config. */
export type AlertsOrganizationConfig = Node & {
  /** Alerts channels in the alerts organization config. */
  readonly alertsChannels: AlertsChannelConnection;
  /** Organization config of the alerts. */
  readonly config: Scalars['String']['output'];
  /** ID of the alerts organization config. */
  readonly id: Scalars['ID']['output'];
  /** Organization to which the alerts organization config belongs. */
  readonly organization: Organization;
};


/** An alerts organization config. */
export type AlertsOrganizationConfigAlertsChannelsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<AlertsChannelSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<AlertsChannelOrderBy>>>;
  where: InputMaybe<AlertsChannelBoolExp>;
};

/** order by aggregate values of AlertsOrganizationConfig */
export type AlertsOrganizationConfigAggregateOrderBy = {
  readonly count: InputMaybe<OrderBy>;
  readonly max: InputMaybe<AlertsOrganizationConfigMaxOrderBy>;
  readonly min: InputMaybe<AlertsOrganizationConfigMinOrderBy>;
};

/** Boolean expression to filter rows from the table "AlertsOrganizationConfig". */
export type AlertsOrganizationConfigBoolExp = {
  /** AlertsOrganizationConfig alertsChannels predicate. */
  readonly alertsChannels: InputMaybe<AlertsChannelBoolExp>;
  /** Logical and. */
  readonly and: InputMaybe<ReadonlyArray<AlertsOrganizationConfigBoolExp>>;
  /** AlertsOrganizationConfig config predicate. */
  readonly config: InputMaybe<StringComparisonExp>;
  /** AlertsOrganizationConfig id predicate. */
  readonly id: InputMaybe<IdComparisonExp>;
  /** Logical not. */
  readonly not: InputMaybe<AlertsOrganizationConfigBoolExp>;
  /** Logical or. */
  readonly or: InputMaybe<ReadonlyArray<AlertsOrganizationConfigBoolExp>>;
  /** AlertsOrganizationConfig organization predicate. */
  readonly organization: InputMaybe<OrganizationBoolExp>;
  /** AlertsOrganizationConfig organization id predicate. */
  readonly organizationID: InputMaybe<IdComparisonExp>;
};

/** Look up AlertsOrganizationConfig */
export type AlertsOrganizationConfigConnection = {
  /** A list of edges. */
  readonly edges: ReadonlyArray<AlertsOrganizationConfigEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AlertsOrganizationConfigEdge = {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node: AlertsOrganizationConfig;
};

/** order by max() on columns of AlertsOrganizationConfig */
export type AlertsOrganizationConfigMaxOrderBy = {
  readonly config: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly organizationID: InputMaybe<OrderBy>;
};

/** order by min() on columns of AlertsOrganizationConfig */
export type AlertsOrganizationConfigMinOrderBy = {
  readonly config: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly organizationID: InputMaybe<OrderBy>;
};

/** Ordering options when querying AlertsOrganizationConfigs. */
export type AlertsOrganizationConfigOrderBy = {
  readonly alertsChannelsAggregate: InputMaybe<AlertsChannelAggregateOrderBy>;
  readonly config: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly organization: InputMaybe<OrganizationOrderBy>;
  readonly organizationID: InputMaybe<OrderBy>;
};

/** Select columns of AlertsOrganizationConfigs. */
export enum AlertsOrganizationConfigSelectColumn {
  /** Column name. */
  Config = 'config',
  /** Column name. */
  Id = 'id',
  /** Column name. */
  OrganizationId = 'organizationID'
}

/** An alerts slack notifier. */
export type AlertsSlackNotifier = Node & {
  /** Alerts channel to which the alerts slack notifier belongs. */
  readonly alertsChannel: AlertsChannel;
  /** The slack channel or user to send notifications to. */
  readonly channel: Scalars['String']['output'];
  /** ID of the alerts slack notifier. */
  readonly id: Scalars['ID']['output'];
  /** Project to which the alerts slack notifier belongs. */
  readonly project: Project;
  /** Whether to notify about resolved alerts. */
  readonly sendResolved: Scalars['Boolean']['output'];
  /** Slack webhook URL. */
  readonly url: Scalars['String']['output'];
};

/** order by aggregate values of AlertsSlackNotifier */
export type AlertsSlackNotifierAggregateOrderBy = {
  readonly count: InputMaybe<OrderBy>;
  readonly max: InputMaybe<AlertsSlackNotifierMaxOrderBy>;
  readonly min: InputMaybe<AlertsSlackNotifierMinOrderBy>;
};

/** Boolean expression to filter rows from the table "alertsSlackNotifier". */
export type AlertsSlackNotifierBoolExp = {
  /** Alerts slack notifier alertsChannel predicate. */
  readonly alertsChannel: InputMaybe<AlertsChannelBoolExp>;
  /** Alerts slack notifier alertsChannel id predicate. */
  readonly alertsChannelID: InputMaybe<IdComparisonExp>;
  /** Logical and. */
  readonly and: InputMaybe<ReadonlyArray<AlertsSlackNotifierBoolExp>>;
  /** Alerts slack notifier channel predicate. */
  readonly channel: InputMaybe<StringComparisonExp>;
  /** Alerts slack notifier id predicate. */
  readonly id: InputMaybe<IdComparisonExp>;
  /** Logical not. */
  readonly not: InputMaybe<AlertsSlackNotifierBoolExp>;
  /** Logical or. */
  readonly or: InputMaybe<ReadonlyArray<AlertsSlackNotifierBoolExp>>;
  /** Alerts slack notifier project predicate. */
  readonly project: InputMaybe<ProjectBoolExp>;
  /** Alerts slack notifier project id predicate. */
  readonly projectID: InputMaybe<IdComparisonExp>;
  /** Alerts slack notifier sendResolved predicate. */
  readonly sendResolved: InputMaybe<BooleanComparisonExp>;
  /** Alerts slack notifier url predicate. */
  readonly url: InputMaybe<StringComparisonExp>;
};

/** Look up AlertsSlackNotifiers */
export type AlertsSlackNotifierConnection = {
  /** A list of edges. */
  readonly edges: ReadonlyArray<AlertsSlackNotifierEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AlertsSlackNotifierEdge = {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node: AlertsSlackNotifier;
};

/** order by max() on columns of AlertsSlackNotifier */
export type AlertsSlackNotifierMaxOrderBy = {
  readonly alertsChannelID: InputMaybe<OrderBy>;
  readonly channel: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly sendResolved: InputMaybe<OrderBy>;
  readonly url: InputMaybe<OrderBy>;
};

/** order by min() on columns of AlertsSlackNotifier */
export type AlertsSlackNotifierMinOrderBy = {
  readonly alertsChannelID: InputMaybe<OrderBy>;
  readonly channel: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly sendResolved: InputMaybe<OrderBy>;
  readonly url: InputMaybe<OrderBy>;
};

/** Ordering options when querying AlertsSlackNotifiers. */
export type AlertsSlackNotifierOrderBy = {
  readonly alertsChannel: InputMaybe<AlertsChannelOrderBy>;
  readonly alertsChannelID: InputMaybe<OrderBy>;
  readonly channel: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly project: InputMaybe<ProjectOrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly sendResolved: InputMaybe<OrderBy>;
  readonly url: InputMaybe<OrderBy>;
};

/** Select columns of Alerts Channel. */
export enum AlertsSlackNotifierSelectColumn {
  /** Column name. */
  AlertsChannelId = 'alertsChannelID',
  /** Column name. */
  Channel = 'channel',
  /** Column name. */
  Id = 'id',
  /** Column name. */
  ProjectId = 'projectID',
  /** Column name. */
  SendResolved = 'sendResolved',
  /** Column name. */
  Url = 'url'
}

/** An alerts webhook notifier. */
export type AlertsWebhookNotifier = Node & {
  /** Alerts channel to which the alerts webhook notifier belongs. */
  readonly alertsChannel: AlertsChannel;
  /** ID of the alerts webhook notifier. */
  readonly id: Scalars['ID']['output'];
  /** Project to which the alerts webhook notifier belongs. */
  readonly project: Project;
  /** Whether to notify about resolved alerts. */
  readonly sendResolved: Scalars['Boolean']['output'];
  /** The URL to send HTTP POST requests to. */
  readonly url: Scalars['String']['output'];
};

/** order by aggregate values of AlertsWebhookNotifier */
export type AlertsWebhookNotifierAggregateOrderBy = {
  readonly count: InputMaybe<OrderBy>;
  readonly max: InputMaybe<AlertsWebhookNotifierMaxOrderBy>;
  readonly min: InputMaybe<AlertsWebhookNotifierMinOrderBy>;
};

/** Boolean expression to filter rows from the table "alertsWebhookNotifier". */
export type AlertsWebhookNotifierBoolExp = {
  /** Alerts webhook notifier alertsChannel predicate. */
  readonly alertsChannel: InputMaybe<AlertsChannelBoolExp>;
  /** Alerts webhook notifier alertsChannel id predicate. */
  readonly alertsChannelID: InputMaybe<IdComparisonExp>;
  /** Logical and. */
  readonly and: InputMaybe<ReadonlyArray<AlertsWebhookNotifierBoolExp>>;
  /** Alerts webhook notifier id predicate. */
  readonly id: InputMaybe<IdComparisonExp>;
  /** Logical not. */
  readonly not: InputMaybe<AlertsWebhookNotifierBoolExp>;
  /** Logical or. */
  readonly or: InputMaybe<ReadonlyArray<AlertsWebhookNotifierBoolExp>>;
  /** Alerts webhook notifier project predicate. */
  readonly project: InputMaybe<ProjectBoolExp>;
  /** Alerts webhook notifier project id predicate. */
  readonly projectID: InputMaybe<IdComparisonExp>;
  /** Alerts webhook notifier sendResolved predicate. */
  readonly sendResolved: InputMaybe<BooleanComparisonExp>;
  /** Alerts webhook notifier url predicate. */
  readonly url: InputMaybe<StringComparisonExp>;
};

/** Look up AlertsWebhookNotifiers */
export type AlertsWebhookNotifierConnection = {
  /** A list of edges. */
  readonly edges: ReadonlyArray<AlertsWebhookNotifierEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AlertsWebhookNotifierEdge = {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node: AlertsWebhookNotifier;
};

/** order by max() on columns of AlertsWebhookNotifier */
export type AlertsWebhookNotifierMaxOrderBy = {
  readonly alertsChannelID: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly sendResolved: InputMaybe<OrderBy>;
  readonly url: InputMaybe<OrderBy>;
};

/** order by min() on columns of AlertsWebhookNotifier */
export type AlertsWebhookNotifierMinOrderBy = {
  readonly alertsChannelID: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly sendResolved: InputMaybe<OrderBy>;
  readonly url: InputMaybe<OrderBy>;
};

/** Ordering options when querying AlertsWebhookNotifiers. */
export type AlertsWebhookNotifierOrderBy = {
  readonly alertsChannel: InputMaybe<AlertsChannelOrderBy>;
  readonly alertsChannelID: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly project: InputMaybe<ProjectOrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly sendResolved: InputMaybe<OrderBy>;
  readonly url: InputMaybe<OrderBy>;
};

/** Select columns of Alerts Channel. */
export enum AlertsWebhookNotifierSelectColumn {
  /** Column name. */
  AlertsChannelId = 'alertsChannelID',
  /** Column name. */
  Id = 'id',
  /** Column name. */
  ProjectId = 'projectID',
  /** Column name. */
  SendResolved = 'sendResolved',
  /** Column name. */
  Url = 'url'
}

/** An Aperture Secret. */
export type ApertureSecret = Node & {
  /** Timestamp at which the Aperture Secret was created. */
  readonly createdAt: Scalars['Time']['output'];
  /** User who created this secret. */
  readonly createdBy: Maybe<User>;
  /** ID of the Aperture Secret. */
  readonly id: Scalars['ID']['output'];
  /** Name string value. */
  readonly name: Scalars['String']['output'];
  /** Project to which the secret is assigned to. */
  readonly project: Project;
  /** Value of the secret. */
  readonly value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "aperture_secret". */
export type ApertureSecretBoolExp = {
  /** Logical and. */
  readonly and: InputMaybe<ReadonlyArray<ApertureSecretBoolExp>>;
  /** aperture secret createdAt timestamp predicate. */
  readonly createdAt: InputMaybe<TimeComparisonExp>;
  /** aperture secret creator predicate. */
  readonly createdBy: InputMaybe<UserBoolExp>;
  /** aperture secret creator id predicate. */
  readonly createdByID: InputMaybe<IdComparisonExp>;
  /** aperture secret id predicate. */
  readonly id: InputMaybe<IdComparisonExp>;
  /** aperture secret name predicate. */
  readonly name: InputMaybe<StringComparisonExp>;
  /** Logical not. */
  readonly not: InputMaybe<ApertureSecretBoolExp>;
  /** Logical or. */
  readonly or: InputMaybe<ReadonlyArray<ApertureSecretBoolExp>>;
  /** aperture secret project predicate. */
  readonly project: InputMaybe<ProjectBoolExp>;
  /** aperture secret project id predicate. */
  readonly projectID: InputMaybe<IdComparisonExp>;
  /** aperture secret value predicate. */
  readonly value: InputMaybe<StringComparisonExp>;
};

/** Look up Aperture Secrets. */
export type ApertureSecretConnection = {
  /** A list of edges. */
  readonly edges: ReadonlyArray<ApertureSecretEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ApertureSecretEdge = {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node: ApertureSecret;
};

/** Ordering options when querying ApertureSecrets. */
export type ApertureSecretOrderBy = {
  readonly createdAt: InputMaybe<OrderBy>;
  readonly createdBy: InputMaybe<UserOrderBy>;
  readonly createdByID: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly name: InputMaybe<OrderBy>;
  readonly project: InputMaybe<ProjectOrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly value: InputMaybe<OrderBy>;
};

/** Select columns of Aperture Secrets. */
export enum ApertureSecretSelectColumn {
  /** Column name. */
  CreatedAt = 'createdAt',
  /** Column name. */
  CreatedById = 'createdByID',
  /** Column name. */
  Id = 'id',
  /** Column name. */
  Name = 'name',
  /** Column name. */
  ProjectId = 'projectID',
  /** Column name. */
  Value = 'value'
}

/** Input type of applyBlueprintDefinedPolicy */
export type ApplyBlueprintDefinedPolicyInput = {
  /** Name of the used blueprint. */
  readonly blueprintName: Scalars['String']['input'];
  /** Version of the used blueprint. */
  readonly blueprintVersion: Scalars['String']['input'];
  /** The id of the blueprintPolicyDefinition to update. */
  readonly id: Scalars['ID']['input'];
  /** Name of the blueprint policy definition and the created policy. */
  readonly name: Scalars['String']['input'];
  /** ID of the project to which the definition and policy belong */
  readonly projectID: Scalars['String']['input'];
  /** Values set in the blueprint as json. */
  readonly values: Scalars['Map']['input'];
};

/** Return type of applyBlueprintDefinedPolicy */
export type ApplyBlueprintDefinedPolicyPayload = {
  /** ID of started temporal workflow. */
  readonly workflowID: Scalars['String']['output'];
};

/** Input type of applyCustomDefinedPolicy */
export type ApplyCustomDefinedPolicyInput = {
  /** Body of the defined policy. */
  readonly body: Scalars['Map']['input'];
  /**
   * Time of last edition as received from customPolicyDefinitions query.
   * Required to ensure the custom policy definition hasn't been already changed.
   */
  readonly editedAt: Scalars['Time']['input'];
  /** The id of the customPolicyDefinition to update. */
  readonly id: Scalars['ID']['input'];
  /** Name of the custom policy definition and the created policy. */
  readonly name: Scalars['String']['input'];
  /** ID of the project to which the definition and policy belong */
  readonly projectID: Scalars['String']['input'];
};

/** Return type of applyCustomDefinedPolicy */
export type ApplyCustomDefinedPolicyPayload = {
  /** ID of started temporal workflow. */
  readonly workflowID: Scalars['String']['output'];
};

/** A blueprint and its values representing a policy definition. */
export type BlueprintPolicyDefinition = Node & {
  /** Name of the used blueprint. */
  readonly blueprintName: Scalars['String']['output'];
  /** Version of the used blueprint. */
  readonly blueprintVersion: Scalars['String']['output'];
  /** ID of the user created the definition. */
  readonly createdBy: Maybe<User>;
  /** Time when blueprint policy definition was edited last time. */
  readonly editedAt: Scalars['Time']['output'];
  /** ID of the blueprint policy definition. */
  readonly id: Scalars['ID']['output'];
  /** ID of the user last modified the definition. */
  readonly lastModifiedBy: Maybe<User>;
  /** Error message when the status is changed to error. */
  readonly message: Maybe<Scalars['String']['output']>;
  /** Name of the blueprint policy definition and the created policy. */
  readonly name: Scalars['String']['output'];
  /** Policy created from the definition. */
  readonly policy: Maybe<Policy>;
  /** Project to which the blueprint policy definition belongs. */
  readonly project: Project;
  /** Status of definition's application */
  readonly status: Scalars['String']['output'];
  /** Values set in the blueprint as json. */
  readonly values: Scalars['Map']['output'];
};

/** order by aggregate values of BlueprintPolicyDefinition */
export type BlueprintPolicyDefinitionAggregateOrderBy = {
  readonly count: InputMaybe<OrderBy>;
  readonly max: InputMaybe<BlueprintPolicyDefinitionMaxOrderBy>;
  readonly min: InputMaybe<BlueprintPolicyDefinitionMinOrderBy>;
};

/** Boolean expression to filter rows from the table "BlueprintPolicyDefinition". */
export type BlueprintPolicyDefinitionBoolExp = {
  /** Logical and. */
  readonly and: InputMaybe<ReadonlyArray<BlueprintPolicyDefinitionBoolExp>>;
  /** BlueprintPolicyDefinition blueprint name predicate. */
  readonly blueprintName: InputMaybe<StringComparisonExp>;
  /** BlueprintPolicyDefinition blueprint version predicate. */
  readonly blueprintVersion: InputMaybe<StringComparisonExp>;
  /** BlueprintPolicyDefinition created by predicate. */
  readonly createdBy: InputMaybe<UserBoolExp>;
  /** BlueprintPolicyDefinition created by ID predicate. */
  readonly createdByID: InputMaybe<IdComparisonExp>;
  /** BlueprintPolicyDefinition edited at predicate. */
  readonly editedAt: InputMaybe<TimeComparisonExp>;
  /** BlueprintPolicyDefinition id predicate. */
  readonly id: InputMaybe<IdComparisonExp>;
  /** BlueprintPolicyDefinition last modified by predicate. */
  readonly lastModifiedBy: InputMaybe<UserBoolExp>;
  /** BlueprintPolicyDefinition last modified by ID predicate. */
  readonly lastModifiedByID: InputMaybe<IdComparisonExp>;
  /** BlueprintPolicyDefinition message predicate. */
  readonly message: InputMaybe<StringComparisonExp>;
  /** BlueprintPolicyDefinition name predicate. */
  readonly name: InputMaybe<StringComparisonExp>;
  /** Logical not. */
  readonly not: InputMaybe<BlueprintPolicyDefinitionBoolExp>;
  /** Logical or. */
  readonly or: InputMaybe<ReadonlyArray<BlueprintPolicyDefinitionBoolExp>>;
  /** BlueprintPolicyDefinition policy predicate. */
  readonly policy: InputMaybe<PolicyBoolExp>;
  /** BlueprintPolicyDefinition policy id predicate. */
  readonly policyID: InputMaybe<IdComparisonExp>;
  /** BlueprintPolicyDefinition project predicate. */
  readonly project: InputMaybe<ProjectBoolExp>;
  /** BlueprintPolicyDefinition project id predicate. */
  readonly projectID: InputMaybe<IdComparisonExp>;
  /** Status values predicate. */
  readonly status: InputMaybe<StringComparisonExp>;
  /** BlueprintPolicyDefinition values predicate. */
  readonly values: InputMaybe<JsonbComparisonExp>;
};

/** Look up BlueprintPolicyDefinitions. */
export type BlueprintPolicyDefinitionConnection = {
  /** A list of edges. */
  readonly edges: ReadonlyArray<BlueprintPolicyDefinitionEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BlueprintPolicyDefinitionEdge = {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node: BlueprintPolicyDefinition;
};

/** order by max() on columns of BlueprintPolicyDefinition */
export type BlueprintPolicyDefinitionMaxOrderBy = {
  readonly blueprintName: InputMaybe<OrderBy>;
  readonly blueprintVersion: InputMaybe<OrderBy>;
  readonly createdBy: InputMaybe<UserOrderBy>;
  readonly editedAt: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly lastModifiedBy: InputMaybe<UserOrderBy>;
  readonly message: InputMaybe<OrderBy>;
  readonly name: InputMaybe<OrderBy>;
  readonly policy: InputMaybe<PolicyOrderBy>;
  readonly project: InputMaybe<ProjectOrderBy>;
  readonly values: InputMaybe<OrderBy>;
};

/** order by min() on columns of BlueprintPolicyDefinition */
export type BlueprintPolicyDefinitionMinOrderBy = {
  readonly blueprintName: InputMaybe<OrderBy>;
  readonly blueprintVersion: InputMaybe<OrderBy>;
  readonly createdBy: InputMaybe<UserOrderBy>;
  readonly editedAt: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly lastModifiedBy: InputMaybe<UserOrderBy>;
  readonly message: InputMaybe<OrderBy>;
  readonly name: InputMaybe<OrderBy>;
  readonly policy: InputMaybe<PolicyOrderBy>;
  readonly project: InputMaybe<ProjectOrderBy>;
  readonly values: InputMaybe<OrderBy>;
};

/** Ordering options when querying BlueprintPolicyDefinitions. */
export type BlueprintPolicyDefinitionOrderBy = {
  readonly blueprintName: InputMaybe<OrderBy>;
  readonly blueprintVersion: InputMaybe<OrderBy>;
  readonly createdBy: InputMaybe<UserOrderBy>;
  readonly editedAt: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly lastModifiedBy: InputMaybe<UserOrderBy>;
  readonly message: InputMaybe<OrderBy>;
  readonly name: InputMaybe<OrderBy>;
  readonly policy: InputMaybe<PolicyOrderBy>;
  readonly project: InputMaybe<ProjectOrderBy>;
  readonly values: InputMaybe<OrderBy>;
};

/** Select columns of BlueprintPolicyDefinitions. */
export enum BlueprintPolicyDefinitionSelectColumn {
  /** Column name. */
  BlueprintName = 'blueprintName',
  /** Column name. */
  BlueprintVersion = 'blueprintVersion',
  /** Column name. */
  CreatedById = 'createdByID',
  /** Column name. */
  Id = 'id',
  /** Column name. */
  LastModifiedById = 'lastModifiedByID',
  /** Column name. */
  Message = 'message',
  /** Column name. */
  Name = 'name',
  /** Column name. */
  PolicyId = 'policyID',
  /** Column name. */
  ProjectId = 'projectID',
  /** Column name. */
  Values = 'values'
}

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type BooleanComparisonExp = {
  /** Equal to operator. */
  readonly eq: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than operator. */
  readonly gt: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than or equal to operator. */
  readonly gte: InputMaybe<Scalars['Boolean']['input']>;
  /** In a list operator. */
  readonly in: InputMaybe<ReadonlyArray<Scalars['Boolean']['input']>>;
  /** Is null operator. */
  readonly isNull: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than operator. */
  readonly lt: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than or equal to operator. */
  readonly lte: InputMaybe<Scalars['Boolean']['input']>;
  /** Not equal to operator. */
  readonly neq: InputMaybe<Scalars['Boolean']['input']>;
  /** Not in a list operator. */
  readonly nin: InputMaybe<ReadonlyArray<Scalars['Boolean']['input']>>;
};

/** A Classifier */
export type Classifier = Node & {
  /** Body of the rule. */
  readonly body: Scalars['Map']['output'];
  /** Control points assigned to the classifier. */
  readonly controlPointClassifierAssignments: ControlPointClassifierAssignmentConnection;
  /** Timestamp when membership was ended in RFC3339 format. */
  readonly end: Maybe<Scalars['String']['output']>;
  /** Flow label of the rule. */
  readonly flowLabel: Scalars['String']['output'];
  /** ID of the rule. */
  readonly id: Scalars['ID']['output'];
  /** Label selector of the rule. */
  readonly labelSelector: Scalars['Map']['output'];
  /** Policy to which the rule belongs. */
  readonly policy: Policy;
  /** Project to which the Classifier belongs. */
  readonly project: Project;
  /** Timestamp when the Classifier was created in RFC3339 format. */
  readonly start: Scalars['String']['output'];
};


/** A Classifier */
export type ClassifierControlPointClassifierAssignmentsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<ControlPointClassifierAssignmentSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<ControlPointClassifierAssignmentOrderBy>>>;
  where: InputMaybe<ControlPointClassifierAssignmentBoolExp>;
};

/** order by aggregate values of Classifier */
export type ClassifierAggregateOrderBy = {
  readonly count: InputMaybe<OrderBy>;
  readonly max: InputMaybe<ClassifierMaxOrderBy>;
  readonly min: InputMaybe<ClassifierMinOrderBy>;
};

/** Boolean expression to filter rows from the table "Classifier". */
export type ClassifierBoolExp = {
  /** Logical and. */
  readonly and: InputMaybe<ReadonlyArray<ClassifierBoolExp>>;
  /** Classifier body predicate. */
  readonly body: InputMaybe<JsonbComparisonExp>;
  /** Classifier assignments to control points predicate. */
  readonly controlPointClassifierAssignments: InputMaybe<ControlPointClassifierAssignmentBoolExp>;
  /** Classifier end predicate. */
  readonly end: InputMaybe<StringComparisonExp>;
  /** Classifier flowLabel predicate. */
  readonly flowLabel: InputMaybe<StringComparisonExp>;
  /** Classifier id predicate. */
  readonly id: InputMaybe<IdComparisonExp>;
  /** Classifier label selector predicate. */
  readonly labelSelector: InputMaybe<JsonbComparisonExp>;
  /** Logical not. */
  readonly not: InputMaybe<ClassifierBoolExp>;
  /** Logical or. */
  readonly or: InputMaybe<ReadonlyArray<ClassifierBoolExp>>;
  /** Classifier policy predicate. */
  readonly policy: InputMaybe<PolicyBoolExp>;
  /** Classifier policy id predicate. */
  readonly policyID: InputMaybe<IdComparisonExp>;
  /** Classifier project predicate. */
  readonly project: InputMaybe<ProjectBoolExp>;
  /** Classifier project id predicate. */
  readonly projectID: InputMaybe<IdComparisonExp>;
  /** Classifier start predicate. */
  readonly start: InputMaybe<StringComparisonExp>;
};

/** Look up Classifiers. */
export type ClassifierConnection = {
  /** A list of edges. */
  readonly edges: ReadonlyArray<ClassifierEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ClassifierEdge = {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node: Classifier;
};

/** order by max() on columns of Classifier */
export type ClassifierMaxOrderBy = {
  readonly body: InputMaybe<OrderBy>;
  readonly end: InputMaybe<OrderBy>;
  readonly flowLabel: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly labelSelector: InputMaybe<OrderBy>;
  readonly policy: InputMaybe<PolicyOrderBy>;
  readonly policyID: InputMaybe<OrderBy>;
  readonly project: InputMaybe<ProjectOrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly start: InputMaybe<OrderBy>;
};

/** order by min() on columns of Classifier */
export type ClassifierMinOrderBy = {
  readonly body: InputMaybe<OrderBy>;
  readonly end: InputMaybe<OrderBy>;
  readonly flowLabel: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly labelSelector: InputMaybe<OrderBy>;
  readonly policy: InputMaybe<PolicyOrderBy>;
  readonly policyID: InputMaybe<OrderBy>;
  readonly project: InputMaybe<ProjectOrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly start: InputMaybe<OrderBy>;
};

/** Ordering options when querying Classifiers. */
export type ClassifierOrderBy = {
  readonly body: InputMaybe<OrderBy>;
  readonly end: InputMaybe<OrderBy>;
  readonly flowLabel: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly labelSelector: InputMaybe<OrderBy>;
  readonly policy: InputMaybe<PolicyOrderBy>;
  readonly policyID: InputMaybe<OrderBy>;
  readonly project: InputMaybe<ProjectOrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly start: InputMaybe<OrderBy>;
};

/** Select columns of Classifiers. */
export enum ClassifierSelectColumn {
  /** Column name. */
  Body = 'body',
  /** Column name. */
  End = 'end',
  /** Column name. */
  FlowLabel = 'flowLabel',
  /** Column name. */
  Id = 'id',
  /** Column name. */
  LabelSelector = 'labelSelector',
  /** Column name. */
  PolicyId = 'policyID',
  /** Column name. */
  ProjectId = 'projectID',
  /** Column name. */
  Start = 'start'
}

/** A Component of the policy. */
export type Component = Node & {
  /** Body of the component. */
  readonly body: Scalars['Map']['output'];
  /** Control points assigned to the component. */
  readonly controlPointComponentAssignments: ControlPointComponentAssignmentConnection;
  /** ID of the component. */
  readonly id: Scalars['ID']['output'];
  /** Policy to which the component belongs. */
  readonly policy: Policy;
  /** Project to which the component belongs. */
  readonly project: Project;
  /** Signals used in this component. */
  readonly signals: Maybe<Scalars['Map']['output']>;
  /** Subtype of this component. */
  readonly subtype: Maybe<Scalars['String']['output']>;
  /** Type of the component. */
  readonly type: Scalars['String']['output'];
};


/** A Component of the policy. */
export type ComponentControlPointComponentAssignmentsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<ControlPointComponentAssignmentSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<ControlPointComponentAssignmentOrderBy>>>;
  where: InputMaybe<ControlPointComponentAssignmentBoolExp>;
};

/** order by aggregate values of Component */
export type ComponentAggregateOrderBy = {
  readonly count: InputMaybe<OrderBy>;
  readonly max: InputMaybe<ComponentMaxOrderBy>;
  readonly min: InputMaybe<ComponentMinOrderBy>;
};

/** Boolean expression to filter rows from the table "Component". */
export type ComponentBoolExp = {
  /** Logical and. */
  readonly and: InputMaybe<ReadonlyArray<ComponentBoolExp>>;
  /** Component body predicate. */
  readonly body: InputMaybe<JsonbComparisonExp>;
  /** Component assignment to control points predicate. */
  readonly controlPointComponentAssignments: InputMaybe<ControlPointComponentAssignmentBoolExp>;
  /** Component id predicate. */
  readonly id: InputMaybe<IdComparisonExp>;
  /** Logical not. */
  readonly not: InputMaybe<ComponentBoolExp>;
  /** Logical or. */
  readonly or: InputMaybe<ReadonlyArray<ComponentBoolExp>>;
  /** Component policy predicate. */
  readonly policy: InputMaybe<PolicyBoolExp>;
  /** Component policy id predicate. */
  readonly policyID: InputMaybe<IdComparisonExp>;
  /** Component project predicate. */
  readonly project: InputMaybe<ProjectBoolExp>;
  /** Component project id predicate. */
  readonly projectID: InputMaybe<IdComparisonExp>;
  /** Component signals predicate. */
  readonly signals: InputMaybe<JsonbComparisonExp>;
  /** Component subtype predicate. */
  readonly subtype: InputMaybe<StringComparisonExp>;
  /** Component type predicate. */
  readonly type: InputMaybe<StringComparisonExp>;
};

/** Look up Components. */
export type ComponentConnection = {
  /** A list of edges. */
  readonly edges: ReadonlyArray<ComponentEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ComponentEdge = {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node: Component;
};

/** order by max() on columns of Component */
export type ComponentMaxOrderBy = {
  readonly body: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly policy: InputMaybe<PolicyOrderBy>;
  readonly policyID: InputMaybe<OrderBy>;
  readonly project: InputMaybe<ProjectOrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly signals: InputMaybe<OrderBy>;
  readonly subtype: InputMaybe<OrderBy>;
  readonly type: InputMaybe<OrderBy>;
};

/** order by min() on columns of Component */
export type ComponentMinOrderBy = {
  readonly body: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly policy: InputMaybe<PolicyOrderBy>;
  readonly policyID: InputMaybe<OrderBy>;
  readonly project: InputMaybe<ProjectOrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly signals: InputMaybe<OrderBy>;
  readonly subtype: InputMaybe<OrderBy>;
  readonly type: InputMaybe<OrderBy>;
};

/** Ordering options when querying Components. */
export type ComponentOrderBy = {
  readonly body: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly policy: InputMaybe<PolicyOrderBy>;
  readonly policyID: InputMaybe<OrderBy>;
  readonly project: InputMaybe<ProjectOrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly signals: InputMaybe<OrderBy>;
  readonly subtype: InputMaybe<OrderBy>;
  readonly type: InputMaybe<OrderBy>;
};

/** Select columns of Components. */
export enum ComponentSelectColumn {
  /** Column name. */
  Body = 'body',
  /** Column name. */
  Id = 'id',
  /** Column name. */
  PolicyId = 'policyID',
  /** Column name. */
  ProjectId = 'projectID',
  /** Column name. */
  Signals = 'signals',
  /** Column name. */
  Subtype = 'subtype',
  /** Column name. */
  Type = 'type'
}

export type ComponentView = {
  readonly component: Scalars['Map']['output'];
  readonly componentDescription: Scalars['String']['output'];
  readonly componentId: Scalars['String']['output'];
  readonly componentName: Scalars['String']['output'];
  readonly componentType: Scalars['String']['output'];
  readonly inPorts: Maybe<ReadonlyArray<Maybe<PortView>>>;
  readonly outPorts: Maybe<ReadonlyArray<Maybe<PortView>>>;
};

export type ConstantValue = {
  readonly constantValue: Scalars['Float']['output'];
};

/** A ControlPoint of the policy. */
export type ControlPoint = Node & {
  /** Classifiers assigned to the Control Point. */
  readonly controlPointClassifierAssignments: ControlPointClassifierAssignmentConnection;
  /** Control points assigned to the component. */
  readonly controlPointComponentAssignments: ControlPointComponentAssignmentConnection;
  /** FluxMeters assigned to the Control Point. */
  readonly controlPointFluxMeterAssignments: ControlPointFluxMeterAssignmentConnection;
  /** UTC timestamp when the control point was seen for the first time. */
  readonly discoveredOn: Scalars['Time']['output'];
  /** ID of the control point. */
  readonly id: Scalars['ID']['output'];
  /** Last seen UTC timestamp of when the control point was seen for the last time. */
  readonly lastSeen: Scalars['Time']['output'];
  /** Name of the control point. */
  readonly name: Scalars['String']['output'];
  /** Project to which the control point belongs. */
  readonly project: Project;
  /** Service to which the control point belongs. */
  readonly service: Maybe<Service>;
  /** Current status of the control point. */
  readonly status: Scalars['String']['output'];
  /** Type of the control point. */
  readonly type: Scalars['String']['output'];
};


/** A ControlPoint of the policy. */
export type ControlPointControlPointClassifierAssignmentsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<ControlPointClassifierAssignmentSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<ControlPointClassifierAssignmentOrderBy>>>;
  where: InputMaybe<ControlPointClassifierAssignmentBoolExp>;
};


/** A ControlPoint of the policy. */
export type ControlPointControlPointComponentAssignmentsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<ControlPointComponentAssignmentSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<ControlPointComponentAssignmentOrderBy>>>;
  where: InputMaybe<ControlPointComponentAssignmentBoolExp>;
};


/** A ControlPoint of the policy. */
export type ControlPointControlPointFluxMeterAssignmentsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<ControlPointFluxMeterAssignmentSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<ControlPointFluxMeterAssignmentOrderBy>>>;
  where: InputMaybe<ControlPointFluxMeterAssignmentBoolExp>;
};

/** order by aggregate values of ControlPoint */
export type ControlPointAggregateOrderBy = {
  readonly count: InputMaybe<OrderBy>;
  readonly max: InputMaybe<ControlPointMaxOrderBy>;
  readonly min: InputMaybe<ControlPointMinOrderBy>;
};

/** Boolean expression to filter rows from the table "ControlPoint". */
export type ControlPointBoolExp = {
  /** Logical and. */
  readonly and: InputMaybe<ReadonlyArray<ControlPointBoolExp>>;
  /** Component assignment to control points predicate. */
  readonly controlPointComponentAssignments: InputMaybe<ControlPointComponentAssignmentBoolExp>;
  /** ControlPoint discoveredOn timestamp predicate. */
  readonly discoveredOn: InputMaybe<TimeComparisonExp>;
  /** ControlPoint id predicate. */
  readonly id: InputMaybe<IdComparisonExp>;
  /** ControlPoint lastSeen timestamp predicate. */
  readonly lastSeen: InputMaybe<TimeComparisonExp>;
  /** ControlPoint name predicate. */
  readonly name: InputMaybe<StringComparisonExp>;
  /** Logical not. */
  readonly not: InputMaybe<ControlPointBoolExp>;
  /** Logical or. */
  readonly or: InputMaybe<ReadonlyArray<ControlPointBoolExp>>;
  /** ControlPoint project predicate. */
  readonly project: InputMaybe<ProjectBoolExp>;
  /** ControlPoint project id predicate. */
  readonly projectID: InputMaybe<IdComparisonExp>;
  /** ControlPoint service predicate. */
  readonly service: InputMaybe<ServiceBoolExp>;
  /** ControlPoint service id predicate. */
  readonly serviceID: InputMaybe<IdComparisonExp>;
  /** ControlPoint status predicate. */
  readonly status: InputMaybe<StringComparisonExp>;
  /** ControlPoint type predicate. */
  readonly type: InputMaybe<StringComparisonExp>;
};

/** An assignment of control point (selector) to a classifier. */
export type ControlPointClassifierAssignment = Node & {
  /** Classifier. */
  readonly classifier: Maybe<Classifier>;
  /** Control Point. */
  readonly controlPoint: Maybe<ControlPoint>;
  /** ID of the assignment. */
  readonly id: Scalars['ID']['output'];
};

/** order by aggregate values of ControlPointClassifierAssignment */
export type ControlPointClassifierAssignmentAggregateOrderBy = {
  readonly count: InputMaybe<OrderBy>;
  readonly max: InputMaybe<ControlPointClassifierAssignmentMaxOrderBy>;
  readonly min: InputMaybe<ControlPointClassifierAssignmentMinOrderBy>;
};

/** Boolean expression to filter rows from the table "ControlPointClassifierAssignment". */
export type ControlPointClassifierAssignmentBoolExp = {
  /** Logical and. */
  readonly and: InputMaybe<ReadonlyArray<ControlPointClassifierAssignmentBoolExp>>;
  /** Classifier predicate. */
  readonly classifier: InputMaybe<ClassifierBoolExp>;
  /** Classifier id predicate. */
  readonly classifierID: InputMaybe<IdComparisonExp>;
  /** ControlPoint predicate. */
  readonly controlPoint: InputMaybe<ControlPointBoolExp>;
  /** Control Point id predicate. */
  readonly controlPointID: InputMaybe<IdComparisonExp>;
  /** ControlPoint to Classifier assignment id predicate. */
  readonly id: InputMaybe<IdComparisonExp>;
  /** Logical not. */
  readonly not: InputMaybe<ControlPointClassifierAssignmentBoolExp>;
  /** Logical or. */
  readonly or: InputMaybe<ReadonlyArray<ControlPointClassifierAssignmentBoolExp>>;
};

/** Look up ControlPointClassifierAssignments */
export type ControlPointClassifierAssignmentConnection = {
  /** A list of edges. */
  readonly edges: ReadonlyArray<ControlPointClassifierAssignmentEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ControlPointClassifierAssignmentEdge = {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node: ControlPointClassifierAssignment;
};

/** order by max() on columns of ControlPointClassifierAssignment */
export type ControlPointClassifierAssignmentMaxOrderBy = {
  readonly classifier: InputMaybe<ClassifierOrderBy>;
  readonly classifierID: InputMaybe<OrderBy>;
  readonly controlPoint: InputMaybe<ControlPointOrderBy>;
  readonly controlPointID: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
};

/** order by min() on columns of ControlPointClassifierAssignment */
export type ControlPointClassifierAssignmentMinOrderBy = {
  readonly classifier: InputMaybe<ClassifierOrderBy>;
  readonly classifierID: InputMaybe<OrderBy>;
  readonly controlPoint: InputMaybe<ControlPointOrderBy>;
  readonly controlPointID: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
};

/** Ordering options when querying ControlPointClassifierAssignments. */
export type ControlPointClassifierAssignmentOrderBy = {
  readonly classifier: InputMaybe<ClassifierOrderBy>;
  readonly classifierID: InputMaybe<OrderBy>;
  readonly controlPoint: InputMaybe<ControlPointOrderBy>;
  readonly controlPointID: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
};

/** Select columns of User Group Memberships. */
export enum ControlPointClassifierAssignmentSelectColumn {
  /** Column name. */
  ClassifierId = 'classifierID',
  /** Column name. */
  ControlPointId = 'controlPointID',
  /** Column name. */
  Id = 'id'
}

/** An assignment of control point (selector) to a component. */
export type ControlPointComponentAssignment = Node & {
  /** Component. */
  readonly component: Maybe<Component>;
  /** Control Point. */
  readonly controlPoint: Maybe<ControlPoint>;
  /** ID of the assignment. */
  readonly id: Scalars['ID']['output'];
};

/** order by aggregate values of ControlPointComponentAssignment */
export type ControlPointComponentAssignmentAggregateOrderBy = {
  readonly count: InputMaybe<OrderBy>;
  readonly max: InputMaybe<ControlPointComponentAssignmentMaxOrderBy>;
  readonly min: InputMaybe<ControlPointComponentAssignmentMinOrderBy>;
};

/** Boolean expression to filter rows from the table "ControlPointComponentAssignment". */
export type ControlPointComponentAssignmentBoolExp = {
  /** Logical and. */
  readonly and: InputMaybe<ReadonlyArray<ControlPointComponentAssignmentBoolExp>>;
  /** Component predicate. */
  readonly component: InputMaybe<ComponentBoolExp>;
  /** Component id predicate. */
  readonly componentID: InputMaybe<IdComparisonExp>;
  /** ControlPoint predicate. */
  readonly controlPoint: InputMaybe<ControlPointBoolExp>;
  /** Control Point id predicate. */
  readonly controlPointID: InputMaybe<IdComparisonExp>;
  /** ControlPoint to Component assignment id predicate. */
  readonly id: InputMaybe<IdComparisonExp>;
  /** Logical not. */
  readonly not: InputMaybe<ControlPointComponentAssignmentBoolExp>;
  /** Logical or. */
  readonly or: InputMaybe<ReadonlyArray<ControlPointComponentAssignmentBoolExp>>;
};

/** Look up ControlPointComponentAssignments */
export type ControlPointComponentAssignmentConnection = {
  /** A list of edges. */
  readonly edges: ReadonlyArray<ControlPointComponentAssignmentEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ControlPointComponentAssignmentEdge = {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node: ControlPointComponentAssignment;
};

/** order by max() on columns of ControlPointComponentAssignment */
export type ControlPointComponentAssignmentMaxOrderBy = {
  readonly component: InputMaybe<ComponentOrderBy>;
  readonly componentID: InputMaybe<OrderBy>;
  readonly controlPoint: InputMaybe<ControlPointOrderBy>;
  readonly controlPointID: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
};

/** order by min() on columns of ControlPointComponentAssignment */
export type ControlPointComponentAssignmentMinOrderBy = {
  readonly component: InputMaybe<ComponentOrderBy>;
  readonly componentID: InputMaybe<OrderBy>;
  readonly controlPoint: InputMaybe<ControlPointOrderBy>;
  readonly controlPointID: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
};

/** Ordering options when querying ControlPointComponentAssignments. */
export type ControlPointComponentAssignmentOrderBy = {
  readonly component: InputMaybe<ComponentOrderBy>;
  readonly componentID: InputMaybe<OrderBy>;
  readonly controlPoint: InputMaybe<ControlPointOrderBy>;
  readonly controlPointID: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
};

/** Select columns of User Group Memberships. */
export enum ControlPointComponentAssignmentSelectColumn {
  /** Column name. */
  ComponentId = 'componentID',
  /** Column name. */
  ControlPointId = 'controlPointID',
  /** Column name. */
  Id = 'id'
}

/** Look up ControlPoints. */
export type ControlPointConnection = {
  /** A list of edges. */
  readonly edges: ReadonlyArray<ControlPointEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ControlPointEdge = {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node: ControlPoint;
};

/** An assignment of control point (selector) to a fluxmeter. */
export type ControlPointFluxMeterAssignment = Node & {
  /** Control Point. */
  readonly controlPoint: Maybe<ControlPoint>;
  /** FluxMeter. */
  readonly fluxMeter: Maybe<FluxMeter>;
  /** ID of the assignment. */
  readonly id: Scalars['ID']['output'];
};

/** order by aggregate values of ControlPointFluxMeterAssignment */
export type ControlPointFluxMeterAssignmentAggregateOrderBy = {
  readonly count: InputMaybe<OrderBy>;
  readonly max: InputMaybe<ControlPointFluxMeterAssignmentMaxOrderBy>;
  readonly min: InputMaybe<ControlPointFluxMeterAssignmentMinOrderBy>;
};

/** Boolean expression to filter rows from the table "ControlPointFluxMeterAssignment". */
export type ControlPointFluxMeterAssignmentBoolExp = {
  /** Logical and. */
  readonly and: InputMaybe<ReadonlyArray<ControlPointFluxMeterAssignmentBoolExp>>;
  /** ControlPoint predicate. */
  readonly controlPoint: InputMaybe<ControlPointBoolExp>;
  /** Control Point id predicate. */
  readonly controlPointID: InputMaybe<IdComparisonExp>;
  /** FluxMeter predicate. */
  readonly fluxMeter: InputMaybe<FluxMeterBoolExp>;
  /** FluxMeter id predicate. */
  readonly fluxMeterID: InputMaybe<IdComparisonExp>;
  /** ControlPoint to FluxMeter assignment id predicate. */
  readonly id: InputMaybe<IdComparisonExp>;
  /** Logical not. */
  readonly not: InputMaybe<ControlPointFluxMeterAssignmentBoolExp>;
  /** Logical or. */
  readonly or: InputMaybe<ReadonlyArray<ControlPointFluxMeterAssignmentBoolExp>>;
};

/** Look up ControlPointFluxMeterAssignments */
export type ControlPointFluxMeterAssignmentConnection = {
  /** A list of edges. */
  readonly edges: ReadonlyArray<ControlPointFluxMeterAssignmentEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ControlPointFluxMeterAssignmentEdge = {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node: ControlPointFluxMeterAssignment;
};

/** order by max() on columns of ControlPointFluxMeterAssignment */
export type ControlPointFluxMeterAssignmentMaxOrderBy = {
  readonly controlPoint: InputMaybe<ControlPointOrderBy>;
  readonly controlPointID: InputMaybe<OrderBy>;
  readonly fluxMeter: InputMaybe<FluxMeterOrderBy>;
  readonly fluxMeterID: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
};

/** order by min() on columns of ControlPointFluxMeterAssignment */
export type ControlPointFluxMeterAssignmentMinOrderBy = {
  readonly controlPoint: InputMaybe<ControlPointOrderBy>;
  readonly controlPointID: InputMaybe<OrderBy>;
  readonly fluxMeter: InputMaybe<FluxMeterOrderBy>;
  readonly fluxMeterID: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
};

/** Ordering options when querying ControlPointFluxMeterAssignments. */
export type ControlPointFluxMeterAssignmentOrderBy = {
  readonly controlPoint: InputMaybe<ControlPointOrderBy>;
  readonly controlPointID: InputMaybe<OrderBy>;
  readonly fluxMeter: InputMaybe<FluxMeterOrderBy>;
  readonly fluxMeterID: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
};

/** Select columns of User Group Memberships. */
export enum ControlPointFluxMeterAssignmentSelectColumn {
  /** Column name. */
  ControlPointId = 'controlPointID',
  /** Column name. */
  FluxMeterId = 'fluxMeterID',
  /** Column name. */
  Id = 'id'
}

/** order by max() on columns of ControlPoint */
export type ControlPointMaxOrderBy = {
  readonly discoveredOn: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly lastSeen: InputMaybe<OrderBy>;
  readonly name: InputMaybe<OrderBy>;
  readonly project: InputMaybe<ProjectOrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly service: InputMaybe<ServiceOrderBy>;
  readonly serviceID: InputMaybe<OrderBy>;
  readonly status: InputMaybe<OrderBy>;
};

/** order by min() on columns of ControlPoint */
export type ControlPointMinOrderBy = {
  readonly discoveredOn: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly lastSeen: InputMaybe<OrderBy>;
  readonly name: InputMaybe<OrderBy>;
  readonly project: InputMaybe<ProjectOrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly service: InputMaybe<ServiceOrderBy>;
  readonly serviceID: InputMaybe<OrderBy>;
  readonly status: InputMaybe<OrderBy>;
};

/** Ordering options when querying ControlPoints. */
export type ControlPointOrderBy = {
  readonly discoveredOn: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly lastSeen: InputMaybe<OrderBy>;
  readonly name: InputMaybe<OrderBy>;
  readonly project: InputMaybe<ProjectOrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly service: InputMaybe<ServiceOrderBy>;
  readonly serviceID: InputMaybe<OrderBy>;
  readonly status: InputMaybe<OrderBy>;
};

/** Select columns of ControlPoints. */
export enum ControlPointSelectColumn {
  /** Column name. */
  DiscoveredOn = 'discoveredOn',
  /** Column name. */
  Id = 'id',
  /** Column name. */
  LastSeen = 'lastSeen',
  /** Column name. */
  Name = 'name',
  /** Column name. */
  ProjectId = 'projectID',
  /** Column name. */
  ServiceId = 'serviceID',
  /** Column name. */
  Status = 'status',
  /** Column name. */
  Type = 'type'
}

/** Controller represents single Controller instance. */
export type Controller = Node & {
  /** The controller agent key used to register this controller. */
  readonly agentKey: AgentKey;
  /** Agents in the controller. */
  readonly agents: AgentConnection;
  /** Commit Hash of the Controller. */
  readonly commitSha: Scalars['String']['output'];
  /** Current health details of the Controller. */
  readonly healthDetails: Scalars['String']['output'];
  /** ID of the Controller. */
  readonly id: Scalars['ID']['output'];
  /** Last seen UTC timestamp of the Controller. */
  readonly lastSeen: Scalars['Time']['output'];
  /** Name for Controller from combined agentGroup and namespace. */
  readonly name: Scalars['String']['output'];
  /** Policies in the controller. */
  readonly policies: PolicyConnection;
  /** Project to which the Agent belongs. */
  readonly project: Project;
  /** Services in the controller. */
  readonly services: ServiceConnection;
  /** Current status of the Controller. */
  readonly status: Scalars['String']['output'];
  /** Version of the Controller. */
  readonly version: Scalars['String']['output'];
};


/** Controller represents single Controller instance. */
export type ControllerAgentsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<AgentSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<AgentOrderBy>>>;
  where: InputMaybe<AgentBoolExp>;
};


/** Controller represents single Controller instance. */
export type ControllerPoliciesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<PolicySelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<PolicyOrderBy>>>;
  where: InputMaybe<PolicyBoolExp>;
};


/** Controller represents single Controller instance. */
export type ControllerServicesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<ServiceSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<ServiceOrderBy>>>;
  where: InputMaybe<ServiceBoolExp>;
};

/** order by aggregate values of Controller */
export type ControllerAggregateOrderBy = {
  readonly count: InputMaybe<OrderBy>;
  readonly max: InputMaybe<ControllerMaxOrderBy>;
  readonly min: InputMaybe<ControllerMinOrderBy>;
};

/** Boolean expression to filter rows from the table "Controller". */
export type ControllerBoolExp = {
  /** Controller agent key predicate. */
  readonly agentKey: InputMaybe<AgentKeyBoolExp>;
  /** Controller agent key id predicate. */
  readonly agentKeyID: InputMaybe<IdComparisonExp>;
  /** Logical and. */
  readonly and: InputMaybe<ReadonlyArray<ControllerBoolExp>>;
  /** Controller Commit Hash predicate. */
  readonly commitSha: InputMaybe<StringComparisonExp>;
  /** Controller health details predicate. */
  readonly healthDetails: InputMaybe<StringComparisonExp>;
  /** Controller id predicate. */
  readonly id: InputMaybe<IdComparisonExp>;
  /** Controller lastSeen timestamp predicate. */
  readonly lastSeen: InputMaybe<TimeComparisonExp>;
  /** Controller name predicate. */
  readonly name: InputMaybe<StringComparisonExp>;
  /** Logical not. */
  readonly not: InputMaybe<ControllerBoolExp>;
  /** Logical or. */
  readonly or: InputMaybe<ReadonlyArray<ControllerBoolExp>>;
  /** Controller policies predicate. */
  readonly policies: InputMaybe<PolicyBoolExp>;
  /** Controller project predicate. */
  readonly project: InputMaybe<ProjectBoolExp>;
  /** Controller project id predicate. */
  readonly projectID: InputMaybe<IdComparisonExp>;
  /** Controller services predicate. */
  readonly services: InputMaybe<ServiceBoolExp>;
  /** Controller status predicate. */
  readonly status: InputMaybe<StringComparisonExp>;
  /** Controller version predicate. */
  readonly version: InputMaybe<StringComparisonExp>;
};

/** Look up Controllers */
export type ControllerConnection = {
  /** A list of edges. */
  readonly edges: ReadonlyArray<ControllerEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ControllerEdge = {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node: Controller;
};

/** order by max() on columns of Controller */
export type ControllerMaxOrderBy = {
  readonly agentKeyID: InputMaybe<OrderBy>;
  readonly commitSha: InputMaybe<OrderBy>;
  readonly healthDetails: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly lastSeen: InputMaybe<OrderBy>;
  readonly name: InputMaybe<OrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly status: InputMaybe<OrderBy>;
  readonly version: InputMaybe<OrderBy>;
};

/** order by min() on columns of Controller */
export type ControllerMinOrderBy = {
  readonly agentKeyID: InputMaybe<OrderBy>;
  readonly commitSha: InputMaybe<OrderBy>;
  readonly healthDetails: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly lastSeen: InputMaybe<OrderBy>;
  readonly name: InputMaybe<OrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly status: InputMaybe<OrderBy>;
  readonly version: InputMaybe<OrderBy>;
};

/** Ordering options when querying Controllers. */
export type ControllerOrderBy = {
  readonly agentKey: InputMaybe<AgentKeyOrderBy>;
  readonly agentKeyID: InputMaybe<OrderBy>;
  readonly agentsAggregate: InputMaybe<AgentAggregateOrderBy>;
  readonly commitSha: InputMaybe<OrderBy>;
  readonly healthDetails: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly lastSeen: InputMaybe<OrderBy>;
  readonly name: InputMaybe<OrderBy>;
  readonly policiesAggregate: InputMaybe<PolicyAggregateOrderBy>;
  readonly project: InputMaybe<ProjectOrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly servicesAggregate: InputMaybe<ServiceAggregateOrderBy>;
  readonly status: InputMaybe<OrderBy>;
  readonly version: InputMaybe<OrderBy>;
};

/** Select columns of Controllers. */
export enum ControllerSelectColumn {
  /** Column name. */
  AgentKeyId = 'agentKeyID',
  /** Column name. */
  CommitSha = 'commitSha',
  /** Column name. */
  HealthDetails = 'healthDetails',
  /** Column name. */
  Id = 'id',
  /** Column name. */
  LastSeen = 'lastSeen',
  /** Column name. */
  Name = 'name',
  /** Column name. */
  ProjectId = 'projectID',
  /** Column name. */
  Status = 'status',
  /** Column name. */
  Version = 'version'
}

/** Input type of CreateAlertsChannel */
export type CreateAlertsChannelInput = {
  /** Alerts organization config to which alerts channel belongs. */
  readonly alertsOrganizationConfig: Scalars['ID']['input'];
  /** Name of the alerts channel. */
  readonly name: Scalars['String']['input'];
  /** Project to which the alerts channel belongs. */
  readonly project: Scalars['ID']['input'];
};

/** Return type of CreateAlertsChannel */
export type CreateAlertsChannelPayload = {
  /** The new alerts channel. */
  readonly alertsChannel: Maybe<AlertsChannel>;
};

/** Input type of CreateAlertsEmailNotifier */
export type CreateAlertsEmailNotifierInput = {
  /** Alerts channel to which the alerts email notifier belongs. */
  readonly alertsChannel: Scalars['ID']['input'];
  /** The email address to send notifications to. */
  readonly email: Scalars['String']['input'];
  /** Project to which the alerts email notifier belongs. */
  readonly project: Scalars['ID']['input'];
  /** Whether to notify about resolved alerts. */
  readonly sendResolved: Scalars['Boolean']['input'];
};

/** Return type of CreateAlertsEmailNotifier */
export type CreateAlertsEmailNotifierPayload = {
  /** The new alerts email notifier. */
  readonly alertsEmailNotifier: Maybe<AlertsEmailNotifier>;
};

/** Input type of createAlertsOrganizationConfig */
export type CreateAlertsOrganizationConfigInput = {
  /** The new alerts organization config. */
  readonly config: Scalars['String']['input'];
  /** Organization id to which the alerts organization config belongs. */
  readonly organization: Scalars['ID']['input'];
};

/** Return type of createAlertsOrganizationConfig */
export type CreateAlertsOrganizationConfigPayload = {
  /** The createed alerts organization config. */
  readonly alertsOrganizationConfig: Maybe<AlertsOrganizationConfig>;
};

/** Input type of CreateAlertsSlackNotifier */
export type CreateAlertsSlackNotifierInput = {
  /** Alerts channel to which the alerts slack notifier belongs. */
  readonly alertsChannel: Scalars['ID']['input'];
  /** The slack channel or user to send notifications to. */
  readonly channel: Scalars['String']['input'];
  /** Project to which the alerts slack notifier belongs. */
  readonly project: Scalars['ID']['input'];
  /** Whether to notify about resolved alerts. */
  readonly sendResolved: Scalars['Boolean']['input'];
  /** Slack webhook URL. */
  readonly url: Scalars['String']['input'];
};

/** Return type of CreateAlertsSlackNotifier */
export type CreateAlertsSlackNotifierPayload = {
  /** The new alerts slack notifier. */
  readonly alertsSlackNotifier: Maybe<AlertsSlackNotifier>;
};

/** Input type of CreateAlertsWebhookNotifier */
export type CreateAlertsWebhookNotifierInput = {
  /** Alerts channel to which the alerts webhook notifier belongs. */
  readonly alertsChannel: Scalars['ID']['input'];
  /** Project to which the alerts webhook notifier belongs. */
  readonly project: Scalars['ID']['input'];
  /** Whether to notify about resolved alerts. */
  readonly sendResolved: Scalars['Boolean']['input'];
  /** The URL to send HTTP POST requests to. */
  readonly url: Scalars['String']['input'];
};

/** Return type of CreateAlertsWebhookNotifier */
export type CreateAlertsWebhookNotifierPayload = {
  /** The new alerts webhook notifier. */
  readonly alertsWebhookNotifier: Maybe<AlertsWebhookNotifier>;
};

/** Input type of CreateApertureSecret */
export type CreateApertureSecretInput = {
  /** Name of the aperture secret. */
  readonly name: Scalars['String']['input'];
  /** The ID of the project the secret belongs to. */
  readonly project: Scalars['ID']['input'];
  /** Value of the secret. */
  readonly value: Scalars['String']['input'];
};

/** Return type of CreateApertureSecret */
export type CreateApertureSecretPayload = {
  /** The new Aperture secret. */
  readonly apertureSecret: Maybe<ApertureSecret>;
};

/** Input type of CreateBlueprintPolicyDefinition */
export type CreateBlueprintPolicyDefinitionInput = {
  /** Name of the used blueprint. */
  readonly blueprintName: Scalars['String']['input'];
  /** Version of the used blueprint. */
  readonly blueprintVersion: Scalars['String']['input'];
  /** Name of the blueprint policy definition and the created policy. */
  readonly name: Scalars['String']['input'];
  /** Project to which the blueprint policy definition belongs. */
  readonly project: Scalars['ID']['input'];
  /** Values set in the blueprint as json. */
  readonly values: Scalars['Map']['input'];
};

/** Return type of CreateBlueprintPolicyDefinition */
export type CreateBlueprintPolicyDefinitionPayload = {
  /** The new blueprintPolicyDefinition. */
  readonly blueprintPolicyDefinition: Maybe<BlueprintPolicyDefinition>;
};

/** Input type of CreateCustomPolicyDefinition */
export type CreateCustomPolicyDefinitionInput = {
  /** Body of the defined policy. */
  readonly body: Scalars['Map']['input'];
  /** Name of the custom policy definition and the created policy. */
  readonly name: Scalars['String']['input'];
  /** Project to which the custom policy definition belongs. */
  readonly project: Scalars['ID']['input'];
};

/** Return type of CreateCustomPolicyDefinition */
export type CreateCustomPolicyDefinitionPayload = {
  /** The new customPolicyDefinition. */
  readonly customPolicyDefinition: Maybe<CustomPolicyDefinition>;
};

/** Input type of CreateOrganization */
export type CreateOrganizationInput = {
  /** The default role for users added to the organization. */
  readonly defaultRole: Scalars['String']['input'];
  /** The domain name of organization. */
  readonly domainName: Scalars['String']['input'];
  /** IdpTenantID of the organization. */
  readonly idpTenantID: InputMaybe<Scalars['ID']['input']>;
  /** The name of organization. */
  readonly name: Scalars['String']['input'];
  /** URL of the organization's picture. */
  readonly pictureURL: InputMaybe<Scalars['String']['input']>;
};

/** Input type of CreateOrganizationMembership */
export type CreateOrganizationMembershipInput = {
  /** ID of the organization to which the user belongs. */
  readonly organization: Scalars['ID']['input'];
  /** Password hash of the user in the organization. */
  readonly password: Scalars['String']['input'];
  /** Role of the user in the organization. */
  readonly role: InputMaybe<Scalars['String']['input']>;
  /** Status of the membership. Can be active or inactive. */
  readonly status: Scalars['String']['input'];
  /** ID of the user who is the member. */
  readonly user: Scalars['ID']['input'];
};

/** Return type of CreateOrganizationMembership */
export type CreateOrganizationMembershipPayload = {
  /** The new organizationMembership. */
  readonly organizationMembership: Maybe<OrganizationMembership>;
};

/** Return type of CreateOrganization */
export type CreateOrganizationPayload = {
  /** The new organization. */
  readonly organization: Maybe<Organization>;
};

/** Input type of CreateProject */
export type CreateProjectInput = {
  /** The cloud provider of the project. */
  readonly cloud_provider: InputMaybe<Scalars['String']['input']>;
  /** The description of project. */
  readonly description: Scalars['String']['input'];
  /** The name of project. */
  readonly name: Scalars['String']['input'];
  /** Organization to which the project belongs. */
  readonly organization: Scalars['ID']['input'];
  /** Region to which the project belongs. */
  readonly region: InputMaybe<Scalars['String']['input']>;
  /** UserGroup that will be initially assigned to the project. */
  readonly userGroup: InputMaybe<Scalars['ID']['input']>;
};

/** Return type of CreateProject */
export type CreateProjectPayload = {
  /** The new project. */
  readonly project: Maybe<Project>;
  /** ID of started temporal workflow. */
  readonly workflowID: Scalars['String']['output'];
};

/** Input type of CreateSubscription */
export type CreateSubscriptionInput = {
  /** Organization ID of the subscription. */
  readonly organizationID: Scalars['String']['input'];
  /** Project ID of the subscription. */
  readonly projectID: Scalars['String']['input'];
  /** Status of the subscription. */
  readonly status: Scalars['String']['input'];
  /** ChargeBee subscription id. */
  readonly subscriptionID: InputMaybe<Scalars['String']['input']>;
};

/** Return type of CreateSubscription */
export type CreateSubscriptionPayload = {
  /** The new subscription. */
  readonly subscription: Maybe<Subscription>;
};

/** Input type of CreateUserGroup */
export type CreateUserGroupInput = {
  /** The name of user group. */
  readonly name: Scalars['String']['input'];
  /** Organization to which the user group belongs. */
  readonly organization: Scalars['ID']['input'];
};

/** Input type of CreateUserGroupMembership */
export type CreateUserGroupMembershipInput = {
  /** ID of the user who is the member. */
  readonly user: Scalars['ID']['input'];
  /** ID of the user group to which the user belongs. */
  readonly userGroup: Scalars['ID']['input'];
};

/** Return type of CreateUserGroupMembership */
export type CreateUserGroupMembershipPayload = {
  /** The new user group membership. */
  readonly userGroupMembership: Maybe<UserGroupMembership>;
};

/** Return type of CreateUserGroup */
export type CreateUserGroupPayload = {
  /** The new user group. */
  readonly userGroup: Maybe<UserGroup>;
};

/** Input type of CreateUserGroupProjectAssignment */
export type CreateUserGroupProjectAssignmentInput = {
  /**
   * Permissions for the user group in the project. May be "read" or "write".
   * If not provided defaults to "read".
   */
  readonly permissions: InputMaybe<Scalars['String']['input']>;
  /** ID of the project to which the userGroup is assigned. */
  readonly project: Scalars['ID']['input'];
  /** ID of the userGroup that is assigned to the project. */
  readonly userGroup: Scalars['ID']['input'];
};

/** Return type of CreateUserGroupProjectAssignment */
export type CreateUserGroupProjectAssignmentPayload = {
  /** The new UserGroupProjectAssignment. */
  readonly userGroupProjectAssignment: Maybe<UserGroupProjectAssignment>;
};

/** Input type of CreateUser */
export type CreateUserInput = {
  /** Email of the user. */
  readonly email: Scalars['String']['input'];
  /** ID of the user in idp. */
  readonly idpUserID: InputMaybe<Scalars['ID']['input']>;
  /** Name of the user. */
  readonly name: Scalars['String']['input'];
  /** URL of the user's picture. */
  readonly pictureURL: InputMaybe<Scalars['String']['input']>;
  /** Preferences of the user. */
  readonly preferences: Scalars['String']['input'];
};

/** Return type of CreateUser */
export type CreateUserPayload = {
  /** The new user. */
  readonly user: Maybe<User>;
};

/** A custom yaml-based policy definition. */
export type CustomPolicyDefinition = Node & {
  /** Body of the defined policy. */
  readonly body: Scalars['Map']['output'];
  /** ID of the user created the definition. */
  readonly createdBy: Maybe<User>;
  /** Time when custom policy definition was edited last time. */
  readonly editedAt: Scalars['Time']['output'];
  /** ID of the custom policy definition. */
  readonly id: Scalars['ID']['output'];
  /** ID of the user last modified the definition. */
  readonly lastModifiedBy: Maybe<User>;
  /** Error message when the status is changed to error. */
  readonly message: Maybe<Scalars['String']['output']>;
  /** Name of the custom policy definition and the created policy. */
  readonly name: Scalars['String']['output'];
  /** Policy created from the definition. */
  readonly policy: Maybe<Policy>;
  /** Project to which the custom policy definition belongs. */
  readonly project: Project;
  /** Status of definition's application */
  readonly status: Scalars['String']['output'];
};

/** order by aggregate values of CustomPolicyDefinition */
export type CustomPolicyDefinitionAggregateOrderBy = {
  readonly count: InputMaybe<OrderBy>;
  readonly max: InputMaybe<CustomPolicyDefinitionMaxOrderBy>;
  readonly min: InputMaybe<CustomPolicyDefinitionMinOrderBy>;
};

/** Boolean expression to filter rows from the table "CustomPolicyDefinition". */
export type CustomPolicyDefinitionBoolExp = {
  /** Logical and. */
  readonly and: InputMaybe<ReadonlyArray<CustomPolicyDefinitionBoolExp>>;
  /** CustomPolicyDefinition body predicate. */
  readonly body: InputMaybe<JsonbComparisonExp>;
  /** CustomPolicyDefinition created by predicate. */
  readonly createdBy: InputMaybe<UserBoolExp>;
  /** CustomPolicyDefinition created by ID predicate. */
  readonly createdByID: InputMaybe<IdComparisonExp>;
  /** CustomPolicyDefinition edited at predicate. */
  readonly editedAt: InputMaybe<TimeComparisonExp>;
  /** CustomPolicyDefinition id predicate. */
  readonly id: InputMaybe<IdComparisonExp>;
  /** CustomPolicyDefinition last modified by predicate. */
  readonly lastModifiedBy: InputMaybe<UserBoolExp>;
  /** CustomPolicyDefinition last modified by ID predicate. */
  readonly lastModifiedByID: InputMaybe<IdComparisonExp>;
  /** CustomPolicyDefinition message predicate. */
  readonly message: InputMaybe<StringComparisonExp>;
  /** CustomPolicyDefinition name predicate. */
  readonly name: InputMaybe<StringComparisonExp>;
  /** Logical not. */
  readonly not: InputMaybe<CustomPolicyDefinitionBoolExp>;
  /** Logical or. */
  readonly or: InputMaybe<ReadonlyArray<CustomPolicyDefinitionBoolExp>>;
  /** CustomPolicyDefinition policy predicate. */
  readonly policy: InputMaybe<PolicyBoolExp>;
  /** CustomPolicyDefinition policy id predicate. */
  readonly policyID: InputMaybe<IdComparisonExp>;
  /** CustomPolicyDefinition project predicate. */
  readonly project: InputMaybe<ProjectBoolExp>;
  /** CustomPolicyDefinition project id predicate. */
  readonly projectID: InputMaybe<IdComparisonExp>;
};

/** Look up CustomPolicyDefinitions. */
export type CustomPolicyDefinitionConnection = {
  /** A list of edges. */
  readonly edges: ReadonlyArray<CustomPolicyDefinitionEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomPolicyDefinitionEdge = {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node: CustomPolicyDefinition;
};

/** order by max() on columns of CustomPolicyDefinition */
export type CustomPolicyDefinitionMaxOrderBy = {
  readonly body: InputMaybe<OrderBy>;
  readonly createdBy: InputMaybe<UserOrderBy>;
  readonly editedAt: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly lastModifiedBy: InputMaybe<UserOrderBy>;
  readonly message: InputMaybe<OrderBy>;
  readonly name: InputMaybe<OrderBy>;
  readonly policy: InputMaybe<PolicyOrderBy>;
  readonly project: InputMaybe<ProjectOrderBy>;
};

/** order by min() on columns of CustomPolicyDefinition */
export type CustomPolicyDefinitionMinOrderBy = {
  readonly body: InputMaybe<OrderBy>;
  readonly createdBy: InputMaybe<UserOrderBy>;
  readonly editedAt: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly lastModifiedBy: InputMaybe<UserOrderBy>;
  readonly message: InputMaybe<OrderBy>;
  readonly name: InputMaybe<OrderBy>;
  readonly policy: InputMaybe<PolicyOrderBy>;
  readonly project: InputMaybe<ProjectOrderBy>;
};

/** Ordering options when querying CustomPolicyDefinitions. */
export type CustomPolicyDefinitionOrderBy = {
  readonly body: InputMaybe<OrderBy>;
  readonly editedAt: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly message: InputMaybe<OrderBy>;
  readonly name: InputMaybe<OrderBy>;
  readonly policy: InputMaybe<PolicyOrderBy>;
  readonly project: InputMaybe<ProjectOrderBy>;
};

/** Select columns of CustomPolicyDefinition. */
export enum CustomPolicyDefinitionSelectColumn {
  /** Column name. */
  Body = 'body',
  /** Column name. */
  CreatedById = 'createdByID',
  /** Column name. */
  Id = 'id',
  /** Column name. */
  LastModifiedById = 'lastModifiedByID',
  /** Column name. */
  Message = 'message',
  /** Column name. */
  Name = 'name',
  /** Column name. */
  PolicyId = 'policyID',
  /** Column name. */
  ProjectId = 'projectID'
}

/** Input type of DeleteAlertsChannel */
export type DeleteAlertsChannelInput = {
  /** The id of the alerts channel to delete. */
  readonly id: Scalars['ID']['input'];
};

/** Return type of DeleteAlertsChannel */
export type DeleteAlertsChannelPayload = {
  /** The deleted alerts channel. */
  readonly alertsChannel: Maybe<AlertsChannel>;
};

/** Input type of DeleteAlertsEmailNotifier */
export type DeleteAlertsEmailNotifierInput = {
  /** The id of the alerts email notifier to delete. */
  readonly id: Scalars['ID']['input'];
};

/** Return type of DeleteAlertsEmailNotifier */
export type DeleteAlertsEmailNotifierPayload = {
  /** The deleted alerts email notifier. */
  readonly alertsEmailNotifier: Maybe<AlertsEmailNotifier>;
};

/** Input type of DeleteAlertsSlackNotifier */
export type DeleteAlertsSlackNotifierInput = {
  /** The id of the alerts slack notifier to delete. */
  readonly id: Scalars['ID']['input'];
};

/** Return type of DeleteAlertsSlackNotifier */
export type DeleteAlertsSlackNotifierPayload = {
  /** The deleted alerts slack notifier. */
  readonly alertsSlackNotifier: Maybe<AlertsSlackNotifier>;
};

/** Input type of DeleteAlertsWebhookNotifier */
export type DeleteAlertsWebhookNotifierInput = {
  /** The id of the alerts webhook notifier to delete. */
  readonly id: Scalars['ID']['input'];
};

/** Return type of DeleteAlertsWebhookNotifier */
export type DeleteAlertsWebhookNotifierPayload = {
  /** The deleted alerts webhook notifier. */
  readonly alertsWebhookNotifier: Maybe<AlertsWebhookNotifier>;
};

/** Input type of DeleteApertureSecret */
export type DeleteApertureSecretInput = {
  /** The id of the Aperture Secret to revoke. */
  readonly id: Scalars['ID']['input'];
};

/** Return type of DeleteApertureSecret */
export type DeleteApertureSecretPayload = {
  /** The revoked Aperture Secret. */
  readonly apertureSecret: Maybe<ApertureSecret>;
};

/** Input type of DeleteBlueprintPolicyDefinition */
export type DeleteBlueprintPolicyDefinitionInput = {
  /** The id of the blueprintPolicyDefinition to delete. */
  readonly id: Scalars['ID']['input'];
};

/** Return type of DeleteBlueprintPolicyDefinition */
export type DeleteBlueprintPolicyDefinitionPayload = {
  /** The deleted blueprintPolicyDefinition. */
  readonly blueprintPolicyDefinition: Maybe<BlueprintPolicyDefinition>;
};

/** Input type of DeleteCustomPolicyDefinition */
export type DeleteCustomPolicyDefinitionInput = {
  /** The id of the customPolicyDefinition to delete. */
  readonly id: Scalars['ID']['input'];
};

/** Return type of DeleteCustomPolicyDefinition */
export type DeleteCustomPolicyDefinitionPayload = {
  /** The deleted customPolicyDefinition. */
  readonly customPolicyDefinition: Maybe<CustomPolicyDefinition>;
};

/** Input type of DeleteOrganization */
export type DeleteOrganizationInput = {
  /** The id of the organization to delete. */
  readonly id: Scalars['ID']['input'];
};

/** Input type of DeleteOrganizationMembership */
export type DeleteOrganizationMembershipInput = {
  /** ID of the membership. */
  readonly id: Scalars['ID']['input'];
};

/** Return type of DeleteOrganizationMembership */
export type DeleteOrganizationMembershipPayload = {
  /** The deleted organizationMembership. */
  readonly organizationMembership: Maybe<OrganizationMembership>;
};

/** Return type of DeleteOrganization */
export type DeleteOrganizationPayload = {
  /** The deleted organization. */
  readonly organization: Maybe<Organization>;
};

/** Input type of DeleteProject */
export type DeleteProjectInput = {
  /** The id of the project to delete. */
  readonly id: Scalars['ID']['input'];
};

/** Return type of DeleteProject */
export type DeleteProjectPayload = {
  /** The deleted project. */
  readonly project: Maybe<Project>;
  /** ID of started temporal workflow. */
  readonly workflowID: Scalars['String']['output'];
};

/** Input type of DeleteService */
export type DeleteServiceInput = {
  /** The id of the service to delete. */
  readonly id: Scalars['ID']['input'];
};

/** Return type of DeleteService */
export type DeleteServicePayload = {
  /** The deleted service. */
  readonly service: Maybe<Service>;
};

/** Input type of DeleteUserGroup */
export type DeleteUserGroupInput = {
  /** The id of the user group to delete. */
  readonly id: Scalars['ID']['input'];
};

/** Input type of DeleteUserGroupMembership */
export type DeleteUserGroupMembershipInput = {
  /** ID of the membership. */
  readonly id: Scalars['ID']['input'];
};

/** Return type of DeleteUserGroupMembership */
export type DeleteUserGroupMembershipPayload = {
  /** The deleted user group membership. */
  readonly userGroupMembership: Maybe<UserGroupMembership>;
};

/** Return type of DeleteUserGroup */
export type DeleteUserGroupPayload = {
  /** The deleted user group. */
  readonly userGroup: Maybe<UserGroup>;
};

/** Input type of DeleteUserGroupProjectAssignment */
export type DeleteUserGroupProjectAssignmentInput = {
  /** ID of the assignment. */
  readonly id: Scalars['ID']['input'];
};

/** Return type of DeleteUserGroupProjectAssignment */
export type DeleteUserGroupProjectAssignmentPayload = {
  /** The deleted UserGroupProjectAssignment. */
  readonly userGroupProjectAssignment: Maybe<UserGroupProjectAssignment>;
};

/** A FluxMeter */
export type FluxMeter = Node & {
  /** Control points assigned to the fluxmeter. */
  readonly controlPointFluxMeterAssignments: ControlPointFluxMeterAssignmentConnection;
  /** ID of the flux meter. */
  readonly id: Scalars['ID']['output'];
  /** Name of the flux meter. */
  readonly name: Scalars['String']['output'];
  /** Policy to which the flux meter belongs. */
  readonly policy: Policy;
  /** Project to which the flux meter belongs. */
  readonly project: Project;
};


/** A FluxMeter */
export type FluxMeterControlPointFluxMeterAssignmentsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<ControlPointFluxMeterAssignmentSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<ControlPointFluxMeterAssignmentOrderBy>>>;
  where: InputMaybe<ControlPointFluxMeterAssignmentBoolExp>;
};

/** order by aggregate values of FluxMeter */
export type FluxMeterAggregateOrderBy = {
  readonly count: InputMaybe<OrderBy>;
  readonly max: InputMaybe<FluxMeterMaxOrderBy>;
  readonly min: InputMaybe<FluxMeterMinOrderBy>;
};

/** Boolean expression to filter rows from the table "FluxMeter". */
export type FluxMeterBoolExp = {
  /** Logical and. */
  readonly and: InputMaybe<ReadonlyArray<FluxMeterBoolExp>>;
  /** FluxMeter assignment to control points predicate. */
  readonly controlPointFluxMeterAssignments: InputMaybe<ControlPointFluxMeterAssignmentBoolExp>;
  /** FluxMeter id predicate. */
  readonly id: InputMaybe<IdComparisonExp>;
  /** FluxMeter name predicate. */
  readonly name: InputMaybe<StringComparisonExp>;
  /** Logical not. */
  readonly not: InputMaybe<FluxMeterBoolExp>;
  /** Logical or. */
  readonly or: InputMaybe<ReadonlyArray<FluxMeterBoolExp>>;
  /** FluxMeter policy predicate. */
  readonly policy: InputMaybe<PolicyBoolExp>;
  /** FluxMeter policy id predicate. */
  readonly policyID: InputMaybe<IdComparisonExp>;
  /** FluxMeter project predicate. */
  readonly project: InputMaybe<ProjectBoolExp>;
  /** FluxMeter project id predicate. */
  readonly projectID: InputMaybe<IdComparisonExp>;
};

/** Look up FluxMeters. */
export type FluxMeterConnection = {
  /** A list of edges. */
  readonly edges: ReadonlyArray<FluxMeterEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FluxMeterEdge = {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node: FluxMeter;
};

/** order by max() on columns of FluxMeter */
export type FluxMeterMaxOrderBy = {
  readonly id: InputMaybe<OrderBy>;
  readonly name: InputMaybe<OrderBy>;
  readonly policy: InputMaybe<PolicyOrderBy>;
  readonly policyID: InputMaybe<OrderBy>;
  readonly project: InputMaybe<ProjectOrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
};

/** order by min() on columns of FluxMeter */
export type FluxMeterMinOrderBy = {
  readonly id: InputMaybe<OrderBy>;
  readonly name: InputMaybe<OrderBy>;
  readonly policy: InputMaybe<PolicyOrderBy>;
  readonly policyID: InputMaybe<OrderBy>;
  readonly project: InputMaybe<ProjectOrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
};

/** Ordering options when querying FluxMeters. */
export type FluxMeterOrderBy = {
  readonly id: InputMaybe<OrderBy>;
  readonly name: InputMaybe<OrderBy>;
  readonly policy: InputMaybe<PolicyOrderBy>;
  readonly policyID: InputMaybe<OrderBy>;
  readonly project: InputMaybe<ProjectOrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
};

/** Select columns of FluxMeters. */
export enum FluxMeterSelectColumn {
  /** Column name. */
  Id = 'id',
  /** Column name. */
  Name = 'name',
  /** Column name. */
  PolicyId = 'policyID',
  /** Column name. */
  ProjectId = 'projectID'
}

/** Input type of GenerateAgentKey */
export type GenerateAgentKeyInput = {
  /** Timestamp at which the Agent Key expires. */
  readonly expiresAt: InputMaybe<Scalars['Time']['input']>;
  /** The ID of the project the key belongs to. */
  readonly project: Scalars['ID']['input'];
};

/** Return type of GenerateAgentKey */
export type GenerateAgentKeyPayload = {
  /** The new Agent Key. */
  readonly agentKey: Maybe<AgentKey>;
  /** ID of the temporal workflow. */
  readonly workflowID: Maybe<Scalars['String']['output']>;
};

/** Return type of GenerateUserAPIKey */
export type GenerateUserApiKeyPayload = {
  /** The new API Key. */
  readonly userAPIKey: Maybe<UserApiKey>;
};

export type Graph = {
  readonly externalComponents: Maybe<ReadonlyArray<Maybe<ComponentView>>>;
  readonly externalLinks: Maybe<ReadonlyArray<Maybe<Link>>>;
  readonly internalComponents: Maybe<ReadonlyArray<Maybe<ComponentView>>>;
  readonly internalLinks: Maybe<ReadonlyArray<Maybe<Link>>>;
};

/**
 * Expression to compare columns of type ID. All fields are combined with logical 'AND'.
 * See https://hasura.io/docs/latest/graphql/core/databases/postgres/queries/query-filters.html#comparison-operators
 * for more detail.
 */
export type IdComparisonExp = {
  /** Equal to operator. */
  readonly eq: InputMaybe<Scalars['ID']['input']>;
  /** Greater than operator. */
  readonly gt: InputMaybe<Scalars['ID']['input']>;
  /** Greater than or equal to operator. */
  readonly gte: InputMaybe<Scalars['ID']['input']>;
  /** In a list operator. */
  readonly in: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** Is null operator. */
  readonly isNull: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than operator. */
  readonly lt: InputMaybe<Scalars['ID']['input']>;
  /** Less than or equal to operator. */
  readonly lte: InputMaybe<Scalars['ID']['input']>;
  /** Not equal to operator. */
  readonly neq: InputMaybe<Scalars['ID']['input']>;
  /** Not in a list operator. */
  readonly nin: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type IntComparisonExp = {
  /** Equal to operator. */
  readonly eq: InputMaybe<Scalars['Int']['input']>;
  /** Greater than operator. */
  readonly gt: InputMaybe<Scalars['Int']['input']>;
  /** Greater than or equal to operator. */
  readonly gte: InputMaybe<Scalars['Int']['input']>;
  /** In a list operator. */
  readonly in: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** Is null operator. */
  readonly isNull: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than operator. */
  readonly lt: InputMaybe<Scalars['Int']['input']>;
  /** Less than or equal to operator. */
  readonly lte: InputMaybe<Scalars['Int']['input']>;
  /** Not equal to operator. */
  readonly neq: InputMaybe<Scalars['Int']['input']>;
  /** Not in a list operator. */
  readonly nin: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
};

/** Boolean expression to compare columns of type "JSONB". All fields are combined with logical 'AND'. */
export type JsonbComparisonExp = {
  /** Is the column contained in the given json value. */
  readonly containedIn: InputMaybe<Scalars['Map']['input']>;
  /** Does the column contain the given json value at the top level. */
  readonly contains: InputMaybe<Scalars['Map']['input']>;
  /** Equal to operator. */
  readonly eq: InputMaybe<Scalars['Map']['input']>;
  /** Greater than operator. */
  readonly gt: InputMaybe<Scalars['Map']['input']>;
  /** Greater than or equal to operator. */
  readonly gte: InputMaybe<Scalars['Map']['input']>;
  /** Does the string exist as a top-level key in the column. */
  readonly hasKey: InputMaybe<Scalars['String']['input']>;
  /** Do all of these strings exist as top-level keys in the column. */
  readonly hasKeysAll: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** Do any of these strings exist as top-level keys in the column. */
  readonly hasKeysAny: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** In a list operator. */
  readonly in: InputMaybe<ReadonlyArray<Scalars['Map']['input']>>;
  /** Is null operator. */
  readonly isNull: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than operator. */
  readonly lt: InputMaybe<Scalars['Map']['input']>;
  /** Less than or equal to operator. */
  readonly lte: InputMaybe<Scalars['Map']['input']>;
  /** Not equal to operator. */
  readonly neq: InputMaybe<Scalars['Map']['input']>;
  /** Not in a list operator. */
  readonly nin: InputMaybe<ReadonlyArray<Scalars['Map']['input']>>;
};

/** A KubernetesControlPoint of the policy. */
export type KubernetesControlPoint = Node & {
  /** Agent to which the kubernetes control point belongs. */
  readonly agent: Agent;
  /** API Version of the kubernetes control point. */
  readonly apiVersion: Scalars['String']['output'];
  /** Controller to which the kubernetes control point belongs. */
  readonly controller: Maybe<Controller>;
  /** UTC timestamp when the kubernetes control point was seen for the first time. */
  readonly discoveredOn: Scalars['Time']['output'];
  /** ID of the kubernetes control point. */
  readonly id: Scalars['ID']['output'];
  /** Kind of the kubernetes control point. */
  readonly kind: Scalars['String']['output'];
  /** Last seen UTC timestamp of when the kubernetes control point was seen for the last time. */
  readonly lastSeen: Scalars['Time']['output'];
  /** Name of the kubernetes control point. */
  readonly name: Scalars['String']['output'];
  /** Namespace of the kubernetes control point. */
  readonly namespace: Scalars['String']['output'];
  /** Project to which the kubernetes control point belongs. */
  readonly project: Project;
  /** Current status of the kubernetes control point. */
  readonly status: Scalars['String']['output'];
};

/** order by aggregate values of KubernetesControlPoint */
export type KubernetesControlPointAggregateOrderBy = {
  readonly count: InputMaybe<OrderBy>;
  readonly max: InputMaybe<KubernetesControlPointMaxOrderBy>;
  readonly min: InputMaybe<KubernetesControlPointMinOrderBy>;
};

/** Boolean expression to filter rows from the table "KubernetesControlPoint". */
export type KubernetesControlPointBoolExp = {
  /** KubernetesControlPoint service predicate. */
  readonly agent: InputMaybe<AgentBoolExp>;
  /** KubernetesControlPoint agent id predicate. */
  readonly agentID: InputMaybe<IdComparisonExp>;
  /** Logical and. */
  readonly and: InputMaybe<ReadonlyArray<KubernetesControlPointBoolExp>>;
  /** KubernetesControlPoint apiVersion predicate. */
  readonly apiVersion: InputMaybe<StringComparisonExp>;
  /** KubernetesControlPoint controller predicate. */
  readonly controller: InputMaybe<ControllerBoolExp>;
  /** KubernetesControlPoint controller id predicate. */
  readonly controllerID: InputMaybe<IdComparisonExp>;
  /** KubernetesControlPoint discoveredOn timestamp predicate. */
  readonly discoveredOn: InputMaybe<TimeComparisonExp>;
  /** KubernetesControlPoint id predicate. */
  readonly id: InputMaybe<IdComparisonExp>;
  /** KubernetesControlPoint kind predicate. */
  readonly kind: InputMaybe<StringComparisonExp>;
  /** KubernetesControlPoint lastSeen timestamp predicate. */
  readonly lastSeen: InputMaybe<TimeComparisonExp>;
  /** KubernetesControlPoint name predicate. */
  readonly name: InputMaybe<StringComparisonExp>;
  /** KubernetesControlPoint namespace predicate. */
  readonly namespace: InputMaybe<StringComparisonExp>;
  /** Logical not. */
  readonly not: InputMaybe<KubernetesControlPointBoolExp>;
  /** Logical or. */
  readonly or: InputMaybe<ReadonlyArray<KubernetesControlPointBoolExp>>;
  /** KubernetesControlPoint project predicate. */
  readonly project: InputMaybe<ProjectBoolExp>;
  /** KubernetesControlPoint project id predicate. */
  readonly projectID: InputMaybe<IdComparisonExp>;
  /** KubernetesControlPoint status predicate. */
  readonly status: InputMaybe<StringComparisonExp>;
};

/** Look up KubernetesControlPoints. */
export type KubernetesControlPointConnection = {
  /** A list of edges. */
  readonly edges: ReadonlyArray<KubernetesControlPointEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type KubernetesControlPointEdge = {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node: KubernetesControlPoint;
};

/** order by max() on columns of KubernetesControlPoint */
export type KubernetesControlPointMaxOrderBy = {
  readonly agent: InputMaybe<AgentOrderBy>;
  readonly agentID: InputMaybe<OrderBy>;
  readonly apiVersion: InputMaybe<OrderBy>;
  readonly controller: InputMaybe<ControllerOrderBy>;
  readonly controllerID: InputMaybe<OrderBy>;
  readonly discoveredOn: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly kind: InputMaybe<OrderBy>;
  readonly lastSeen: InputMaybe<OrderBy>;
  readonly name: InputMaybe<OrderBy>;
  readonly namespace: InputMaybe<OrderBy>;
  readonly project: InputMaybe<ProjectOrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly status: InputMaybe<OrderBy>;
};

/** order by min() on columns of KubernetesControlPoint */
export type KubernetesControlPointMinOrderBy = {
  readonly agent: InputMaybe<AgentOrderBy>;
  readonly agentID: InputMaybe<OrderBy>;
  readonly apiVersion: InputMaybe<OrderBy>;
  readonly controller: InputMaybe<ControllerOrderBy>;
  readonly controllerID: InputMaybe<OrderBy>;
  readonly discoveredOn: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly kind: InputMaybe<OrderBy>;
  readonly lastSeen: InputMaybe<OrderBy>;
  readonly name: InputMaybe<OrderBy>;
  readonly namespace: InputMaybe<OrderBy>;
  readonly project: InputMaybe<ProjectOrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly status: InputMaybe<OrderBy>;
};

/** Ordering options when querying KubernetesControlPoints. */
export type KubernetesControlPointOrderBy = {
  readonly agent: InputMaybe<AgentOrderBy>;
  readonly agentID: InputMaybe<OrderBy>;
  readonly apiVersion: InputMaybe<OrderBy>;
  readonly controller: InputMaybe<ControllerOrderBy>;
  readonly controllerID: InputMaybe<OrderBy>;
  readonly discoveredOn: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly kind: InputMaybe<OrderBy>;
  readonly lastSeen: InputMaybe<OrderBy>;
  readonly name: InputMaybe<OrderBy>;
  readonly namespace: InputMaybe<OrderBy>;
  readonly project: InputMaybe<ProjectOrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly status: InputMaybe<OrderBy>;
};

/** Select columns of KubernetesControlPoints. */
export enum KubernetesControlPointSelectColumn {
  /** Column name. */
  AgentId = 'agentID',
  /** Column name. */
  ApiVersion = 'apiVersion',
  /** Column name. */
  ControllerId = 'controllerID',
  /** Column name. */
  DiscoveredOn = 'discoveredOn',
  /** Column name. */
  Id = 'id',
  /** Column name. */
  Kind = 'kind',
  /** Column name. */
  LastSeen = 'lastSeen',
  /** Column name. */
  Name = 'name',
  /** Column name. */
  Namespace = 'namespace',
  /** Column name. */
  ProjectId = 'projectID',
  /** Column name. */
  Status = 'status'
}

export type Link = {
  readonly looped: Scalars['String']['output'];
  readonly source: Maybe<SourceTarget>;
  readonly subCircuitId: Scalars['String']['output'];
  readonly target: Maybe<SourceTarget>;
  readonly value: Maybe<PortValue>;
};

/** Input type of markProjectAsActive */
export type MarkProjectAsActiveInput = {
  /** The id of the project to mark. */
  readonly id: Scalars['ID']['input'];
};

/** Return type of markProjectAsActive */
export type MarkProjectAsActivePayload = {
  /** The updated project. */
  readonly project: Maybe<Project>;
};

/** The root query for implementing GraphQL mutations. */
export type Mutation = {
  /** Activates an organizationMembership. */
  readonly activateOrganizationMembership: Maybe<ActivateOrganizationMembershipPayload>;
  /** Creates a UserGroupProjectAssignment. */
  readonly addUserGroupToProject: Maybe<CreateUserGroupProjectAssignmentPayload>;
  /** Creates an organizationMembership. */
  readonly addUserToOrganization: Maybe<CreateOrganizationMembershipPayload>;
  /** Creates an user group membership. */
  readonly addUserToUserGroup: Maybe<CreateUserGroupMembershipPayload>;
  /** Updates a blueprintPolicyDefinition and applies policy defined by it. */
  readonly applyBlueprintDefinedPolicy: Maybe<ApplyBlueprintDefinedPolicyPayload>;
  /** Updates a customPolicyDefinition and applies policy defined by it. */
  readonly applyCustomDefinedPolicy: Maybe<ApplyCustomDefinedPolicyPayload>;
  /** Creates an alerts channel. */
  readonly createAlertsChannel: Maybe<CreateAlertsChannelPayload>;
  /** Creates a alerts email notifier. */
  readonly createAlertsEmailNotifier: Maybe<CreateAlertsEmailNotifierPayload>;
  /** Creates an alerts organization config. */
  readonly createAlertsOrganizationConfig: Maybe<CreateAlertsOrganizationConfigPayload>;
  /** Creates a alerts slack notifier. */
  readonly createAlertsSlackNotifier: Maybe<CreateAlertsSlackNotifierPayload>;
  /** Creates a alerts webhook notifier. */
  readonly createAlertsWebhookNotifier: Maybe<CreateAlertsWebhookNotifierPayload>;
  /** Creates a new Aperture Secret. */
  readonly createApertureSecret: Maybe<CreateApertureSecretPayload>;
  /** Creates a draft blueprintPolicyDefinition. */
  readonly createBlueprintPolicyDefinition: Maybe<CreateBlueprintPolicyDefinitionPayload>;
  /** Creates a draft customPolicyDefinition. */
  readonly createCustomPolicyDefinition: Maybe<CreateCustomPolicyDefinitionPayload>;
  /** Creates an organization. */
  readonly createOrganization: Maybe<CreateOrganizationPayload>;
  /** Creates a project. */
  readonly createProject: Maybe<CreateProjectPayload>;
  /** Creates a new Subscription. */
  readonly createSubscription: Maybe<CreateSubscriptionPayload>;
  /** Creates an user. */
  readonly createUser: Maybe<CreateUserPayload>;
  /** Creates a user group. */
  readonly createUserGroup: Maybe<CreateUserGroupPayload>;
  /** Deletes an alerts channel. */
  readonly deleteAlertsChannel: Maybe<DeleteAlertsChannelPayload>;
  /** Deletes a alerts email notifier. */
  readonly deleteAlertsEmailNotifier: Maybe<DeleteAlertsEmailNotifierPayload>;
  /** Deletes a alerts slack notifier. */
  readonly deleteAlertsSlackNotifier: Maybe<DeleteAlertsSlackNotifierPayload>;
  /** Deletes a alerts webhook notifier. */
  readonly deleteAlertsWebhookNotifier: Maybe<DeleteAlertsWebhookNotifierPayload>;
  /** Deletes an aperture secret. */
  readonly deleteApertureSecret: Maybe<DeleteApertureSecretPayload>;
  /** Deletes a blueprintPolicyDefinition. Only possible in 'draft' state. */
  readonly deleteBlueprintPolicyDefinition: Maybe<DeleteBlueprintPolicyDefinitionPayload>;
  /** Deletes a customPolicyDefinition. Only possible in 'draft' state. */
  readonly deleteCustomPolicyDefinition: Maybe<DeleteCustomPolicyDefinitionPayload>;
  /** Deletes an organization. */
  readonly deleteOrganization: Maybe<DeleteOrganizationPayload>;
  /** Deletes a project. */
  readonly deleteProject: Maybe<DeleteProjectPayload>;
  /** Deletes a service. */
  readonly deleteService: Maybe<DeleteServicePayload>;
  /** Deletes a user group. */
  readonly deleteUserGroup: Maybe<DeleteUserGroupPayload>;
  /** Generates a new Agent Key. */
  readonly generateAgentKey: Maybe<GenerateAgentKeyPayload>;
  /** Generates a new User API Key. */
  readonly generateUserAPIKey: Maybe<GenerateUserApiKeyPayload>;
  /** Marks project as active. */
  readonly markProjectAsActive: Maybe<MarkProjectAsActivePayload>;
  /** Onboards an organization. */
  readonly onboardOrganization: Maybe<OnboardOrganizationPayload>;
  /** Pauses the project. */
  readonly pauseProject: Maybe<PauseProjectPayload>;
  /**
   * Populates underlying policy_with_definition table with records from bpd, cpd
   * and policy tables. Should never be exposed to end user, only for system admin usage.
   */
  readonly refreshPoliciesWithDefinition: RefreshPoliciesWithDefinitionPayload;
  /** Deletes a blueprintPolicyDefinition and policy defined by it if previously applied. */
  readonly removeBlueprintDefinedPolicy: Maybe<RemoveBlueprintDefinedPolicyPayload>;
  /** Deletes a customPolicyDefinition and policy defined by it if previously applied. */
  readonly removeCustomDefinedPolicy: Maybe<RemoveCustomDefinedPolicyPayload>;
  /** Deletes an organizationMembership. */
  readonly removeUserFromOrganization: Maybe<DeleteOrganizationMembershipPayload>;
  /** Deletes an user group membership. */
  readonly removeUserFromUserGroup: Maybe<DeleteUserGroupMembershipPayload>;
  /** Deletes a UserGroupProjectAssignment. */
  readonly removeUserGroupFromProject: Maybe<DeleteUserGroupProjectAssignmentPayload>;
  /** Resumes the project. */
  readonly resumeProject: Maybe<ResumeProjectPayload>;
  /** Revokes an agent key. */
  readonly revokeAgentKey: Maybe<RevokeAgentKeyPayload>;
  /** Revokes a User API key. */
  readonly revokeUserAPIKey: Maybe<RevokeUserApiKeyPayload>;
  /** Silences an alerts channel. */
  readonly silenceAlertsChannel: Maybe<SilenceAlertsChannelPayload>;
  /** Unmutes an alerts channel. */
  readonly unmuteAlertsChannel: Maybe<UnmuteAlertsChannelPayload>;
  /** Updates an alerts channel name. */
  readonly updateAlertsChannel: Maybe<UpdateAlertsChannelPayload>;
  /** Updates a alerts email notifier. */
  readonly updateAlertsEmailNotifier: Maybe<UpdateAlertsEmailNotifierPayload>;
  /** Updates an alerts organization config. */
  readonly updateAlertsOrganizationConfig: Maybe<UpdateAlertsOrganizationConfigPayload>;
  /** Updates a alerts slack notifier. */
  readonly updateAlertsSlackNotifier: Maybe<UpdateAlertsSlackNotifierPayload>;
  /** Updates a alerts webhook notifier name. */
  readonly updateAlertsWebhookNotifier: Maybe<UpdateAlertsWebhookNotifierPayload>;
  /** Updates a blueprintPolicyDefinition. Only possible in 'draft' state. */
  readonly updateBlueprintPolicyDefinition: Maybe<UpdateBlueprintPolicyDefinitionPayload>;
  /** Updates policy ID of a blueprintPolicyDefinition. */
  readonly updateBlueprintPolicyDefinitionPolicyID: Maybe<UpdateBlueprintPolicyDefinitionPolicyIdPayload>;
  /** Updates status of a blueprintPolicyDefinition. */
  readonly updateBlueprintPolicyDefinitionStatus: Maybe<UpdateBlueprintPolicyDefinitionStatusPayload>;
  /** Updates a customPolicyDefinition. Only possible in 'draft' state. */
  readonly updateCustomPolicyDefinition: Maybe<UpdateCustomPolicyDefinitionPayload>;
  /** Updates policy ID of a customPolicyDefinition. */
  readonly updateCustomPolicyDefinitionPolicyID: Maybe<UpdateCustomPolicyDefinitionPolicyIdPayload>;
  /** Updates status of a customPolicyDefinition. */
  readonly updateCustomPolicyDefinitionStatus: Maybe<UpdateCustomPolicyDefinitionStatusPayload>;
  /** Updates an organization default role. */
  readonly updateOrganizationDefaultRole: Maybe<UpdateOrganizationDefaultRolePayload>;
  /** Updates an organization name. */
  readonly updateOrganizationName: Maybe<UpdateOrganizationNamePayload>;
  /** Updates an organization picture. */
  readonly updateOrganizationPicture: Maybe<UpdateOrganizationPicturePayload>;
  /** Updates status of a policy. */
  readonly updatePolicyStatus: Maybe<UpdatePolicyStatusPayload>;
  /** Updates a project description. */
  readonly updateProjectDescription: Maybe<UpdateProjectDescriptionPayload>;
  /** Updates a project name. */
  readonly updateProjectName: Maybe<UpdateProjectNamePayload>;
  /** Updates the project region. */
  readonly updateProjectRegion: Maybe<UpdateProjectRegionPayload>;
  /** Updates a Subscription status. */
  readonly updateSubscriptionStatus: Maybe<UpdateSubscriptionStatusPayload>;
  /** Updates a user group name. */
  readonly updateUserGroupName: Maybe<UpdateUserGroupNamePayload>;
  /** Updates permissions in UserGroupProjectAssignment */
  readonly updateUserGroupProjectAssignmentPermissions: Maybe<UpdateUserGroupProjectAssignmentPermissionsPayload>;
  /** Updates a user name. */
  readonly updateUserName: Maybe<UpdateUserNamePayload>;
  /** Updates a user role in organization. */
  readonly updateUserRole: Maybe<UpdateUserRolePayload>;
};


/** The root query for implementing GraphQL mutations. */
export type MutationActivateOrganizationMembershipArgs = {
  input: ActivateOrganizationMembershipInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAddUserGroupToProjectArgs = {
  input: CreateUserGroupProjectAssignmentInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAddUserToOrganizationArgs = {
  input: CreateOrganizationMembershipInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAddUserToUserGroupArgs = {
  input: CreateUserGroupMembershipInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationApplyBlueprintDefinedPolicyArgs = {
  input: ApplyBlueprintDefinedPolicyInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationApplyCustomDefinedPolicyArgs = {
  input: ApplyCustomDefinedPolicyInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateAlertsChannelArgs = {
  input: CreateAlertsChannelInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateAlertsEmailNotifierArgs = {
  input: CreateAlertsEmailNotifierInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateAlertsOrganizationConfigArgs = {
  input: CreateAlertsOrganizationConfigInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateAlertsSlackNotifierArgs = {
  input: CreateAlertsSlackNotifierInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateAlertsWebhookNotifierArgs = {
  input: CreateAlertsWebhookNotifierInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateApertureSecretArgs = {
  input: CreateApertureSecretInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateBlueprintPolicyDefinitionArgs = {
  input: CreateBlueprintPolicyDefinitionInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateCustomPolicyDefinitionArgs = {
  input: CreateCustomPolicyDefinitionInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateProjectArgs = {
  input: CreateProjectInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateSubscriptionArgs = {
  input: CreateSubscriptionInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateUserGroupArgs = {
  input: CreateUserGroupInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteAlertsChannelArgs = {
  input: DeleteAlertsChannelInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteAlertsEmailNotifierArgs = {
  input: DeleteAlertsEmailNotifierInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteAlertsSlackNotifierArgs = {
  input: DeleteAlertsSlackNotifierInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteAlertsWebhookNotifierArgs = {
  input: DeleteAlertsWebhookNotifierInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteApertureSecretArgs = {
  input: DeleteApertureSecretInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteBlueprintPolicyDefinitionArgs = {
  input: DeleteBlueprintPolicyDefinitionInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteCustomPolicyDefinitionArgs = {
  input: DeleteCustomPolicyDefinitionInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteOrganizationArgs = {
  input: DeleteOrganizationInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteProjectArgs = {
  input: DeleteProjectInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteServiceArgs = {
  input: DeleteServiceInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteUserGroupArgs = {
  input: DeleteUserGroupInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationGenerateAgentKeyArgs = {
  input: GenerateAgentKeyInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationMarkProjectAsActiveArgs = {
  input: MarkProjectAsActiveInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationOnboardOrganizationArgs = {
  input: OnboardOrganizationInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationPauseProjectArgs = {
  input: PauseProjectInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRemoveBlueprintDefinedPolicyArgs = {
  input: RemoveBlueprintDefinedPolicyInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRemoveCustomDefinedPolicyArgs = {
  input: RemoveCustomDefinedPolicyInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRemoveUserFromOrganizationArgs = {
  input: DeleteOrganizationMembershipInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRemoveUserFromUserGroupArgs = {
  input: DeleteUserGroupMembershipInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRemoveUserGroupFromProjectArgs = {
  input: DeleteUserGroupProjectAssignmentInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationResumeProjectArgs = {
  input: ResumeProjectInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRevokeAgentKeyArgs = {
  input: RevokeAgentKeyInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRevokeUserApiKeyArgs = {
  input: RevokeUserApiKeyInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationSilenceAlertsChannelArgs = {
  input: SilenceAlertsChannelInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUnmuteAlertsChannelArgs = {
  input: UnmuteAlertsChannelInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateAlertsChannelArgs = {
  input: UpdateAlertsChannelInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateAlertsEmailNotifierArgs = {
  input: UpdateAlertsEmailNotifierInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateAlertsOrganizationConfigArgs = {
  input: UpdateAlertsOrganizationConfigInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateAlertsSlackNotifierArgs = {
  input: UpdateAlertsSlackNotifierInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateAlertsWebhookNotifierArgs = {
  input: UpdateAlertsWebhookNotifierInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateBlueprintPolicyDefinitionArgs = {
  input: UpdateBlueprintPolicyDefinitionInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateBlueprintPolicyDefinitionPolicyIdArgs = {
  input: UpdateBlueprintPolicyDefinitionPolicyIdInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateBlueprintPolicyDefinitionStatusArgs = {
  input: UpdateBlueprintPolicyDefinitionStatusInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateCustomPolicyDefinitionArgs = {
  input: UpdateCustomPolicyDefinitionInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateCustomPolicyDefinitionPolicyIdArgs = {
  input: UpdateCustomPolicyDefinitionPolicyIdInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateCustomPolicyDefinitionStatusArgs = {
  input: UpdateCustomPolicyDefinitionStatusInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateOrganizationDefaultRoleArgs = {
  input: UpdateOrganizationDefaultRoleInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateOrganizationNameArgs = {
  input: UpdateOrganizationNameInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateOrganizationPictureArgs = {
  input: UpdateOrganizationPictureInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdatePolicyStatusArgs = {
  input: UpdatePolicyStatusInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateProjectDescriptionArgs = {
  input: UpdateProjectDescriptionInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateProjectNameArgs = {
  input: UpdateProjectNameInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateProjectRegionArgs = {
  input: UpdateProjectRegionInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateSubscriptionStatusArgs = {
  input: UpdateSubscriptionStatusInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateUserGroupNameArgs = {
  input: UpdateUserGroupNameInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateUserGroupProjectAssignmentPermissionsArgs = {
  input: UpdateUserGroupProjectAssignmentPermissionsInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateUserNameArgs = {
  input: UpdateUserNameInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateUserRoleArgs = {
  input: UpdateUserRoleInput;
};

/** An object with an ID. */
export type Node = {
  /** ID of the object. */
  readonly id: Scalars['ID']['output'];
};

/** Input type of onboardOrganization */
export type OnboardOrganizationInput = {
  /** The id of the organization to update. */
  readonly id: Scalars['ID']['input'];
};

/** Return type of onboardOrganization */
export type OnboardOrganizationPayload = {
  /** The updated organization. */
  readonly organization: Maybe<Organization>;
};

/** column ordering options */
export enum OrderBy {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'ascNullsFirst',
  /** in ascending order, nulls last */
  AscNullsLast = 'ascNullsLast',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'descNullsFirst',
  /** in descending order, nulls last */
  DescNullsLast = 'descNullsLast'
}

/** An organization, a container for the rest of the objects. */
export type Organization = Node & {
  /** Alerts config for this Organization. */
  readonly alertsOrganizationConfig: AlertsOrganizationConfig;
  /** Default role for new users in organization. */
  readonly defaultRole: Scalars['String']['output'];
  /** Domain name of the organization. */
  readonly domainName: Scalars['String']['output'];
  /** ID of the organization. */
  readonly id: Scalars['ID']['output'];
  /** IdpTenantID of the organization. */
  readonly idpTenantID: Maybe<Scalars['String']['output']>;
  /** Name of the organization. */
  readonly name: Scalars['String']['output'];
  /** Flag for onboarding users. */
  readonly onboarded: Scalars['Boolean']['output'];
  /** Organization memberships in the organization. */
  readonly organizationMemberships: OrganizationMembershipConnection;
  /** URL of the organization's picture. */
  readonly pictureURL: Maybe<Scalars['String']['output']>;
  /** Projects in the organization. */
  readonly projects: ProjectConnection;
  /** Usage connected to this Organization. */
  readonly usage: Usage;
  /** User groups in the organization. */
  readonly userGroups: UserGroupConnection;
};


/** An organization, a container for the rest of the objects. */
export type OrganizationOrganizationMembershipsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<OrganizationMembershipSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<OrganizationMembershipOrderBy>>>;
  where: InputMaybe<OrganizationMembershipBoolExp>;
};


/** An organization, a container for the rest of the objects. */
export type OrganizationProjectsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<ProjectSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<ProjectOrderBy>>>;
  where: InputMaybe<ProjectBoolExp>;
};


/** An organization, a container for the rest of the objects. */
export type OrganizationUsageArgs = {
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<UsageOrderBy>>>;
  where: InputMaybe<UsageBoolExp>;
};


/** An organization, a container for the rest of the objects. */
export type OrganizationUserGroupsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<UserGroupSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<UserGroupOrderBy>>>;
  where: InputMaybe<UserGroupBoolExp>;
};

/** Boolean expression to filter rows from the table "organization". */
export type OrganizationBoolExp = {
  /** Alerts config predicate. */
  readonly alertsOrganizationConfig: InputMaybe<AlertsOrganizationConfigBoolExp>;
  /** Logical and. */
  readonly and: InputMaybe<ReadonlyArray<OrganizationBoolExp>>;
  /** Organization default role predicate. */
  readonly defaultRole: InputMaybe<StringComparisonExp>;
  /** Organization domain name predicate. */
  readonly domainName: InputMaybe<StringComparisonExp>;
  /** Organization id predicate. */
  readonly id: InputMaybe<IdComparisonExp>;
  /** Organization idpTenantID predicate. */
  readonly idpTenantID: InputMaybe<StringComparisonExp>;
  /** Organization name predicate. */
  readonly name: InputMaybe<StringComparisonExp>;
  /** Logical not. */
  readonly not: InputMaybe<OrganizationBoolExp>;
  /** Onboarded predicate. */
  readonly onboarded: InputMaybe<BooleanComparisonExp>;
  /** Logical or. */
  readonly or: InputMaybe<ReadonlyArray<OrganizationBoolExp>>;
  /** Organization memberships predicate. */
  readonly organizationMemberships: InputMaybe<OrganizationMembershipBoolExp>;
  /** Projects predicate. */
  readonly projects: InputMaybe<ProjectBoolExp>;
  /** User group predicate. */
  readonly userGroups: InputMaybe<UserGroupBoolExp>;
};

/** Look up Organizations */
export type OrganizationConnection = {
  /** A list of edges. */
  readonly edges: ReadonlyArray<OrganizationEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrganizationEdge = {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node: Organization;
};

/** An organization membership */
export type OrganizationMembership = Node & {
  /** Timestamp when membership was ended in RFC3339 format. */
  readonly end: Maybe<Scalars['String']['output']>;
  /** ID of the membership. */
  readonly id: Scalars['ID']['output'];
  /** Organization to which the user belongs. */
  readonly organization: Organization;
  /** Role of the user in the organization. */
  readonly role: Scalars['String']['output'];
  /** Timestamp when membership was created in RFC3339 format. */
  readonly start: Scalars['String']['output'];
  /** Status of the membership. Can be active or inactive. */
  readonly status: Scalars['String']['output'];
  /** User who is the member. */
  readonly user: User;
};

/** order by aggregate values of OrganizationMembership */
export type OrganizationMembershipAggregateOrderBy = {
  readonly count: InputMaybe<OrderBy>;
  readonly max: InputMaybe<OrganizationMembershipMaxOrderBy>;
  readonly min: InputMaybe<OrganizationMembershipMinOrderBy>;
};

/** Boolean expression to filter rows from the table "organizationMembership". */
export type OrganizationMembershipBoolExp = {
  /** Logical and. */
  readonly and: InputMaybe<ReadonlyArray<OrganizationMembershipBoolExp>>;
  /** Organization membership end predicate. */
  readonly end: InputMaybe<StringComparisonExp>;
  /** Organization membership id predicate. */
  readonly id: InputMaybe<IdComparisonExp>;
  /** Logical not. */
  readonly not: InputMaybe<OrganizationMembershipBoolExp>;
  /** Logical or. */
  readonly or: InputMaybe<ReadonlyArray<OrganizationMembershipBoolExp>>;
  /** Organization membership organization predicate. */
  readonly organization: InputMaybe<OrganizationBoolExp>;
  /** Organization membership organization id predicate. */
  readonly organizationID: InputMaybe<IdComparisonExp>;
  /** Organization membership role predicate. */
  readonly role: InputMaybe<StringComparisonExp>;
  /** Organization membership start predicate. */
  readonly start: InputMaybe<StringComparisonExp>;
  /** Organization membership status predicate. */
  readonly status: InputMaybe<StringComparisonExp>;
  /** Organization membership user predicate. */
  readonly user: InputMaybe<UserBoolExp>;
  /** Organization membership user id predicate. */
  readonly userID: InputMaybe<IdComparisonExp>;
};

/** Look up OrganizationMemberships */
export type OrganizationMembershipConnection = {
  /** A list of edges. */
  readonly edges: ReadonlyArray<OrganizationMembershipEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrganizationMembershipEdge = {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node: OrganizationMembership;
};

/** order by max() on columns of OrganizationMembership */
export type OrganizationMembershipMaxOrderBy = {
  readonly end: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly organizationID: InputMaybe<OrderBy>;
  readonly role: InputMaybe<OrderBy>;
  readonly start: InputMaybe<OrderBy>;
  readonly status: InputMaybe<OrderBy>;
  readonly userID: InputMaybe<OrderBy>;
};

/** order by min() on columns of OrganizationMembership */
export type OrganizationMembershipMinOrderBy = {
  readonly end: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly organizationID: InputMaybe<OrderBy>;
  readonly role: InputMaybe<OrderBy>;
  readonly start: InputMaybe<OrderBy>;
  readonly status: InputMaybe<OrderBy>;
  readonly userID: InputMaybe<OrderBy>;
};

/** Ordering options when querying OrganizationMemberships. */
export type OrganizationMembershipOrderBy = {
  readonly end: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly organization: InputMaybe<OrganizationOrderBy>;
  readonly organizationID: InputMaybe<OrderBy>;
  readonly password: InputMaybe<OrderBy>;
  readonly role: InputMaybe<OrderBy>;
  readonly start: InputMaybe<OrderBy>;
  readonly status: InputMaybe<OrderBy>;
  readonly user: InputMaybe<UserOrderBy>;
  readonly userID: InputMaybe<OrderBy>;
};

/** Select columns of Organization Memberships. */
export enum OrganizationMembershipSelectColumn {
  /** Column name. */
  End = 'end',
  /** Column name. */
  Id = 'id',
  /** Column name. */
  OrganizationId = 'organizationID',
  /** Column name. */
  Password = 'password',
  /** Column name. */
  Role = 'role',
  /** Column name. */
  Start = 'start',
  /** Column name. */
  Status = 'status',
  /** Column name. */
  UserId = 'userID'
}

/** Ordering options when querying Organizations. */
export type OrganizationOrderBy = {
  readonly alertsOrganizationConfigAggregate: InputMaybe<AlertsOrganizationConfigAggregateOrderBy>;
  readonly defaultRole: InputMaybe<OrderBy>;
  readonly domainName: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly idpTenantID: InputMaybe<OrderBy>;
  readonly name: InputMaybe<OrderBy>;
  readonly onboarded: InputMaybe<OrderBy>;
  readonly organizationMembershipsAggregate: InputMaybe<OrganizationMembershipAggregateOrderBy>;
  readonly picture: InputMaybe<OrderBy>;
  readonly projectsAggregate: InputMaybe<ProjectAggregateOrderBy>;
  readonly userGroupsAggregate: InputMaybe<UserGroupAggregateOrderBy>;
};

/** Select columns of Organizations. */
export enum OrganizationSelectColumn {
  /** Column name. */
  DefaultRole = 'defaultRole',
  /** Column name. */
  DomainName = 'domainName',
  /** Column name. */
  Id = 'id',
  /** Column name. */
  IdpTenantId = 'idpTenantID',
  /** Column name. */
  Name = 'name',
  /** Column name. */
  Onboarded = 'onboarded',
  /** Column name. */
  Picture = 'picture'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor: Maybe<Scalars['String']['output']>;
};

/** Input type of pauseProject */
export type PauseProjectInput = {
  /** The id of the project to pause. */
  readonly id: Scalars['ID']['input'];
};

/** Return type of pauseProject */
export type PauseProjectPayload = {
  /** The updated project. */
  readonly project: Maybe<Project>;
  /** ID of started temporal workflow. */
  readonly workflowID: Scalars['String']['output'];
};

/** A Policy */
export type Policy = Node & {
  /** Blueprint policy definitions pointing to this policy */
  readonly blueprintPolicyDefinitions: BlueprintPolicyDefinitionConnection;
  /** Body of policy */
  readonly body: Scalars['Map']['output'];
  /** Compiled representation of the policy circuit in json form */
  readonly circuit: Tree;
  /** Classifiers in the policy. */
  readonly classifiers: ClassifierConnection;
  /** Components of the policy. */
  readonly components: ComponentConnection;
  /** Controller this policy belongs to. */
  readonly controller: Controller;
  /** Custom policy definitions pointing to this policy */
  readonly customPolicyDefinitions: CustomPolicyDefinitionConnection;
  /** Timestamp when policy was ended in RFC3339 format. */
  readonly end: Maybe<Scalars['String']['output']>;
  /** FluxMeters in this policy. */
  readonly fluxMeters: FluxMeterConnection;
  /** Hash of the policy. */
  readonly hash: Scalars['String']['output'];
  /** ID of the policy. */
  readonly id: Scalars['ID']['output'];
  /** Last seen UTC timestamp of the Policy. */
  readonly lastSeen: Scalars['Time']['output'];
  /** Name of the policy. */
  readonly name: Scalars['String']['output'];
  /** Project to which the Policy belongs. */
  readonly project: Project;
  /** Timestamp when policy was created in RFC3339 format. */
  readonly start: Scalars['String']['output'];
  /** Status of the policy. */
  readonly status: Scalars['String']['output'];
};


/** A Policy */
export type PolicyBlueprintPolicyDefinitionsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<BlueprintPolicyDefinitionSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<BlueprintPolicyDefinitionOrderBy>>>;
  where: InputMaybe<BlueprintPolicyDefinitionBoolExp>;
};


/** A Policy */
export type PolicyCircuitArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};


/** A Policy */
export type PolicyClassifiersArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<ClassifierSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<ClassifierOrderBy>>>;
  where: InputMaybe<ClassifierBoolExp>;
};


/** A Policy */
export type PolicyComponentsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<ComponentSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<ComponentOrderBy>>>;
  where: InputMaybe<ComponentBoolExp>;
};


/** A Policy */
export type PolicyCustomPolicyDefinitionsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<CustomPolicyDefinitionSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<CustomPolicyDefinitionOrderBy>>>;
  where: InputMaybe<CustomPolicyDefinitionBoolExp>;
};


/** A Policy */
export type PolicyFluxMetersArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<FluxMeterSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<FluxMeterOrderBy>>>;
  where: InputMaybe<FluxMeterBoolExp>;
};

/** order by aggregate values of Policy */
export type PolicyAggregateOrderBy = {
  readonly count: InputMaybe<OrderBy>;
  readonly max: InputMaybe<PolicyMaxOrderBy>;
  readonly min: InputMaybe<PolicyMinOrderBy>;
};

/** Boolean expression to filter rows from the table "Policy". */
export type PolicyBoolExp = {
  /** Logical and. */
  readonly and: InputMaybe<ReadonlyArray<PolicyBoolExp>>;
  /** Policy blueprint policy definitions predicate. */
  readonly blueprintPolicyDefinitions: InputMaybe<BlueprintPolicyDefinitionBoolExp>;
  /** Policy body predicate. */
  readonly body: InputMaybe<JsonbComparisonExp>;
  /** Policy circuit json predicate. */
  readonly circuit: InputMaybe<JsonbComparisonExp>;
  /** Policy classifiers predicate. */
  readonly classifiers: InputMaybe<ClassifierBoolExp>;
  /** Policy components predicate. */
  readonly components: InputMaybe<ComponentBoolExp>;
  /** Policy controller predicate. */
  readonly controller: InputMaybe<ControllerBoolExp>;
  /** Policy controller id predicate. */
  readonly controllerID: InputMaybe<IdComparisonExp>;
  /** Policy custom policy definitions predicate. */
  readonly customPolicyDefinitions: InputMaybe<CustomPolicyDefinitionBoolExp>;
  /** Policy end predicate. */
  readonly end: InputMaybe<StringComparisonExp>;
  /** Policy fluxmeters predicate. */
  readonly fluxMeters: InputMaybe<FluxMeterBoolExp>;
  /** Policy hash predicate. */
  readonly hash: InputMaybe<StringComparisonExp>;
  /** Policy id predicate. */
  readonly id: InputMaybe<IdComparisonExp>;
  /** Policy lastSeen timestamp predicate. */
  readonly lastSeen: InputMaybe<TimeComparisonExp>;
  /** Policy name predicate. */
  readonly name: InputMaybe<StringComparisonExp>;
  /** Logical not. */
  readonly not: InputMaybe<PolicyBoolExp>;
  /** Logical or. */
  readonly or: InputMaybe<ReadonlyArray<PolicyBoolExp>>;
  /** Policy project predicate. */
  readonly project: InputMaybe<ProjectBoolExp>;
  /** Policy project id predicate. */
  readonly projectID: InputMaybe<IdComparisonExp>;
  /** Policy start predicate. */
  readonly start: InputMaybe<StringComparisonExp>;
  /** Policy status predicate. */
  readonly status: InputMaybe<StringComparisonExp>;
};

/** Look up Policies. */
export type PolicyConnection = {
  /** A list of edges. */
  readonly edges: ReadonlyArray<PolicyEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PolicyEdge = {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node: Policy;
};

/** order by max() on columns of Policy */
export type PolicyMaxOrderBy = {
  readonly body: InputMaybe<OrderBy>;
  readonly circuit: InputMaybe<OrderBy>;
  readonly controller: InputMaybe<ControllerOrderBy>;
  readonly controllerID: InputMaybe<OrderBy>;
  readonly end: InputMaybe<OrderBy>;
  readonly hash: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly lastSeen: InputMaybe<OrderBy>;
  readonly name: InputMaybe<OrderBy>;
  readonly project: InputMaybe<ProjectOrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly start: InputMaybe<OrderBy>;
  readonly status: InputMaybe<OrderBy>;
};

/** order by min() on columns of Policy */
export type PolicyMinOrderBy = {
  readonly body: InputMaybe<OrderBy>;
  readonly circuit: InputMaybe<OrderBy>;
  readonly controller: InputMaybe<ControllerOrderBy>;
  readonly controllerID: InputMaybe<OrderBy>;
  readonly end: InputMaybe<OrderBy>;
  readonly hash: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly lastSeen: InputMaybe<OrderBy>;
  readonly name: InputMaybe<OrderBy>;
  readonly project: InputMaybe<ProjectOrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly start: InputMaybe<OrderBy>;
  readonly status: InputMaybe<OrderBy>;
};

/** Ordering options when querying Policies. */
export type PolicyOrderBy = {
  readonly blueprintPolicyDefinitionsAggregate: InputMaybe<BlueprintPolicyDefinitionAggregateOrderBy>;
  readonly body: InputMaybe<OrderBy>;
  readonly circuit: InputMaybe<OrderBy>;
  readonly classifiersAggregate: InputMaybe<ClassifierAggregateOrderBy>;
  readonly componentsAggregate: InputMaybe<ComponentAggregateOrderBy>;
  readonly controller: InputMaybe<ControllerOrderBy>;
  readonly controllerID: InputMaybe<OrderBy>;
  readonly customPolicyDefinitionsAggregate: InputMaybe<CustomPolicyDefinitionAggregateOrderBy>;
  readonly end: InputMaybe<OrderBy>;
  readonly fluxMetersAggregate: InputMaybe<FluxMeterAggregateOrderBy>;
  readonly hash: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly lastSeen: InputMaybe<OrderBy>;
  readonly name: InputMaybe<OrderBy>;
  readonly project: InputMaybe<ProjectOrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly start: InputMaybe<OrderBy>;
  readonly status: InputMaybe<OrderBy>;
};

/** Select columns of Policies. */
export enum PolicySelectColumn {
  /** Column name. */
  Body = 'body',
  /** Column name. */
  Circuit = 'circuit',
  /** Column name. */
  ControllerId = 'controllerID',
  /** Column name. */
  End = 'end',
  /** Column name. */
  Hash = 'hash',
  /** Column name. */
  Id = 'id',
  /** Column name. */
  LastSeen = 'lastSeen',
  /** Column name. */
  Name = 'name',
  /** Column name. */
  ProjectId = 'projectID',
  /** Column name. */
  Start = 'start',
  /** Column name. */
  Status = 'status'
}

/** A PolicyWithDefinition */
export type PolicyWithDefinition = {
  /** Blueprint policy definition associated with this policy */
  readonly blueprintPolicyDefinition: Maybe<BlueprintPolicyDefinition>;
  /** Custom policy definition associated with this policy */
  readonly customPolicyDefinition: Maybe<CustomPolicyDefinition>;
  /** Name of the policy or definition */
  readonly name: Scalars['String']['output'];
  /** Origin of the policy */
  readonly origin: Scalars['String']['output'];
  /** The policy associated with this definition */
  readonly policy: Maybe<Policy>;
  /** Project to which the policy with definition belongs. */
  readonly project: Project;
  /** Status of the policy or definition */
  readonly status: Scalars['String']['output'];
};

/** A boolean expression for filtering PolicyWithDefinition objects. */
export type PolicyWithDefinitionBoolExp = {
  /** Logical and. */
  readonly and: InputMaybe<ReadonlyArray<PolicyWithDefinitionBoolExp>>;
  /** Policy with definition BlueprintPolicyDefinition predicate. */
  readonly blueprintPolicyDefinition: InputMaybe<BlueprintPolicyDefinitionBoolExp>;
  /** Policy with definition CustomPolicyDefinition predicate. */
  readonly customPolicyDefinition: InputMaybe<CustomPolicyDefinitionBoolExp>;
  /** Policy with definition name predicate. */
  readonly name: InputMaybe<StringComparisonExp>;
  /** Logical not. */
  readonly not: InputMaybe<ReadonlyArray<PolicyWithDefinitionBoolExp>>;
  /** Logical or. */
  readonly or: InputMaybe<ReadonlyArray<PolicyWithDefinitionBoolExp>>;
  /** Policy with definition origin predicate. */
  readonly origin: InputMaybe<StringComparisonExp>;
  /** Policy with definition Policy predicate. */
  readonly policy: InputMaybe<PolicyBoolExp>;
  /** Policy with definition project predicate. */
  readonly project: InputMaybe<ProjectBoolExp>;
  /** Policy with definition project id predicate. */
  readonly projectID: InputMaybe<IdComparisonExp>;
  /** Policy with definition status predicate. */
  readonly status: InputMaybe<StringComparisonExp>;
};

/** A connection to a list of PolicyWithDefinition items. */
export type PolicyWithDefinitionConnection = {
  /** A list of edges. */
  readonly edges: ReadonlyArray<PolicyWithDefinitionEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a PolicyWithDefinitionConnection. */
export type PolicyWithDefinitionEdge = {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node: PolicyWithDefinition;
};

/** Ordering options when querying PolicyWithDefinition. */
export type PolicyWithDefinitionOrderBy = {
  /** Order by status. */
  readonly name: InputMaybe<OrderBy>;
  /** Order by origin. */
  readonly origin: InputMaybe<OrderBy>;
  /** Order by status. */
  readonly status: InputMaybe<OrderBy>;
};

/** Select columns of Policies with definition. */
export enum PolicyWithDefinitionSelectColumn {
  /** Column name. */
  Name = 'name',
  /** Column name. */
  Origin = 'origin',
  /** Column name. */
  Status = 'status'
}

export type PortValue = ConstantValue | SignalName;

export type PortView = {
  readonly looped: Scalars['Boolean']['output'];
  readonly portName: Scalars['String']['output'];
  readonly subCircuitId: Scalars['String']['output'];
  readonly value: Maybe<PortValue>;
};

/** A project. */
export type Project = Node & {
  /** Agent keys in the project. */
  readonly agentKeys: AgentKeyConnection;
  /** Agents in the project. */
  readonly agents: AgentConnection;
  /** Alerts in the project. */
  readonly alerts: AlertConnection;
  readonly alertsChannels: AlertsChannelConnection;
  /** Classifiers in the project. */
  readonly classifiers: ClassifierConnection;
  /** Cloud Provider for Aperture Components in Project. */
  readonly cloud_provider: Scalars['String']['output'];
  /** Components of policies in the project. */
  readonly components: ComponentConnection;
  /** Controllers in the project. */
  readonly controllers: ControllerConnection;
  /** Description of the project. */
  readonly description: Scalars['String']['output'];
  /** FluxMeters in this project. */
  readonly fluxMeters: FluxMeterConnection;
  /** ID of the project. */
  readonly id: Scalars['ID']['output'];
  /** Name of the project. */
  readonly name: Scalars['String']['output'];
  /** Organization to which the project belongs. */
  readonly organization: Organization;
  /** Policies in the project. */
  readonly policies: PolicyConnection;
  /** Region for Aperture Components in Project. */
  readonly region: Scalars['String']['output'];
  /** Services in the project. */
  readonly services: ServiceConnection;
  /** Status of the project. */
  readonly status: Scalars['String']['output'];
  /** User group project assignments in the project. */
  readonly userGroupProjectAssignments: UserGroupProjectAssignmentConnection;
};


/** A project. */
export type ProjectAgentKeysArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<AgentKeySelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<AgentKeyOrderBy>>>;
  where: InputMaybe<AgentKeyBoolExp>;
};


/** A project. */
export type ProjectAgentsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<AgentSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<AgentOrderBy>>>;
  where: InputMaybe<AgentBoolExp>;
};


/** A project. */
export type ProjectAlertsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<AlertSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<AlertOrderBy>>>;
  where: InputMaybe<AlertBoolExp>;
};


/** A project. */
export type ProjectAlertsChannelsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<AlertsChannelSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<AlertsChannelOrderBy>>>;
  where: InputMaybe<AlertsChannelBoolExp>;
};


/** A project. */
export type ProjectClassifiersArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<ClassifierSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<ClassifierOrderBy>>>;
  where: InputMaybe<ClassifierBoolExp>;
};


/** A project. */
export type ProjectComponentsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<ComponentSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<ComponentOrderBy>>>;
  where: InputMaybe<ComponentBoolExp>;
};


/** A project. */
export type ProjectControllersArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<ControllerSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<ControllerOrderBy>>>;
  where: InputMaybe<ControllerBoolExp>;
};


/** A project. */
export type ProjectFluxMetersArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<FluxMeterSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<FluxMeterOrderBy>>>;
  where: InputMaybe<FluxMeterBoolExp>;
};


/** A project. */
export type ProjectPoliciesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<PolicySelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<PolicyOrderBy>>>;
  where: InputMaybe<PolicyBoolExp>;
};


/** A project. */
export type ProjectServicesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<ServiceSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<ServiceOrderBy>>>;
  where: InputMaybe<ServiceBoolExp>;
};


/** A project. */
export type ProjectUserGroupProjectAssignmentsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<UserGroupProjectAssignmentSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<UserGroupProjectAssignmentOrderBy>>>;
  where: InputMaybe<UserGroupProjectAssignmentBoolExp>;
};

/** order by aggregate values of Project */
export type ProjectAggregateOrderBy = {
  readonly count: InputMaybe<OrderBy>;
  readonly max: InputMaybe<ProjectMaxOrderBy>;
  readonly min: InputMaybe<ProjectMinOrderBy>;
};

/** Boolean expression to filter rows from the table "userGroup". */
export type ProjectBoolExp = {
  /** Project agent agent keys predicate. */
  readonly agentKeys: InputMaybe<AgentKeyBoolExp>;
  /** Project agents predicate. */
  readonly agents: InputMaybe<AgentBoolExp>;
  /** Project alerts channels predicate. */
  readonly alertsChannels: InputMaybe<AlertsChannelBoolExp>;
  /** Logical and. */
  readonly and: InputMaybe<ReadonlyArray<ProjectBoolExp>>;
  /** Project classifiers predicate. */
  readonly classifiers: InputMaybe<ClassifierBoolExp>;
  /** Project cloud provider predicate. */
  readonly cloud_provider: InputMaybe<StringComparisonExp>;
  /** Project components predicate. */
  readonly components: InputMaybe<ComponentBoolExp>;
  /** Project controllers predicate. */
  readonly controllers: InputMaybe<ControllerBoolExp>;
  /** Project description predicate. */
  readonly description: InputMaybe<StringComparisonExp>;
  /** Project flux_meters predicate. */
  readonly fluxMeters: InputMaybe<FluxMeterBoolExp>;
  /** Project id predicate. */
  readonly id: InputMaybe<IdComparisonExp>;
  /** Project name predicate. */
  readonly name: InputMaybe<StringComparisonExp>;
  /** Logical not. */
  readonly not: InputMaybe<ProjectBoolExp>;
  /** Logical or. */
  readonly or: InputMaybe<ReadonlyArray<ProjectBoolExp>>;
  /** Project organization predicate. */
  readonly organization: InputMaybe<OrganizationBoolExp>;
  /** Project organization id predicate. */
  readonly organizationID: InputMaybe<IdComparisonExp>;
  /** Project policies predicate. */
  readonly policies: InputMaybe<PolicyBoolExp>;
  /** Project region predicate. */
  readonly region: InputMaybe<StringComparisonExp>;
  /** Project services predicate. */
  readonly services: InputMaybe<ServiceBoolExp>;
  /** Project status predicate. */
  readonly status: InputMaybe<StringComparisonExp>;
  /** Project user group assignments predicate. */
  readonly userGroupProjectAssignments: InputMaybe<UserGroupProjectAssignmentBoolExp>;
};

/** Look up Projects */
export type ProjectConnection = {
  /** A list of edges. */
  readonly edges: ReadonlyArray<ProjectEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProjectEdge = {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node: Project;
};

/** order by max() on columns of Project */
export type ProjectMaxOrderBy = {
  readonly cloud_provider: InputMaybe<OrderBy>;
  readonly description: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly name: InputMaybe<OrderBy>;
  readonly organizationID: InputMaybe<OrderBy>;
  readonly region: InputMaybe<OrderBy>;
  readonly status: InputMaybe<OrderBy>;
};

/** order by min() on columns of Project */
export type ProjectMinOrderBy = {
  readonly cloud_provider: InputMaybe<OrderBy>;
  readonly description: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly name: InputMaybe<OrderBy>;
  readonly organizationID: InputMaybe<OrderBy>;
  readonly region: InputMaybe<OrderBy>;
  readonly status: InputMaybe<OrderBy>;
};

/** Ordering options when querying Projects. */
export type ProjectOrderBy = {
  readonly agentKeysAggregate: InputMaybe<AgentKeyAggregateOrderBy>;
  readonly agentsAggregate: InputMaybe<AgentAggregateOrderBy>;
  readonly alertsAggregate: InputMaybe<AlertAggregateOrderBy>;
  readonly alertsChannelsAggregate: InputMaybe<AlertsChannelAggregateOrderBy>;
  readonly classifiersAggregate: InputMaybe<ClassifierAggregateOrderBy>;
  readonly cloud_provider: InputMaybe<OrderBy>;
  readonly componentsAggregate: InputMaybe<ComponentAggregateOrderBy>;
  readonly controllersAggregate: InputMaybe<ControllerAggregateOrderBy>;
  readonly description: InputMaybe<OrderBy>;
  readonly fluxMetersAggregate: InputMaybe<FluxMeterAggregateOrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly name: InputMaybe<OrderBy>;
  readonly organization: InputMaybe<OrganizationOrderBy>;
  readonly organizationID: InputMaybe<OrderBy>;
  readonly policiesAggregate: InputMaybe<PolicyAggregateOrderBy>;
  readonly region: InputMaybe<OrderBy>;
  readonly servicesAggregate: InputMaybe<ServiceAggregateOrderBy>;
  readonly status: InputMaybe<OrderBy>;
  readonly userGroupProjectAssignmentsAggregate: InputMaybe<UserGroupProjectAssignmentAggregateOrderBy>;
};

/** Select columns of Projects. */
export enum ProjectSelectColumn {
  /** Column name. */
  CloudProvider = 'cloud_provider',
  /** Column name. */
  Description = 'description',
  /** Column name. */
  Id = 'id',
  /** Column name. */
  Name = 'name',
  /** Column name. */
  OrganizationId = 'organizationID',
  /** Column name. */
  Region = 'region',
  /** Column name. */
  Status = 'status'
}

/** The query root of FluxNinja's GraphQL interface. */
export type Query = {
  readonly agentKeys: AgentKeyConnection;
  readonly agents: AgentConnection;
  readonly alerts: AlertConnection;
  readonly alertsChannelAssignments: AlertsChannelAssignmentConnection;
  readonly alertsChannels: AlertsChannelConnection;
  readonly alertsEmailNotifiers: AlertsEmailNotifierConnection;
  readonly alertsOrganizationConfigs: AlertsOrganizationConfigConnection;
  readonly alertsSlackNotifiers: AlertsSlackNotifierConnection;
  readonly alertsWebhookNotifiers: AlertsWebhookNotifierConnection;
  readonly apertureSecrets: ApertureSecretConnection;
  readonly blueprintPolicyDefinitions: BlueprintPolicyDefinitionConnection;
  readonly classifiers: ClassifierConnection;
  readonly components: ComponentConnection;
  readonly controlPointClassifierAssignments: ControlPointClassifierAssignmentConnection;
  readonly controlPointComponentAssignments: ControlPointComponentAssignmentConnection;
  readonly controlPointFluxMeterAssignments: ControlPointFluxMeterAssignmentConnection;
  readonly controlPoints: ControlPointConnection;
  readonly controllers: ControllerConnection;
  readonly customPolicyDefinitions: CustomPolicyDefinitionConnection;
  readonly fluxMeters: FluxMeterConnection;
  readonly kubernetesControlPoints: KubernetesControlPointConnection;
  readonly organizationMemberships: OrganizationMembershipConnection;
  readonly organizations: OrganizationConnection;
  readonly policies: PolicyConnection;
  readonly policiesWithDefinition: PolicyWithDefinitionConnection;
  readonly projects: ProjectConnection;
  readonly services: ServiceConnection;
  readonly subscriptions: SubscriptionConnection;
  readonly userAPIKeys: UserApiKeyConnection;
  readonly userGroupMemberships: UserGroupMembershipConnection;
  readonly userGroupProjectAssignments: UserGroupProjectAssignmentConnection;
  readonly userGroups: UserGroupConnection;
  readonly users: UserConnection;
};


/** The query root of FluxNinja's GraphQL interface. */
export type QueryAgentKeysArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<AgentKeySelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<AgentKeyOrderBy>>>;
  where: InputMaybe<AgentKeyBoolExp>;
};


/** The query root of FluxNinja's GraphQL interface. */
export type QueryAgentsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<AgentSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<AgentOrderBy>>>;
  where: InputMaybe<AgentBoolExp>;
};


/** The query root of FluxNinja's GraphQL interface. */
export type QueryAlertsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<AlertSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<AlertOrderBy>>>;
  where: InputMaybe<AlertBoolExp>;
};


/** The query root of FluxNinja's GraphQL interface. */
export type QueryAlertsChannelAssignmentsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<AlertsChannelAssignmentSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<AlertsChannelAssignmentOrderBy>>>;
  where: InputMaybe<AlertsChannelAssignmentBoolExp>;
};


/** The query root of FluxNinja's GraphQL interface. */
export type QueryAlertsChannelsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<AlertsChannelSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<AlertsChannelOrderBy>>>;
  where: InputMaybe<AlertsChannelBoolExp>;
};


/** The query root of FluxNinja's GraphQL interface. */
export type QueryAlertsEmailNotifiersArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<AlertsEmailNotifierSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<AlertsEmailNotifierOrderBy>>>;
  where: InputMaybe<AlertsEmailNotifierBoolExp>;
};


/** The query root of FluxNinja's GraphQL interface. */
export type QueryAlertsOrganizationConfigsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<AlertsOrganizationConfigSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<AlertsOrganizationConfigOrderBy>>>;
  where: InputMaybe<AlertsOrganizationConfigBoolExp>;
};


/** The query root of FluxNinja's GraphQL interface. */
export type QueryAlertsSlackNotifiersArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<AlertsSlackNotifierSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<AlertsSlackNotifierOrderBy>>>;
  where: InputMaybe<AlertsSlackNotifierBoolExp>;
};


/** The query root of FluxNinja's GraphQL interface. */
export type QueryAlertsWebhookNotifiersArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<AlertsWebhookNotifierSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<AlertsWebhookNotifierOrderBy>>>;
  where: InputMaybe<AlertsWebhookNotifierBoolExp>;
};


/** The query root of FluxNinja's GraphQL interface. */
export type QueryApertureSecretsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<ApertureSecretSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<ApertureSecretOrderBy>>>;
  where: InputMaybe<ApertureSecretBoolExp>;
};


/** The query root of FluxNinja's GraphQL interface. */
export type QueryBlueprintPolicyDefinitionsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<BlueprintPolicyDefinitionSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<BlueprintPolicyDefinitionOrderBy>>>;
  where: InputMaybe<BlueprintPolicyDefinitionBoolExp>;
};


/** The query root of FluxNinja's GraphQL interface. */
export type QueryClassifiersArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<ClassifierSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<ClassifierOrderBy>>>;
  where: InputMaybe<ClassifierBoolExp>;
};


/** The query root of FluxNinja's GraphQL interface. */
export type QueryComponentsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<ComponentSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<ComponentOrderBy>>>;
  where: InputMaybe<ComponentBoolExp>;
};


/** The query root of FluxNinja's GraphQL interface. */
export type QueryControlPointClassifierAssignmentsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<ControlPointClassifierAssignmentSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<ControlPointClassifierAssignmentOrderBy>>>;
  where: InputMaybe<ControlPointClassifierAssignmentBoolExp>;
};


/** The query root of FluxNinja's GraphQL interface. */
export type QueryControlPointComponentAssignmentsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<ControlPointComponentAssignmentSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<ControlPointComponentAssignmentOrderBy>>>;
  where: InputMaybe<ControlPointComponentAssignmentBoolExp>;
};


/** The query root of FluxNinja's GraphQL interface. */
export type QueryControlPointFluxMeterAssignmentsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<ControlPointFluxMeterAssignmentSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<ControlPointFluxMeterAssignmentOrderBy>>>;
  where: InputMaybe<ControlPointFluxMeterAssignmentBoolExp>;
};


/** The query root of FluxNinja's GraphQL interface. */
export type QueryControlPointsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<ControlPointSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<ControlPointOrderBy>>>;
  where: InputMaybe<ControlPointBoolExp>;
};


/** The query root of FluxNinja's GraphQL interface. */
export type QueryControllersArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<ControllerSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<ControllerOrderBy>>>;
  where: InputMaybe<ControllerBoolExp>;
};


/** The query root of FluxNinja's GraphQL interface. */
export type QueryCustomPolicyDefinitionsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<CustomPolicyDefinitionSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<CustomPolicyDefinitionOrderBy>>>;
  where: InputMaybe<CustomPolicyDefinitionBoolExp>;
};


/** The query root of FluxNinja's GraphQL interface. */
export type QueryFluxMetersArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<FluxMeterSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<FluxMeterOrderBy>>>;
  where: InputMaybe<FluxMeterBoolExp>;
};


/** The query root of FluxNinja's GraphQL interface. */
export type QueryKubernetesControlPointsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<KubernetesControlPointSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<KubernetesControlPointOrderBy>>>;
  where: InputMaybe<KubernetesControlPointBoolExp>;
};


/** The query root of FluxNinja's GraphQL interface. */
export type QueryOrganizationMembershipsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<OrganizationMembershipSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<OrganizationMembershipOrderBy>>>;
  where: InputMaybe<OrganizationMembershipBoolExp>;
};


/** The query root of FluxNinja's GraphQL interface. */
export type QueryOrganizationsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<OrganizationSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<OrganizationOrderBy>>>;
  where: InputMaybe<OrganizationBoolExp>;
};


/** The query root of FluxNinja's GraphQL interface. */
export type QueryPoliciesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<PolicySelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<PolicyOrderBy>>>;
  where: InputMaybe<PolicyBoolExp>;
};


/** The query root of FluxNinja's GraphQL interface. */
export type QueryPoliciesWithDefinitionArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<PolicyWithDefinitionSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<PolicyWithDefinitionOrderBy>>>;
  where: InputMaybe<PolicyWithDefinitionBoolExp>;
};


/** The query root of FluxNinja's GraphQL interface. */
export type QueryProjectsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<ProjectSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<ProjectOrderBy>>>;
  where: InputMaybe<ProjectBoolExp>;
};


/** The query root of FluxNinja's GraphQL interface. */
export type QueryServicesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<ServiceSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<ServiceOrderBy>>>;
  where: InputMaybe<ServiceBoolExp>;
};


/** The query root of FluxNinja's GraphQL interface. */
export type QuerySubscriptionsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<SubscriptionSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<SubscriptionOrderBy>>>;
  where: InputMaybe<SubscriptionBoolExp>;
};


/** The query root of FluxNinja's GraphQL interface. */
export type QueryUserApiKeysArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<UserApiKeySelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<UserApiKeyOrderBy>>>;
  where: InputMaybe<UserApiKeyBoolExp>;
};


/** The query root of FluxNinja's GraphQL interface. */
export type QueryUserGroupMembershipsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<UserGroupMembershipSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<UserGroupMembershipOrderBy>>>;
  where: InputMaybe<UserGroupMembershipBoolExp>;
};


/** The query root of FluxNinja's GraphQL interface. */
export type QueryUserGroupProjectAssignmentsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<UserGroupProjectAssignmentSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<UserGroupProjectAssignmentOrderBy>>>;
  where: InputMaybe<UserGroupProjectAssignmentBoolExp>;
};


/** The query root of FluxNinja's GraphQL interface. */
export type QueryUserGroupsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<UserGroupSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<UserGroupOrderBy>>>;
  where: InputMaybe<UserGroupBoolExp>;
};


/** The query root of FluxNinja's GraphQL interface. */
export type QueryUsersArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<UserSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<UserOrderBy>>>;
  where: InputMaybe<UserBoolExp>;
};

/** Return type of refreshPoliciesWithDefinition. */
export type RefreshPoliciesWithDefinitionPayload = {
  /** Policy Count. */
  readonly policiesCount: Scalars['Int']['output'];
};

/** Input type of removeBlueprintPolicyDefinition */
export type RemoveBlueprintDefinedPolicyInput = {
  /** The id of the blueprintPolicyDefinition to be removed with its policy. */
  readonly id: Scalars['ID']['input'];
  /** Delete definition */
  readonly removeDefinition: Scalars['Boolean']['input'];
};

/** Return type of removeBlueprintPolicyDefinition */
export type RemoveBlueprintDefinedPolicyPayload = {
  /** ID of started temporal workflow. */
  readonly workflowID: Scalars['String']['output'];
};

/** Input type of removeCustomPolicyDefinition */
export type RemoveCustomDefinedPolicyInput = {
  /** The id of the customPolicyDefinition to be removed with its policy. */
  readonly id: Scalars['ID']['input'];
  /** Delete definition */
  readonly removeDefinition: Scalars['Boolean']['input'];
};

/** Return type of removeCustomPolicyDefinition */
export type RemoveCustomDefinedPolicyPayload = {
  /** ID of started temporal workflow. */
  readonly workflowID: Scalars['String']['output'];
};

/** Input type of resumeProject */
export type ResumeProjectInput = {
  /** The id of the project to resume. */
  readonly id: Scalars['ID']['input'];
};

/** Return type of resumeProject */
export type ResumeProjectPayload = {
  /** The updated project. */
  readonly project: Maybe<Project>;
  /** ID of started temporal workflow. */
  readonly workflowID: Scalars['String']['output'];
};

/** Input type of RevokeAgentKey */
export type RevokeAgentKeyInput = {
  /** The id of the Agent Key to revoke. */
  readonly id: Scalars['ID']['input'];
};

/** Return type of RevokeAgentKey */
export type RevokeAgentKeyPayload = {
  /** The revoked Agent Key. */
  readonly agentKey: Maybe<AgentKey>;
  /** ID of the temporal workflow. */
  readonly workflowID: Maybe<Scalars['String']['output']>;
};

/** Input type of RevokeUserAPIKey */
export type RevokeUserApiKeyInput = {
  /** The id of the API Key to revoke. */
  readonly id: Scalars['ID']['input'];
};

/** Return type of RevokeUserAPIKey */
export type RevokeUserApiKeyPayload = {
  /** The revoked API Key. */
  readonly userAPIKey: Maybe<UserApiKey>;
};

/** Service represents single Service instance. */
export type Service = Node & {
  /** Name of the agentGroup. */
  readonly agentGroup: Scalars['String']['output'];
  /** Number of alerts counted in this service. */
  readonly alertsCount: Maybe<ReadonlyArray<AlertsCount>>;
  /** Control Points in this service. */
  readonly controlPoints: ControlPointConnection;
  /** Controller this service belongs to. */
  readonly controller: Controller;
  /** UTC timestamp of the first service discovery. */
  readonly discoveredOn: Scalars['Time']['output'];
  /** Number of entities counted in this service. */
  readonly entitiesCount: Scalars['Int']['output'];
  /** ID of the Service. */
  readonly id: Scalars['ID']['output'];
  /** Labels attached to this service. */
  readonly labels: Scalars['Map']['output'];
  /** Last seen UTC timestamp of the Service. */
  readonly lastSeen: Scalars['Time']['output'];
  /** Name of this service. */
  readonly name: Scalars['String']['output'];
  /** Project this service belongs to. */
  readonly project: Project;
  /** Current status of the Service. */
  readonly status: Scalars['String']['output'];
};


/** Service represents single Service instance. */
export type ServiceControlPointsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<ControlPointSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<ControlPointOrderBy>>>;
  where: InputMaybe<ControlPointBoolExp>;
};

/** order by aggregate values of Service */
export type ServiceAggregateOrderBy = {
  readonly count: InputMaybe<OrderBy>;
  readonly max: InputMaybe<ServiceMaxOrderBy>;
  readonly min: InputMaybe<ServiceMinOrderBy>;
};

/** Boolean expression to filter rows from the table "Service". */
export type ServiceBoolExp = {
  /** Service agentGroup predicate. */
  readonly agentGroup: InputMaybe<StringComparisonExp>;
  /** Logical and. */
  readonly and: InputMaybe<ReadonlyArray<ServiceBoolExp>>;
  /** Service control points predicate. */
  readonly controlPoints: InputMaybe<ControlPointBoolExp>;
  /** Service controller predicate. */
  readonly controller: InputMaybe<ControllerBoolExp>;
  /** Service controller id predicate. */
  readonly controllerID: InputMaybe<IdComparisonExp>;
  /** Service discoveredOn timestamp predicate. */
  readonly discoveredOn: InputMaybe<TimeComparisonExp>;
  /** Service entities count predicate. */
  readonly entitiesCount: InputMaybe<IntComparisonExp>;
  /** Service id predicate. */
  readonly id: InputMaybe<IdComparisonExp>;
  /** Service labels predicate. */
  readonly labels: InputMaybe<JsonbComparisonExp>;
  /** Service lastSeen timestamp predicate. */
  readonly lastSeen: InputMaybe<TimeComparisonExp>;
  /** Service name predicate. */
  readonly name: InputMaybe<StringComparisonExp>;
  /** Logical not. */
  readonly not: InputMaybe<ServiceBoolExp>;
  /** Logical or. */
  readonly or: InputMaybe<ReadonlyArray<ServiceBoolExp>>;
  /** Service project predicate. */
  readonly project: InputMaybe<ProjectBoolExp>;
  /** Service project id predicate. */
  readonly projectID: InputMaybe<IdComparisonExp>;
  /** Service status predicate. */
  readonly status: InputMaybe<StringComparisonExp>;
};

/** Look up Services */
export type ServiceConnection = {
  /** A list of edges. */
  readonly edges: ReadonlyArray<ServiceEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ServiceEdge = {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node: Service;
};

/** order by max() on columns of Service */
export type ServiceMaxOrderBy = {
  readonly agentGroup: InputMaybe<OrderBy>;
  readonly controllerID: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly name: InputMaybe<OrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly status: InputMaybe<OrderBy>;
};

/** order by min() on columns of Service */
export type ServiceMinOrderBy = {
  readonly agentGroup: InputMaybe<OrderBy>;
  readonly controllerID: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly name: InputMaybe<OrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly status: InputMaybe<OrderBy>;
};

/** Ordering options when querying Services. */
export type ServiceOrderBy = {
  readonly agentGroup: InputMaybe<OrderBy>;
  readonly alertsCount: InputMaybe<OrderBy>;
  readonly controlPointsAggregate: InputMaybe<ControlPointAggregateOrderBy>;
  readonly controller: InputMaybe<ControllerOrderBy>;
  readonly controllerID: InputMaybe<OrderBy>;
  readonly discoveredOn: InputMaybe<OrderBy>;
  readonly entitiesCount: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly labels: InputMaybe<OrderBy>;
  readonly lastSeen: InputMaybe<OrderBy>;
  readonly name: InputMaybe<OrderBy>;
  readonly project: InputMaybe<ProjectOrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly status: InputMaybe<OrderBy>;
};

/** Select columns of Services. */
export enum ServiceSelectColumn {
  /** Column name. */
  AgentGroup = 'agentGroup',
  /** Column name. */
  ControllerId = 'controllerID',
  /** Column name. */
  Id = 'id',
  /** Column name. */
  Labels = 'labels',
  /** Column name. */
  Name = 'name',
  /** Column name. */
  ProjectId = 'projectID',
  /** Column name. */
  Status = 'status'
}

export type SignalName = {
  readonly signalName: Scalars['String']['output'];
};

/** Input type of silenceAlertsChannel */
export type SilenceAlertsChannelInput = {
  /** The id of the alertsChannel to silence. */
  readonly id: Scalars['ID']['input'];
  /** Timestamp (in RFC3339 format) until the channel is silenced. */
  readonly silencedUntil: Scalars['Time']['input'];
};

/** Return type of silenceAlertsChannel */
export type SilenceAlertsChannelPayload = {
  /** The updated alertsChannel. */
  readonly alertsChannel: Maybe<AlertsChannel>;
};

export type SourceTarget = {
  readonly componentId: Scalars['String']['output'];
  readonly portName: Scalars['String']['output'];
};

/**
 * Expression to compare columns of type String. All fields are combined with logical 'AND'.
 * See https://hasura.io/docs/latest/graphql/core/databases/postgres/queries/query-filters.html#comparison-operators
 * for more detail.
 */
export type StringComparisonExp = {
  /** Equal to operator. */
  readonly eq: InputMaybe<Scalars['String']['input']>;
  /** Greater than operator. */
  readonly gt: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to operator. */
  readonly gte: InputMaybe<Scalars['String']['input']>;
  /** Ilike correspons to Postgres ILIKE operator. */
  readonly ilike: InputMaybe<Scalars['String']['input']>;
  /** In a list operator. */
  readonly in: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** Does the column match the given POSIX regular expression, case insensitive. */
  readonly iregex: InputMaybe<Scalars['String']['input']>;
  /** Is null operator. */
  readonly isNull: InputMaybe<Scalars['Boolean']['input']>;
  /** Like correspons to Postgres LIKE operator. */
  readonly like: InputMaybe<Scalars['String']['input']>;
  /** Less than operator. */
  readonly lt: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to operator. */
  readonly lte: InputMaybe<Scalars['String']['input']>;
  /** Not equal to operator. */
  readonly neq: InputMaybe<Scalars['String']['input']>;
  /** Nilike correspons to Postgres NOT ILIKE operator. */
  readonly nilike: InputMaybe<Scalars['String']['input']>;
  /** Not in a list operator. */
  readonly nin: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** Does the column NOT match the given POSIX regular expression, case insensitive. */
  readonly niregex: InputMaybe<Scalars['String']['input']>;
  /** Nlike correspons to Postgres NOT LIKE operator. */
  readonly nlike: InputMaybe<Scalars['String']['input']>;
  /** Does the column NOT match the given POSIX regular expression, case sensitive. */
  readonly nregex: InputMaybe<Scalars['String']['input']>;
  /** Nsimilar correspons to Postgres NOT SIMILAR TO operator. */
  readonly nsimilar: InputMaybe<Scalars['String']['input']>;
  /** Does the column match the given POSIX regular expression, case sensitive. */
  readonly regex: InputMaybe<Scalars['String']['input']>;
  /** Similar correspons to Postgres SIMILAR TO operator. */
  readonly similar: InputMaybe<Scalars['String']['input']>;
};

/** A subscription. */
export type Subscription = Node & {
  /** ID of the subscription. */
  readonly id: Scalars['ID']['output'];
  /** Organization to which the subscription belongs. */
  readonly organization: Organization;
  /** Project to which the subscription belongs. */
  readonly project: Project;
  /** Status of the subscription. */
  readonly status: Scalars['String']['output'];
  /** ID of the subscription in ChargeBee. */
  readonly subscriptionID: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to filter rows from the table "subscription". */
export type SubscriptionBoolExp = {
  /** Logical and. */
  readonly and: InputMaybe<ReadonlyArray<SubscriptionBoolExp>>;
  /** subscription id predicate. */
  readonly id: InputMaybe<IdComparisonExp>;
  /** Logical not. */
  readonly not: InputMaybe<SubscriptionBoolExp>;
  /** Logical or. */
  readonly or: InputMaybe<ReadonlyArray<SubscriptionBoolExp>>;
  /** subscription organization predicate. */
  readonly organization: InputMaybe<OrganizationBoolExp>;
  /** subscription organization id predicate. */
  readonly organizationID: InputMaybe<IdComparisonExp>;
  /** subscription project predicate. */
  readonly project: InputMaybe<ProjectBoolExp>;
  /** subscription project id predicate. */
  readonly projectID: InputMaybe<IdComparisonExp>;
  /** subscription status predicate. */
  readonly status: InputMaybe<StringComparisonExp>;
  /** subscription id predicate. */
  readonly subscriptionID: InputMaybe<StringComparisonExp>;
};

/** Look up Subscriptions. */
export type SubscriptionConnection = {
  /** A list of edges. */
  readonly edges: ReadonlyArray<SubscriptionEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SubscriptionEdge = {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node: Subscription;
};

/** Ordering options when querying Subscriptions. */
export type SubscriptionOrderBy = {
  readonly id: InputMaybe<OrderBy>;
  readonly organization: InputMaybe<OrganizationOrderBy>;
  readonly organizationID: InputMaybe<OrderBy>;
  readonly project: InputMaybe<ProjectOrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly status: InputMaybe<OrderBy>;
  readonly subscriptionID: InputMaybe<OrderBy>;
};

/** Select columns of Subscription. */
export enum SubscriptionSelectColumn {
  /** Column name. */
  Id = 'id',
  /** Column name. */
  OrganizationId = 'organizationID',
  /** Column name. */
  ProjectId = 'projectID',
  /** Column name. */
  Status = 'status',
  /** Column name. */
  SubscriptionId = 'subscriptionID'
}

/** Boolean expression to compare columns of type "Time". All fields are combined with logical 'AND'. */
export type TimeComparisonExp = {
  /** Equal to operator. */
  readonly eq: InputMaybe<Scalars['Time']['input']>;
  /** Greater than operator. */
  readonly gt: InputMaybe<Scalars['Time']['input']>;
  /** Greater than or equal to operator. */
  readonly gte: InputMaybe<Scalars['Time']['input']>;
  /** In a list operator. */
  readonly in: InputMaybe<ReadonlyArray<Scalars['Time']['input']>>;
  /** Is null operator. */
  readonly isNull: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than operator. */
  readonly lt: InputMaybe<Scalars['Time']['input']>;
  /** Less than or equal to operator. */
  readonly lte: InputMaybe<Scalars['Time']['input']>;
  /** Not equal to operator. */
  readonly neq: InputMaybe<Scalars['Time']['input']>;
  /** Not in a list operator. */
  readonly nin: InputMaybe<ReadonlyArray<Scalars['Time']['input']>>;
};

export type Tree = {
  readonly actuators: Maybe<ReadonlyArray<Maybe<ComponentView>>>;
  readonly children: Maybe<ReadonlyArray<Maybe<Tree>>>;
  readonly graph: Maybe<Graph>;
  readonly hasChildren: Scalars['Boolean']['output'];
  readonly node: Maybe<ComponentView>;
};

/** Input type of unmuteAlertsChannel */
export type UnmuteAlertsChannelInput = {
  /** The id of the alertsChannel to unmute. */
  readonly id: Scalars['ID']['input'];
};

/** Return type of unmuteAlertsChannel */
export type UnmuteAlertsChannelPayload = {
  /** The updated alertsChannel. */
  readonly alertsChannel: Maybe<AlertsChannel>;
};

/** Input type of updateAlertsChannel */
export type UpdateAlertsChannelInput = {
  /** The id of the alertsChannel to update. */
  readonly id: Scalars['ID']['input'];
  /** The new alertsChannel name. */
  readonly name: Scalars['String']['input'];
};

/** Return type of updateAlertsChannel */
export type UpdateAlertsChannelPayload = {
  /** The updated alertsChannel. */
  readonly alertsChannel: Maybe<AlertsChannel>;
};

/** Input type of updateAlertsEmailNotifier */
export type UpdateAlertsEmailNotifierInput = {
  /** The new alertsEmailNotifier email. */
  readonly email: Scalars['String']['input'];
  /** The id of the alertsEmailNotifier to update. */
  readonly id: Scalars['ID']['input'];
  /** Whether to notify about resolved alerts. */
  readonly sendResolved: Scalars['Boolean']['input'];
};

/** Return type of updateAlertsEmailNotifier */
export type UpdateAlertsEmailNotifierPayload = {
  /** The updated alertsEmailNotifier. */
  readonly alertsEmailNotifier: Maybe<AlertsEmailNotifier>;
};

/** Input type of updateAlertsOrganizationConfig */
export type UpdateAlertsOrganizationConfigInput = {
  /** The new alerts organization config. */
  readonly config: Scalars['String']['input'];
  /** The id of the alerts organization config to update. */
  readonly id: Scalars['ID']['input'];
};

/** Return type of updateAlertsOrganizationConfig */
export type UpdateAlertsOrganizationConfigPayload = {
  /** The updated alerts organization config. */
  readonly alertsOrganizationConfig: Maybe<AlertsOrganizationConfig>;
};

/** Input type of updateAlertsSlackNotifier */
export type UpdateAlertsSlackNotifierInput = {
  /** The new alertsSlackNotifier channel. */
  readonly channel: Scalars['String']['input'];
  /** The id of the alertsSlackNotifier to update. */
  readonly id: Scalars['ID']['input'];
  /** Whether to notify about resolved alerts. */
  readonly sendResolved: Scalars['Boolean']['input'];
  /** The new alertsSlackNotifier url. */
  readonly url: Scalars['String']['input'];
};

/** Return type of updateAlertsSlackNotifier */
export type UpdateAlertsSlackNotifierPayload = {
  /** The updated alertsSlackNotifier. */
  readonly alertsSlackNotifier: Maybe<AlertsSlackNotifier>;
};

/** Input type of updateAlertsWebhookNotifier */
export type UpdateAlertsWebhookNotifierInput = {
  /** The id of the alertsWebhookNotifier to update. */
  readonly id: Scalars['ID']['input'];
  /** Whether to notify about resolved alerts. */
  readonly sendResolved: Scalars['Boolean']['input'];
  /** The new alertsWebhookNotifier url. */
  readonly url: Scalars['String']['input'];
};

/** Return type of updateAlertsWebhookNotifier */
export type UpdateAlertsWebhookNotifierPayload = {
  /** The updated alertsWebhookNotifier. */
  readonly alertsWebhookNotifier: Maybe<AlertsWebhookNotifier>;
};

/** Input type of updateBlueprintPolicyDefinition */
export type UpdateBlueprintPolicyDefinitionInput = {
  /** Name of the used blueprint. */
  readonly blueprintName: Scalars['String']['input'];
  /** Version of the used blueprint. */
  readonly blueprintVersion: Scalars['String']['input'];
  /**
   * Time of last edition as received from blueprintPolicyDefinitions query.
   * Required to ensure the blueprint policy definition hasn't been already changed.
   */
  readonly editedAt: Scalars['Time']['input'];
  /** The id of the blueprintPolicyDefinition to update. */
  readonly id: Scalars['ID']['input'];
  /** ID of the user who modified the definition. */
  readonly lastModifiedByID: Scalars['ID']['input'];
  /** Message to show. */
  readonly message: InputMaybe<Scalars['String']['input']>;
  /** Name of the blueprint policy definition and the created policy. */
  readonly name: Scalars['String']['input'];
  /** Values set in the blueprint as json. */
  readonly values: Scalars['Map']['input'];
};

/** Return type of updateBlueprintPolicyDefinition */
export type UpdateBlueprintPolicyDefinitionPayload = {
  /** The updated blueprintPolicyDefinition. */
  readonly blueprintPolicyDefinition: Maybe<BlueprintPolicyDefinition>;
};

/** Input type of updateBlueprintPolicyDefinitionPolicyID */
export type UpdateBlueprintPolicyDefinitionPolicyIdInput = {
  /** The id of the blueprintPolicyDefinition to update. */
  readonly id: Scalars['ID']['input'];
  /** ID of policy created from the blueprint policy definition. */
  readonly policyID: Scalars['String']['input'];
};

/** Return type of updateBlueprintPolicyDefinitionPolicyID */
export type UpdateBlueprintPolicyDefinitionPolicyIdPayload = {
  /** The updated blueprintPolicyDefinition. */
  readonly blueprintPolicyDefinition: Maybe<BlueprintPolicyDefinition>;
};

/** Input type of updateBlueprintPolicyDefinitionStatus */
export type UpdateBlueprintPolicyDefinitionStatusInput = {
  /** The id of the blueprintPolicyDefinition to update. */
  readonly id: Scalars['ID']['input'];
  /** Message to show. */
  readonly message: InputMaybe<Scalars['String']['input']>;
  /** Status of the blueprint policy definition's application'. */
  readonly status: Scalars['String']['input'];
};

/** Return type of updateBlueprintPolicyDefinitionStatus */
export type UpdateBlueprintPolicyDefinitionStatusPayload = {
  /** The updated blueprintPolicyDefinition. */
  readonly blueprintPolicyDefinition: Maybe<BlueprintPolicyDefinition>;
};

/** Input type of updateCustomPolicyDefinition */
export type UpdateCustomPolicyDefinitionInput = {
  /** Body of the defined policy. */
  readonly body: Scalars['Map']['input'];
  /**
   * Time of last edition as received from blueprintPolicyDefinitions query.
   * Required to ensure the blueprint policy definition hasn't been already changed.
   */
  readonly editedAt: Scalars['Time']['input'];
  /** The id of the customPolicyDefinition to update. */
  readonly id: Scalars['ID']['input'];
  /** ID of the user who modified the definition. */
  readonly lastModifiedByID: Scalars['ID']['input'];
  /** Message to show. */
  readonly message: InputMaybe<Scalars['String']['input']>;
  /** Name of the custom policy definition and the created policy. */
  readonly name: Scalars['String']['input'];
};

/** Return type of updateCustomPolicyDefinition */
export type UpdateCustomPolicyDefinitionPayload = {
  /** The updated customPolicyDefinition. */
  readonly customPolicyDefinition: Maybe<CustomPolicyDefinition>;
};

/** Input type of updateCustomPolicyDefinitionPolicyID */
export type UpdateCustomPolicyDefinitionPolicyIdInput = {
  /** The id of the customPolicyDefinition to update. */
  readonly id: Scalars['ID']['input'];
  /** ID of policy created from the custom policy definition. */
  readonly policyID: Scalars['String']['input'];
};

/** Return type of updateCustomPolicyDefinitionPolicyID */
export type UpdateCustomPolicyDefinitionPolicyIdPayload = {
  /** The updated customPolicyDefinition. */
  readonly customPolicyDefinition: Maybe<CustomPolicyDefinition>;
};

/** Input type of updateCustomPolicyDefinitionStatus */
export type UpdateCustomPolicyDefinitionStatusInput = {
  /** The id of the customPolicyDefinition to update. */
  readonly id: Scalars['ID']['input'];
  /** Message to show. */
  readonly message: InputMaybe<Scalars['String']['input']>;
  /** Status of the custom policy definition's application'. */
  readonly status: Scalars['String']['input'];
};

/** Return type of updateCustomPolicyDefinitionStatus */
export type UpdateCustomPolicyDefinitionStatusPayload = {
  /** The updated customPolicyDefinition. */
  readonly customPolicyDefinition: Maybe<CustomPolicyDefinition>;
};

/** Input type of updateOrganizationDefaultRole */
export type UpdateOrganizationDefaultRoleInput = {
  /** The new organization default role. */
  readonly defaultRole: Scalars['String']['input'];
  /** The id of the organization to update. */
  readonly id: Scalars['ID']['input'];
};

/** Return type of updateOrganizationDefaultRole */
export type UpdateOrganizationDefaultRolePayload = {
  /** The updated organization. */
  readonly organization: Maybe<Organization>;
};

/** Input type of updateOrganizationName */
export type UpdateOrganizationNameInput = {
  /** The id of the organization to update. */
  readonly id: Scalars['ID']['input'];
  /** The new organization name. */
  readonly name: InputMaybe<Scalars['String']['input']>;
};

/** Return type of updateOrganizationName */
export type UpdateOrganizationNamePayload = {
  /** The updated organization. */
  readonly organization: Maybe<Organization>;
};

/** Input type of updateOrganizationPicture */
export type UpdateOrganizationPictureInput = {
  /** The id of the organization to update. */
  readonly id: Scalars['ID']['input'];
  /** The new organization picture. */
  readonly pictureURL: InputMaybe<Scalars['String']['input']>;
};

/** Return type of updateOrganizationPicture */
export type UpdateOrganizationPicturePayload = {
  /** The updated organization. */
  readonly organization: Maybe<Organization>;
};

/** Input type of updatePolicyStatus */
export type UpdatePolicyStatusInput = {
  /** The id of the policy to update. */
  readonly id: Scalars['ID']['input'];
  /** Status of the policy. */
  readonly status: Scalars['String']['input'];
};

/** Return type of updatePolicyStatus */
export type UpdatePolicyStatusPayload = {
  /** The updated policy. */
  readonly policy: Maybe<Policy>;
};

/** Input type of updateProjectDescription */
export type UpdateProjectDescriptionInput = {
  /** The new project description. */
  readonly description: Scalars['String']['input'];
  /** The id of the project to update. */
  readonly id: Scalars['ID']['input'];
};

/** Return type of updateProjectDescription */
export type UpdateProjectDescriptionPayload = {
  /** The updated project. */
  readonly project: Maybe<Project>;
};

/** Input type of updateProjectName */
export type UpdateProjectNameInput = {
  /** The id of the project to update. */
  readonly id: Scalars['ID']['input'];
  /** The new project name. */
  readonly name: Scalars['String']['input'];
};

/** Return type of updateProjectName */
export type UpdateProjectNamePayload = {
  /** The updated project. */
  readonly project: Maybe<Project>;
};

/** Input type of updateProjectRegion */
export type UpdateProjectRegionInput = {
  /** The cloud provider for the project. */
  readonly cloud_provider: Scalars['String']['input'];
  /** The id of the project to change the region. */
  readonly id: Scalars['ID']['input'];
  /** The region to update for the project. */
  readonly region: Scalars['String']['input'];
};

/** Return type of updateProjectRegion */
export type UpdateProjectRegionPayload = {
  /** The updated project. */
  readonly project: Maybe<Project>;
  /** ID of started temporal workflow. */
  readonly workflowID: Scalars['String']['output'];
};

/** Input type of UpdateSubscriptionStatus */
export type UpdateSubscriptionStatusInput = {
  /** ID of the subscription. */
  readonly id: Scalars['String']['input'];
  /** Status of the subscription. */
  readonly status: Scalars['String']['input'];
};

/** Return type of UpdateSubscriptionStatus */
export type UpdateSubscriptionStatusPayload = {
  /** ID of the subscription. */
  readonly subscription: Subscription;
  /** ID of started temporal workflow. */
  readonly workflowID: Maybe<Scalars['String']['output']>;
};

/** Input type of updateUserGroupName */
export type UpdateUserGroupNameInput = {
  /** The id of the userGroup to update. */
  readonly id: Scalars['ID']['input'];
  /** The new userGroup name. */
  readonly name: Scalars['String']['input'];
};

/** Return type of updateUserGroupName */
export type UpdateUserGroupNamePayload = {
  /** The updated userGroup. */
  readonly userGroup: Maybe<UserGroup>;
};

/** Input type of UpdateUserGroupProjectAssignmentPermissions */
export type UpdateUserGroupProjectAssignmentPermissionsInput = {
  /** ID of the assignment. */
  readonly id: Scalars['ID']['input'];
  /** New permissions for the assignment. */
  readonly permissions: Scalars['String']['input'];
};

/** Return type of UpdateUserGroupProjectAssignmentPermissions */
export type UpdateUserGroupProjectAssignmentPermissionsPayload = {
  /** The updated UserGroupProjectAssignment. */
  readonly userGroupProjectAssignment: Maybe<UserGroupProjectAssignment>;
};

/** Input type of updateUserName */
export type UpdateUserNameInput = {
  /** The id of the user to update. */
  readonly id: Scalars['ID']['input'];
  /** The new user name. */
  readonly name: Scalars['String']['input'];
};

/** Return type of updateUserName */
export type UpdateUserNamePayload = {
  /** The updated user. */
  readonly user: Maybe<User>;
};

/** Input type of updateUserRole */
export type UpdateUserRoleInput = {
  /** ID of the organizationMembership to update. */
  readonly id: Scalars['ID']['input'];
  /** The new user role. */
  readonly role: Scalars['String']['input'];
};

/** Return type of updateUserRole */
export type UpdateUserRolePayload = {
  /** The updated organizationMembership. */
  readonly organizationMembership: Maybe<OrganizationMembership>;
};

/** Usage represents aggregated usage for given organization in a timeframe. */
export type Usage = {
  /** Number of Agents deployed in Baremetal mode. */
  readonly agentsBaremetal: Scalars['Int']['output'];
  /** Number of Agents deployed in Daemonset mode. */
  readonly agentsDaemonset: Scalars['Int']['output'];
  /** Number of Agents deployed in Sidecar mode. */
  readonly agentsSidecar: Scalars['Int']['output'];
  /** Number of Controllers. */
  readonly controllers: Scalars['Int']['output'];
  /** ID of organization for which the Usage is calculated. */
  readonly organizationID: Scalars['ID']['output'];
};

/** Boolean expression to filter rows from the table "Usage". */
export type UsageBoolExp = {
  /** Logical and. */
  readonly and: InputMaybe<ReadonlyArray<UsageBoolExp>>;
  /** Logical not. */
  readonly not: InputMaybe<UsageBoolExp>;
  /** Logical or. */
  readonly or: InputMaybe<ReadonlyArray<UsageBoolExp>>;
  /** Usage organization id predicate. */
  readonly organizationID: InputMaybe<IdComparisonExp>;
  /** Usage timestamp preficate. */
  readonly timestamp: InputMaybe<TimeComparisonExp>;
};

/** Ordering options when querying Usages. */
export type UsageOrderBy = {
  readonly organizationID: InputMaybe<OrderBy>;
};

/** A user */
export type User = Node & {
  /** Email of the user. */
  readonly email: Scalars['String']['output'];
  /** ID of the user. */
  readonly id: Scalars['ID']['output'];
  /** ID of the user in idp. */
  readonly idpUserID: Maybe<Scalars['String']['output']>;
  /** Name of the user. */
  readonly name: Scalars['String']['output'];
  /** Organization memberships connected to this user. */
  readonly organizationMemberships: OrganizationMembershipConnection;
  /** URL of the user's picture. */
  readonly pictureURL: Maybe<Scalars['String']['output']>;
  /** Preferences of the user. */
  readonly preferences: Scalars['String']['output'];
  /** User's API Keys. */
  readonly userAPIKeys: UserApiKeyConnection;
  /** User group memberships connected to this user. */
  readonly userGroupMemberships: UserGroupMembershipConnection;
};


/** A user */
export type UserOrganizationMembershipsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<OrganizationMembershipSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<OrganizationMembershipOrderBy>>>;
  where: InputMaybe<OrganizationMembershipBoolExp>;
};


/** A user */
export type UserUserApiKeysArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<UserApiKeySelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<UserApiKeyOrderBy>>>;
  where: InputMaybe<UserApiKeyBoolExp>;
};


/** A user */
export type UserUserGroupMembershipsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<UserGroupMembershipSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<UserGroupMembershipOrderBy>>>;
  where: InputMaybe<UserGroupMembershipBoolExp>;
};

/** A User API Key. */
export type UserApiKey = Node & {
  /** Timestamp at which the User API key was created. */
  readonly createdAt: Scalars['Time']['output'];
  /** Timestamp at which the User API key gets expired. */
  readonly expiresAt: Scalars['Time']['output'];
  /** ID of the User API key. */
  readonly id: Scalars['ID']['output'];
  /** Key string value. */
  readonly key: Scalars['String']['output'];
  /** Organization membership of the key. */
  readonly organizationMembership: OrganizationMembership;
};

/** order by aggregate values of UserAPIKey */
export type UserApiKeyAggregateOrderBy = {
  readonly count: InputMaybe<OrderBy>;
  readonly max: InputMaybe<UserApiKeyMaxOrderBy>;
  readonly min: InputMaybe<UserApiKeyMinOrderBy>;
};

/** Boolean expression to filter rows from the table "user_api_key". */
export type UserApiKeyBoolExp = {
  /** Logical and. */
  readonly and: InputMaybe<ReadonlyArray<UserApiKeyBoolExp>>;
  /** User API key createdAt timestamp predicate. */
  readonly createdAt: InputMaybe<TimeComparisonExp>;
  /** User API key expiresAt timestamp predicate. */
  readonly expiresAt: InputMaybe<TimeComparisonExp>;
  /** User API key id predicate. */
  readonly id: InputMaybe<IdComparisonExp>;
  /** User API key value predicate. */
  readonly key: InputMaybe<StringComparisonExp>;
  /** Logical not. */
  readonly not: InputMaybe<UserApiKeyBoolExp>;
  /** Logical or. */
  readonly or: InputMaybe<ReadonlyArray<UserApiKeyBoolExp>>;
  /** User API key organizationMembership predicate. */
  readonly organizationMembership: InputMaybe<OrganizationMembershipBoolExp>;
  /** User API key organizationMembership id predicate. */
  readonly organizationMembershipID: InputMaybe<IdComparisonExp>;
};

/** Look up User API Keys. */
export type UserApiKeyConnection = {
  /** A list of edges. */
  readonly edges: ReadonlyArray<UserApiKeyEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserApiKeyEdge = {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node: UserApiKey;
};

/** order by max() on columns of UserAPIKey */
export type UserApiKeyMaxOrderBy = {
  readonly createdAt: InputMaybe<OrderBy>;
  readonly expiresAt: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly key: InputMaybe<OrderBy>;
  readonly organizationMembershipID: InputMaybe<OrderBy>;
};

/** order by min() on columns of UserAPIKey */
export type UserApiKeyMinOrderBy = {
  readonly createdAt: InputMaybe<OrderBy>;
  readonly expiresAt: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly key: InputMaybe<OrderBy>;
  readonly organizationMembershipID: InputMaybe<OrderBy>;
};

/** Ordering options when querying UserAPIKeys. */
export type UserApiKeyOrderBy = {
  readonly createdAt: InputMaybe<OrderBy>;
  readonly expiresAt: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly key: InputMaybe<OrderBy>;
  readonly organizationMembership: InputMaybe<OrganizationMembershipOrderBy>;
  readonly organizationMembershipID: InputMaybe<OrderBy>;
};

/** Select columns of User API keys. */
export enum UserApiKeySelectColumn {
  /** Column name. */
  CreatedAt = 'createdAt',
  /** Column name. */
  ExpiresAt = 'expiresAt',
  /** Column name. */
  Id = 'id',
  /** Column name. */
  Key = 'key',
  /** Column name. */
  OrganizationMembershipId = 'organizationMembershipID'
}

/** Boolean expression to filter rows from the table "user". */
export type UserBoolExp = {
  /** Logical and. */
  readonly and: InputMaybe<ReadonlyArray<UserBoolExp>>;
  /** User email predicate. */
  readonly email: InputMaybe<StringComparisonExp>;
  /** User id predicate. */
  readonly id: InputMaybe<IdComparisonExp>;
  /** User idpUserID predicate. */
  readonly idpUserID: InputMaybe<StringComparisonExp>;
  /** User name predicate. */
  readonly name: InputMaybe<StringComparisonExp>;
  /** Logical not. */
  readonly not: InputMaybe<UserBoolExp>;
  /** Logical or. */
  readonly or: InputMaybe<ReadonlyArray<UserBoolExp>>;
  /** User organization membership predicate. */
  readonly organizationMemberships: InputMaybe<OrganizationMembershipBoolExp>;
  /** User preferences predicate. */
  readonly preferences: InputMaybe<StringComparisonExp>;
  /** User API Key predicate. */
  readonly userAPIKeys: InputMaybe<UserApiKeyBoolExp>;
  /** User user group membership predicate. */
  readonly userGroupMemberships: InputMaybe<UserGroupMembershipBoolExp>;
};

/** Look up Users */
export type UserConnection = {
  /** A list of edges. */
  readonly edges: ReadonlyArray<UserEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserEdge = {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node: User;
};

/** A user group. */
export type UserGroup = Node & {
  /** ID of the user group. */
  readonly id: Scalars['ID']['output'];
  /** Name of the user group. */
  readonly name: Scalars['String']['output'];
  /** Organization to which the user group belongs. */
  readonly organization: Organization;
  /** User group memberships in the user group. */
  readonly userGroupMemberships: UserGroupMembershipConnection;
  /** Projects assignments in the user group. */
  readonly userGroupProjectAssignments: UserGroupProjectAssignmentConnection;
};


/** A user group. */
export type UserGroupUserGroupMembershipsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<UserGroupMembershipSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<UserGroupMembershipOrderBy>>>;
  where: InputMaybe<UserGroupMembershipBoolExp>;
};


/** A user group. */
export type UserGroupUserGroupProjectAssignmentsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<UserGroupProjectAssignmentSelectColumn>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<UserGroupProjectAssignmentOrderBy>>>;
  where: InputMaybe<UserGroupProjectAssignmentBoolExp>;
};

/** order by aggregate values of UserGroup */
export type UserGroupAggregateOrderBy = {
  readonly count: InputMaybe<OrderBy>;
  readonly max: InputMaybe<UserGroupMaxOrderBy>;
  readonly min: InputMaybe<UserGroupMinOrderBy>;
};

/** Boolean expression to filter rows from the table "userGroup". */
export type UserGroupBoolExp = {
  /** Logical and. */
  readonly and: InputMaybe<ReadonlyArray<UserGroupBoolExp>>;
  /** User group id predicate. */
  readonly id: InputMaybe<IdComparisonExp>;
  /** User group name predicate. */
  readonly name: InputMaybe<StringComparisonExp>;
  /** Logical not. */
  readonly not: InputMaybe<UserGroupBoolExp>;
  /** Logical or. */
  readonly or: InputMaybe<ReadonlyArray<UserGroupBoolExp>>;
  /** User group organization predicate. */
  readonly organization: InputMaybe<OrganizationBoolExp>;
  /** User group organization id predicate. */
  readonly organizationID: InputMaybe<IdComparisonExp>;
  /** User group membership predicate. */
  readonly userGroupMemberships: InputMaybe<UserGroupMembershipBoolExp>;
  /** User group project assignment predicate. */
  readonly userGroupProjectAssignments: InputMaybe<UserGroupProjectAssignmentBoolExp>;
};

/** Look up UserGroups */
export type UserGroupConnection = {
  /** A list of edges. */
  readonly edges: ReadonlyArray<UserGroupEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserGroupEdge = {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node: UserGroup;
};

/** order by max() on columns of UserGroup */
export type UserGroupMaxOrderBy = {
  readonly id: InputMaybe<OrderBy>;
  readonly name: InputMaybe<OrderBy>;
  readonly organizationID: InputMaybe<OrderBy>;
};

/** A user group membership */
export type UserGroupMembership = Node & {
  /** Timestamp when membership was ended in RFC3339 format. */
  readonly end: Maybe<Scalars['String']['output']>;
  /** ID of the membership. */
  readonly id: Scalars['ID']['output'];
  /** Timestamp when membership was created in RFC3339 format. */
  readonly start: Scalars['String']['output'];
  /** Status of the membership. Can be active or inactive. */
  readonly status: Scalars['String']['output'];
  /** User who is the member. */
  readonly user: User;
  /** UserGroup to which the user belongs. */
  readonly userGroup: UserGroup;
};

/** order by aggregate values of UserGroupMembership */
export type UserGroupMembershipAggregateOrderBy = {
  readonly count: InputMaybe<OrderBy>;
  readonly max: InputMaybe<UserGroupMembershipMaxOrderBy>;
  readonly min: InputMaybe<UserGroupMembershipMinOrderBy>;
};

/** Boolean expression to filter rows from the table "userGroupMembership". */
export type UserGroupMembershipBoolExp = {
  /** Logical and. */
  readonly and: InputMaybe<ReadonlyArray<UserGroupMembershipBoolExp>>;
  /** User group membership end predicate. */
  readonly end: InputMaybe<StringComparisonExp>;
  /** User group membership id predicate. */
  readonly id: InputMaybe<IdComparisonExp>;
  /** Logical not. */
  readonly not: InputMaybe<UserGroupMembershipBoolExp>;
  /** Logical or. */
  readonly or: InputMaybe<ReadonlyArray<UserGroupMembershipBoolExp>>;
  /** User group membership start predicate. */
  readonly start: InputMaybe<StringComparisonExp>;
  /** User group membership status predicate. */
  readonly status: InputMaybe<StringComparisonExp>;
  /** User group membership user predicate. */
  readonly user: InputMaybe<UserBoolExp>;
  /** User group membership userGroup predicate. */
  readonly userGroup: InputMaybe<UserGroupBoolExp>;
  /** User group membership userGroup id predicate. */
  readonly userGroupID: InputMaybe<IdComparisonExp>;
  /** User group membership user id predicate. */
  readonly userID: InputMaybe<IdComparisonExp>;
};

/** Look up UserGroupMemberships */
export type UserGroupMembershipConnection = {
  /** A list of edges. */
  readonly edges: ReadonlyArray<UserGroupMembershipEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserGroupMembershipEdge = {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node: UserGroupMembership;
};

/** order by max() on columns of UserGroupMembership */
export type UserGroupMembershipMaxOrderBy = {
  readonly end: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly start: InputMaybe<OrderBy>;
  readonly status: InputMaybe<OrderBy>;
  readonly userGroupID: InputMaybe<OrderBy>;
  readonly userID: InputMaybe<OrderBy>;
};

/** order by min() on columns of UserGroupMembership */
export type UserGroupMembershipMinOrderBy = {
  readonly end: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly start: InputMaybe<OrderBy>;
  readonly status: InputMaybe<OrderBy>;
  readonly userGroupID: InputMaybe<OrderBy>;
  readonly userID: InputMaybe<OrderBy>;
};

/** Ordering options when querying UserGroupMemberships. */
export type UserGroupMembershipOrderBy = {
  readonly end: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly start: InputMaybe<OrderBy>;
  readonly status: InputMaybe<OrderBy>;
  readonly user: InputMaybe<UserOrderBy>;
  readonly userGroup: InputMaybe<UserGroupOrderBy>;
  readonly userGroupID: InputMaybe<OrderBy>;
  readonly userID: InputMaybe<OrderBy>;
};

/** Select columns of User Group Memberships. */
export enum UserGroupMembershipSelectColumn {
  /** Column name. */
  End = 'end',
  /** Column name. */
  Id = 'id',
  /** Column name. */
  Start = 'start',
  /** Column name. */
  Status = 'status',
  /** Column name. */
  UserGroupId = 'userGroupID',
  /** Column name. */
  UserId = 'userID'
}

/** order by min() on columns of UserGroup */
export type UserGroupMinOrderBy = {
  readonly id: InputMaybe<OrderBy>;
  readonly name: InputMaybe<OrderBy>;
  readonly organizationID: InputMaybe<OrderBy>;
};

/** Ordering options when querying UserGroups. */
export type UserGroupOrderBy = {
  readonly id: InputMaybe<OrderBy>;
  readonly name: InputMaybe<OrderBy>;
  readonly organization: InputMaybe<OrganizationOrderBy>;
  readonly organizationID: InputMaybe<OrderBy>;
  readonly userGroupMembershipsAggregate: InputMaybe<UserGroupMembershipAggregateOrderBy>;
  readonly userGroupProjectAssignmentsAggregate: InputMaybe<UserGroupProjectAssignmentAggregateOrderBy>;
};

/** A userGroup-project assignment */
export type UserGroupProjectAssignment = Node & {
  /** Timestamp when assignment was ended in RFC3339 format. */
  readonly end: Maybe<Scalars['String']['output']>;
  /** ID of the assignment. */
  readonly id: Scalars['ID']['output'];
  /** Permissions for the user group in the project. May be "read" or "write". */
  readonly permissions: Maybe<Scalars['String']['output']>;
  /** Project to which the userGroup is assigned. */
  readonly project: Project;
  /** Timestamp when assignment was created in RFC3339 format. */
  readonly start: Scalars['String']['output'];
  /** UserGroup assigned to the project. */
  readonly userGroup: UserGroup;
};

/** order by aggregate values of UserGroupProjectAssignment */
export type UserGroupProjectAssignmentAggregateOrderBy = {
  readonly count: InputMaybe<OrderBy>;
  readonly max: InputMaybe<UserGroupProjectAssignmentMaxOrderBy>;
  readonly min: InputMaybe<UserGroupProjectAssignmentMinOrderBy>;
};

/** Boolean expression to filter rows from the table "userGroupProjectAssignment". */
export type UserGroupProjectAssignmentBoolExp = {
  /** Logical and. */
  readonly and: InputMaybe<ReadonlyArray<UserGroupProjectAssignmentBoolExp>>;
  /** User group project assignment end predicate. */
  readonly end: InputMaybe<StringComparisonExp>;
  /** User group project assignment id predicate. */
  readonly id: InputMaybe<IdComparisonExp>;
  /** Logical not. */
  readonly not: InputMaybe<UserGroupProjectAssignmentBoolExp>;
  /** Logical or. */
  readonly or: InputMaybe<ReadonlyArray<UserGroupProjectAssignmentBoolExp>>;
  /** User group project assignment permissions predicate. */
  readonly permissions: InputMaybe<StringComparisonExp>;
  /** User group project assignment project predicate. */
  readonly project: InputMaybe<ProjectBoolExp>;
  /** User group project assignment project id predicate. */
  readonly projectID: InputMaybe<IdComparisonExp>;
  /** User group project assignment start predicate. */
  readonly start: InputMaybe<StringComparisonExp>;
  /** User group project assignment userGroup predicate. */
  readonly userGroup: InputMaybe<UserGroupBoolExp>;
  /** User group project assignment userGroup id predicate. */
  readonly userGroupID: InputMaybe<IdComparisonExp>;
};

/** Look up UserGroupProjectAssignments */
export type UserGroupProjectAssignmentConnection = {
  /** A list of edges. */
  readonly edges: ReadonlyArray<UserGroupProjectAssignmentEdge>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserGroupProjectAssignmentEdge = {
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node: UserGroupProjectAssignment;
};

/** order by max() on columns of UserGroupProjectAssignment */
export type UserGroupProjectAssignmentMaxOrderBy = {
  readonly end: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly permissions: InputMaybe<OrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly start: InputMaybe<OrderBy>;
  readonly userGroupID: InputMaybe<OrderBy>;
};

/** order by min() on columns of UserGroupProjectAssignment */
export type UserGroupProjectAssignmentMinOrderBy = {
  readonly end: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly permissions: InputMaybe<OrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly start: InputMaybe<OrderBy>;
  readonly userGroupID: InputMaybe<OrderBy>;
};

/** Ordering options when querying UserGroupProjectAssignments. */
export type UserGroupProjectAssignmentOrderBy = {
  readonly end: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly permissions: InputMaybe<OrderBy>;
  readonly project: InputMaybe<ProjectOrderBy>;
  readonly projectID: InputMaybe<OrderBy>;
  readonly start: InputMaybe<OrderBy>;
  readonly userGroup: InputMaybe<UserGroupOrderBy>;
  readonly userGroupID: InputMaybe<OrderBy>;
};

/** Select columns of User Group Project Assignments. */
export enum UserGroupProjectAssignmentSelectColumn {
  /** Column name. */
  End = 'end',
  /** Column name. */
  Id = 'id',
  /** Column name. */
  Permissions = 'permissions',
  /** Column name. */
  ProjectId = 'projectID',
  /** Column name. */
  Start = 'start',
  /** Column name. */
  UserGroupId = 'userGroupID'
}

/** Select columns of User Group. */
export enum UserGroupSelectColumn {
  /** Column name. */
  Id = 'id',
  /** Column name. */
  Name = 'name',
  /** Column name. */
  OrganizationId = 'organizationID'
}

/** Ordering options when querying Users. */
export type UserOrderBy = {
  readonly email: InputMaybe<OrderBy>;
  readonly id: InputMaybe<OrderBy>;
  readonly idpUserID: InputMaybe<OrderBy>;
  readonly name: InputMaybe<OrderBy>;
  readonly organizationMembershipsAggregate: InputMaybe<OrganizationMembershipAggregateOrderBy>;
  readonly picture: InputMaybe<OrderBy>;
  readonly preferences: InputMaybe<OrderBy>;
  readonly userAPIKeyAggregate: InputMaybe<UserApiKeyAggregateOrderBy>;
  readonly userGroupMembershipsAggregate: InputMaybe<UserGroupMembershipAggregateOrderBy>;
};

/** Select columns of Users. */
export enum UserSelectColumn {
  /** Column name. */
  Email = 'email',
  /** Column name. */
  Id = 'id',
  /** Column name. */
  IdpUserId = 'idpUserID',
  /** Column name. */
  Name = 'name',
  /** Column name. */
  Picture = 'picture',
  /** Column name. */
  Preferences = 'preferences'
}

export type NoKubernetesCheckQueryVariables = Exact<{
  where: InputMaybe<KubernetesControlPointBoolExp>;
}>;


export type NoKubernetesCheckQuery = { readonly kubernetesControlPoints: { readonly totalCount: number } };

export type FirstProjectQueryVariables = Exact<{ [key: string]: never; }>;


export type FirstProjectQuery = { readonly projects: { readonly edges: ReadonlyArray<{ readonly node: { readonly id: string, readonly name: string } }> } };

export type ChangeUserRoleMutationVariables = Exact<{
  input: UpdateUserRoleInput;
}>;


export type ChangeUserRoleMutation = { readonly updateUserRole: { readonly organizationMembership: { readonly role: string } | null } | null };

export type DeleteProjectMutationVariables = Exact<{
  input: DeleteProjectInput;
}>;


export type DeleteProjectMutation = { readonly deleteProject: { readonly project: { readonly name: string } | null } | null };

export type PauseProjectMutationVariables = Exact<{
  input: PauseProjectInput;
}>;


export type PauseProjectMutation = { readonly pauseProject: { readonly project: { readonly name: string } | null } | null };

export type ResumeProjectMutationVariables = Exact<{
  input: ResumeProjectInput;
}>;


export type ResumeProjectMutation = { readonly resumeProject: { readonly project: { readonly name: string } | null } | null };

export type AddUserToUserGroupMutationVariables = Exact<{
  input: CreateUserGroupMembershipInput;
}>;


export type AddUserToUserGroupMutation = { readonly addUserToUserGroup: { readonly userGroupMembership: { readonly user: { readonly email: string }, readonly userGroup: { readonly id: string, readonly name: string } } | null } | null };

export type ChangeUserGroupNameMutationVariables = Exact<{
  input: UpdateUserGroupNameInput;
}>;


export type ChangeUserGroupNameMutation = { readonly updateUserGroupName: { readonly userGroup: { readonly name: string } | null } | null };

export type RemoveUserGroupMutationVariables = Exact<{
  input: DeleteUserGroupInput;
}>;


export type RemoveUserGroupMutation = { readonly deleteUserGroup: { readonly userGroup: { readonly name: string } | null } | null };

export type RemoveUserGroupFromAssignedProjectMutationVariables = Exact<{
  input: DeleteUserGroupProjectAssignmentInput;
}>;


export type RemoveUserGroupFromAssignedProjectMutation = { readonly removeUserGroupFromProject: { readonly userGroupProjectAssignment: { readonly id: string, readonly userGroup: { readonly id: string, readonly name: string } } | null } | null };

export type UserGroupPermissionQueryVariables = Exact<{
  where: InputMaybe<UserGroupBoolExp>;
}>;


export type UserGroupPermissionQuery = { readonly userGroups: { readonly edges: ReadonlyArray<{ readonly node: { readonly userGroupProjectAssignments: { readonly edges: ReadonlyArray<{ readonly node: { readonly permissions: string | null } }> } } }> } };

export type CreateAlertsChannelMutationVariables = Exact<{
  input: CreateAlertsChannelInput;
}>;


export type CreateAlertsChannelMutation = { readonly createAlertsChannel: { readonly alertsChannel: { readonly id: string } | null } | null };

export type CreateAlertsEmailNotifierMutationVariables = Exact<{
  input: CreateAlertsEmailNotifierInput;
}>;


export type CreateAlertsEmailNotifierMutation = { readonly createAlertsEmailNotifier: { readonly alertsEmailNotifier: { readonly id: string, readonly email: string } | null } | null };

export type CreateAlertsSlackNotifierMutationVariables = Exact<{
  input: CreateAlertsSlackNotifierInput;
}>;


export type CreateAlertsSlackNotifierMutation = { readonly createAlertsSlackNotifier: { readonly alertsSlackNotifier: { readonly channel: string, readonly id: string, readonly url: string } | null } | null };

export type CreateAlertsWebhookNotifierMutationVariables = Exact<{
  input: CreateAlertsWebhookNotifierInput;
}>;


export type CreateAlertsWebhookNotifierMutation = { readonly createAlertsWebhookNotifier: { readonly alertsWebhookNotifier: { readonly id: string, readonly url: string } | null } | null };

export type SilenceAlertsChannelMutationVariables = Exact<{
  input: SilenceAlertsChannelInput;
}>;


export type SilenceAlertsChannelMutation = { readonly silenceAlertsChannel: { readonly alertsChannel: { readonly id: string, readonly name: string, readonly silencedUntil: any | null } | null } | null };

export type UnmuteAlertsChannelMutationVariables = Exact<{
  input: UnmuteAlertsChannelInput;
}>;


export type UnmuteAlertsChannelMutation = { readonly unmuteAlertsChannel: { readonly alertsChannel: { readonly id: string, readonly name: string, readonly silencedUntil: any | null } | null } | null };

export type DeleteAlertsChannelMutationVariables = Exact<{
  input: DeleteAlertsChannelInput;
}>;


export type DeleteAlertsChannelMutation = { readonly deleteAlertsChannel: { readonly alertsChannel: { readonly name: string, readonly id: string } | null } | null };

export type DeleteAlertsEmailNotifierMutationVariables = Exact<{
  input: DeleteAlertsEmailNotifierInput;
}>;


export type DeleteAlertsEmailNotifierMutation = { readonly deleteAlertsEmailNotifier: { readonly alertsEmailNotifier: { readonly email: string, readonly id: string } | null } | null };

export type DeleteAlertsSlackNotifierMutationVariables = Exact<{
  input: DeleteAlertsSlackNotifierInput;
}>;


export type DeleteAlertsSlackNotifierMutation = { readonly deleteAlertsSlackNotifier: { readonly alertsSlackNotifier: { readonly id: string, readonly channel: string, readonly url: string } | null } | null };

export type DeleteAlertsWebhookNotifierMutationVariables = Exact<{
  input: DeleteAlertsWebhookNotifierInput;
}>;


export type DeleteAlertsWebhookNotifierMutation = { readonly deleteAlertsWebhookNotifier: { readonly alertsWebhookNotifier: { readonly id: string, readonly url: string } | null } | null };

export type UpdateAlertsChannelMutationVariables = Exact<{
  input: UpdateAlertsChannelInput;
}>;


export type UpdateAlertsChannelMutation = { readonly updateAlertsChannel: { readonly alertsChannel: { readonly name: string, readonly id: string } | null } | null };

export type UpdateAlertsEmailNotifierMutationVariables = Exact<{
  input: UpdateAlertsEmailNotifierInput;
}>;


export type UpdateAlertsEmailNotifierMutation = { readonly updateAlertsEmailNotifier: { readonly alertsEmailNotifier: { readonly email: string, readonly id: string } | null } | null };

export type UpdateAlertsSlackNotifierMutationVariables = Exact<{
  input: UpdateAlertsSlackNotifierInput;
}>;


export type UpdateAlertsSlackNotifierMutation = { readonly updateAlertsSlackNotifier: { readonly alertsSlackNotifier: { readonly channel: string, readonly id: string, readonly url: string } | null } | null };

export type UpdateAlertsWebhookNotifierMutationVariables = Exact<{
  input: UpdateAlertsWebhookNotifierInput;
}>;


export type UpdateAlertsWebhookNotifierMutation = { readonly updateAlertsWebhookNotifier: { readonly alertsWebhookNotifier: { readonly id: string, readonly url: string } | null } | null };

export type AlertsOrganizationConfigsQueryVariables = Exact<{
  where: InputMaybe<AlertsOrganizationConfigBoolExp>;
}>;


export type AlertsOrganizationConfigsQuery = { readonly alertsOrganizationConfigs: { readonly edges: ReadonlyArray<{ readonly node: { readonly id: string, readonly config: string } }> } };

export type AlertsChannelsQueryVariables = Exact<{
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  where: InputMaybe<AlertsChannelBoolExp>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<AlertsChannelOrderBy>> | InputMaybe<AlertsChannelOrderBy>>;
}>;


export type AlertsChannelsQuery = { readonly alertsChannels: { readonly totalCount: number, readonly pageInfo: { readonly startCursor: string | null, readonly endCursor: string | null, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean }, readonly edges: ReadonlyArray<{ readonly node: { readonly id: string, readonly name: string, readonly silencedUntil: any | null, readonly project: { readonly id: string }, readonly alertsEmailNotifiers: { readonly edges: ReadonlyArray<{ readonly node: { readonly email: string, readonly id: string, readonly sendResolved: boolean } }> }, readonly alertsSlackNotifiers: { readonly edges: ReadonlyArray<{ readonly node: { readonly channel: string, readonly id: string, readonly url: string, readonly sendResolved: boolean } }> }, readonly alertsWebhookNotifiers: { readonly edges: ReadonlyArray<{ readonly node: { readonly id: string, readonly url: string, readonly sendResolved: boolean } }> } } }> } };

export type AlertsQueryVariables = Exact<{
  first: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  where: InputMaybe<AlertBoolExp>;
  distinctOn: InputMaybe<ReadonlyArray<AlertSelectColumn> | AlertSelectColumn>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<AlertOrderBy>> | InputMaybe<AlertOrderBy>>;
}>;


export type AlertsQuery = { readonly alerts: { readonly totalCount: number, readonly pageInfo: { readonly endCursor: string | null }, readonly edges: ReadonlyArray<{ readonly node: { readonly id: string, readonly name: string, readonly startsAt: any, readonly severity: string, readonly annotations: any, readonly labels: any, readonly alertsChannelAssignments: { readonly edges: ReadonlyArray<{ readonly node: { readonly alertsChannelName: string, readonly alertsChannel: { readonly id: string, readonly silencedUntil: any | null } | null } }> } } }> } };

export type AlertsCountBySeverityQueryVariables = Exact<{
  where: InputMaybe<AlertBoolExp>;
}>;


export type AlertsCountBySeverityQuery = { readonly alerts: { readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly node: { readonly severity: string } }> } };

export type AlertsByNameQueryVariables = Exact<{
  where: InputMaybe<AlertBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
}>;


export type AlertsByNameQuery = { readonly alerts: { readonly edges: ReadonlyArray<{ readonly node: { readonly name: string } }> } };

export type AlertsBySeverityQueryVariables = Exact<{
  where: InputMaybe<AlertBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
}>;


export type AlertsBySeverityQuery = { readonly alerts: { readonly edges: ReadonlyArray<{ readonly node: { readonly severity: string } }> } };

export type AgentKeysGroupsTitleQueryVariables = Exact<{
  where: AgentKeyBoolExp;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<AgentKeyOrderBy>> | InputMaybe<AgentKeyOrderBy>>;
}>;


export type AgentKeysGroupsTitleQuery = { readonly agentKeys: { readonly totalCount: number, readonly pageInfo: { readonly startCursor: string | null, readonly endCursor: string | null, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean }, readonly edges: ReadonlyArray<{ readonly node: { readonly key: string, readonly id: string, readonly createdAt: any, readonly createdBy: { readonly name: string } | null, readonly agents: { readonly totalCount: number }, readonly controllers: { readonly totalCount: number } } }> } };

export type AgentKeysDataQueryVariables = Exact<{
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  where: InputMaybe<AgentKeyBoolExp>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<AgentKeyOrderBy>> | InputMaybe<AgentKeyOrderBy>>;
}>;


export type AgentKeysDataQuery = { readonly agentKeys: { readonly totalCount: number, readonly pageInfo: { readonly startCursor: string | null, readonly endCursor: string | null, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean }, readonly edges: ReadonlyArray<{ readonly node: { readonly key: string, readonly id: string, readonly createdAt: any, readonly createdBy: { readonly name: string } | null, readonly agents: { readonly totalCount: number }, readonly controllers: { readonly totalCount: number } } }> } };

export type GenerateAgentKeyMutationVariables = Exact<{
  input: GenerateAgentKeyInput;
}>;


export type GenerateAgentKeyMutation = { readonly generateAgentKey: { readonly agentKey: { readonly id: string, readonly key: string } | null } | null };

export type RevokeAgentKeyMutationVariables = Exact<{
  input: RevokeAgentKeyInput;
}>;


export type RevokeAgentKeyMutation = { readonly revokeAgentKey: { readonly agentKey: { readonly id: string } | null } | null };

export type AgentKeysKeyQueryVariables = Exact<{
  where: InputMaybe<AgentKeyBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
}>;


export type AgentKeysKeyQuery = { readonly agentKeys: { readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly node: { readonly key: string } }> } };

export type ControllersJobDataQueryVariables = Exact<{
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  where: InputMaybe<ControllerBoolExp>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<ControllerOrderBy>> | InputMaybe<ControllerOrderBy>>;
}>;


export type ControllersJobDataQuery = { readonly controllers: { readonly totalCount: number, readonly pageInfo: { readonly startCursor: string | null, readonly endCursor: string | null, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean }, readonly edges: ReadonlyArray<{ readonly node: { readonly lastSeen: any, readonly healthDetails: string } }> } };

export type AgentsJobDataQueryVariables = Exact<{
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  where: InputMaybe<AgentBoolExp>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<AgentOrderBy>> | InputMaybe<AgentOrderBy>>;
}>;


export type AgentsJobDataQuery = { readonly agents: { readonly totalCount: number, readonly pageInfo: { readonly startCursor: string | null, readonly endCursor: string | null, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean }, readonly edges: ReadonlyArray<{ readonly node: { readonly lastSeen: any, readonly healthDetails: string } }> } };

export type AgentsGroupsTitlesQueryVariables = Exact<{
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  where: InputMaybe<AgentBoolExp>;
  distinctOn: InputMaybe<ReadonlyArray<AgentSelectColumn> | AgentSelectColumn>;
}>;


export type AgentsGroupsTitlesQuery = { readonly agents: { readonly totalCount: number, readonly pageInfo: { readonly startCursor: string | null, readonly endCursor: string | null, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean }, readonly edges: ReadonlyArray<{ readonly node: { readonly status: string, readonly agentGroup: string, readonly version: string, readonly agentKey: { readonly key: string } } }> } };

export type AgentsGroupDataQueryVariables = Exact<{
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  where: InputMaybe<AgentBoolExp>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<AgentOrderBy>> | InputMaybe<AgentOrderBy>>;
}>;


export type AgentsGroupDataQuery = { readonly agents: { readonly totalCount: number, readonly pageInfo: { readonly startCursor: string | null, readonly endCursor: string | null, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean }, readonly edges: ReadonlyArray<{ readonly node: { readonly status: string, readonly hostname: string, readonly id: string, readonly lastSeen: any, readonly agentGroup: string, readonly version: string, readonly controller: { readonly id: string, readonly name: string, readonly status: string } | null, readonly agentKey: { readonly key: string } } }> } };

export type GetAgentsGroupQueryVariables = Exact<{
  where: InputMaybe<AgentBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAgentsGroupQuery = { readonly agents: { readonly edges: ReadonlyArray<{ readonly node: { readonly agentGroup: string } }> } };

export type GetAgentsControllerNameQueryVariables = Exact<{
  where: InputMaybe<AgentBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAgentsControllerNameQuery = { readonly agents: { readonly edges: ReadonlyArray<{ readonly node: { readonly controller: { readonly name: string } | null } }> } };

export type GetAgentsHostnameQueryVariables = Exact<{
  where: InputMaybe<AgentBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAgentsHostnameQuery = { readonly agents: { readonly edges: ReadonlyArray<{ readonly node: { readonly hostname: string } }> } };

export type GetAgentsAgentKeyQueryVariables = Exact<{
  where: InputMaybe<AgentBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAgentsAgentKeyQuery = { readonly agents: { readonly edges: ReadonlyArray<{ readonly node: { readonly agentKey: { readonly key: string } } }> } };

export type GetAgentsControllerVersionQueryVariables = Exact<{
  where: InputMaybe<AgentBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAgentsControllerVersionQuery = { readonly agents: { readonly edges: ReadonlyArray<{ readonly node: { readonly version: string } }> } };

export type GetAgentsStatusQueryVariables = Exact<{
  where: InputMaybe<AgentBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAgentsStatusQuery = { readonly agents: { readonly edges: ReadonlyArray<{ readonly node: { readonly status: string } }> } };

export type GetAgentsLastSeenQueryVariables = Exact<{
  where: InputMaybe<AgentBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAgentsLastSeenQuery = { readonly agents: { readonly edges: ReadonlyArray<{ readonly node: { readonly lastSeen: any } }> } };

export type GetControllerAgentInfoQueryVariables = Exact<{
  first: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<AgentBoolExp>;
}>;


export type GetControllerAgentInfoQuery = { readonly agents: { readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly node: { readonly status: string } }> }, readonly agentGroupsCount: { readonly totalCount: number } };

export type ControllerAgentsGroupsTitlesQueryVariables = Exact<{
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  where: InputMaybe<AgentBoolExp>;
  distinctOn: InputMaybe<ReadonlyArray<AgentSelectColumn> | AgentSelectColumn>;
}>;


export type ControllerAgentsGroupsTitlesQuery = { readonly agents: { readonly totalCount: number, readonly pageInfo: { readonly startCursor: string | null, readonly endCursor: string | null, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean }, readonly edges: ReadonlyArray<{ readonly node: { readonly id: string, readonly hostname: string, readonly agentGroup: string, readonly lastSeen: any, readonly status: string, readonly version: string, readonly agentKey: { readonly key: string } } }> } };

export type GetControllerAgentsDataQueryVariables = Exact<{
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  where: InputMaybe<AgentBoolExp>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<AgentOrderBy>> | InputMaybe<AgentOrderBy>>;
}>;


export type GetControllerAgentsDataQuery = { readonly agents: { readonly totalCount: number, readonly pageInfo: { readonly startCursor: string | null, readonly endCursor: string | null, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean }, readonly edges: ReadonlyArray<{ readonly node: { readonly id: string, readonly hostname: string, readonly agentGroup: string, readonly lastSeen: any, readonly status: string, readonly version: string, readonly agentKey: { readonly key: string } } }> } };

export type GetControllerAgentsHostnameQueryVariables = Exact<{
  where: InputMaybe<AgentBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetControllerAgentsHostnameQuery = { readonly agents: { readonly edges: ReadonlyArray<{ readonly node: { readonly hostname: string } }> } };

export type GetControllerAgentsAgentKeyQueryVariables = Exact<{
  where: InputMaybe<AgentBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetControllerAgentsAgentKeyQuery = { readonly agents: { readonly edges: ReadonlyArray<{ readonly node: { readonly agentKey: { readonly key: string } } }> } };

export type GetControllerAgentsVersionQueryVariables = Exact<{
  where: InputMaybe<AgentBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetControllerAgentsVersionQuery = { readonly agents: { readonly edges: ReadonlyArray<{ readonly node: { readonly version: string } }> } };

export type GetControllerAgentsStatusQueryVariables = Exact<{
  where: InputMaybe<AgentBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetControllerAgentsStatusQuery = { readonly agents: { readonly edges: ReadonlyArray<{ readonly node: { readonly status: string } }> } };

export type GetControllerAgentsLastSeenQueryVariables = Exact<{
  where: InputMaybe<AgentBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetControllerAgentsLastSeenQuery = { readonly agents: { readonly edges: ReadonlyArray<{ readonly node: { readonly lastSeen: any } }> } };

export type GetControllerAgentsLastAgentGroupQueryVariables = Exact<{
  where: InputMaybe<AgentBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetControllerAgentsLastAgentGroupQuery = { readonly agents: { readonly edges: ReadonlyArray<{ readonly node: { readonly agentGroup: string } }> } };

export type ControllersGroupsTitlesQueryVariables = Exact<{
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  where: InputMaybe<ControllerBoolExp>;
  distinctOn: InputMaybe<ReadonlyArray<ControllerSelectColumn> | ControllerSelectColumn>;
}>;


export type ControllersGroupsTitlesQuery = { readonly controllers: { readonly totalCount: number, readonly pageInfo: { readonly startCursor: string | null, readonly endCursor: string | null, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean }, readonly edges: ReadonlyArray<{ readonly node: { readonly name: string, readonly version: string, readonly lastSeen: any, readonly id: string, readonly status: string, readonly agentKey: { readonly key: string } } }> } };

export type GetControllersDataQueryVariables = Exact<{
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  where: InputMaybe<ControllerBoolExp>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<ControllerOrderBy>> | InputMaybe<ControllerOrderBy>>;
}>;


export type GetControllersDataQuery = { readonly controllers: { readonly totalCount: number, readonly pageInfo: { readonly startCursor: string | null, readonly endCursor: string | null, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean }, readonly edges: ReadonlyArray<{ readonly node: { readonly name: string, readonly id: string, readonly version: string, readonly lastSeen: any, readonly status: string, readonly agents: { readonly totalCount: number }, readonly agentKey: { readonly key: string } } }> } };

export type GetControllersNameQueryVariables = Exact<{
  where: InputMaybe<ControllerBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetControllersNameQuery = { readonly controllers: { readonly edges: ReadonlyArray<{ readonly node: { readonly name: string } }> } };

export type GetControllersAgentKeyQueryVariables = Exact<{
  where: InputMaybe<ControllerBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetControllersAgentKeyQuery = { readonly controllers: { readonly edges: ReadonlyArray<{ readonly node: { readonly agentKey: { readonly key: string } } }> } };

export type GetControllersVersionQueryVariables = Exact<{
  where: InputMaybe<ControllerBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetControllersVersionQuery = { readonly controllers: { readonly edges: ReadonlyArray<{ readonly node: { readonly version: string } }> } };

export type GetControllersStatusQueryVariables = Exact<{
  where: InputMaybe<ControllerBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetControllersStatusQuery = { readonly controllers: { readonly edges: ReadonlyArray<{ readonly node: { readonly status: string } }> } };

export type GetControllersLastSeenQueryVariables = Exact<{
  where: InputMaybe<ControllerBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetControllersLastSeenQuery = { readonly controllers: { readonly edges: ReadonlyArray<{ readonly node: { readonly lastSeen: any } }> } };

export type ApiKeyQueryVariables = Exact<{
  where: InputMaybe<AgentKeyBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
}>;


export type ApiKeyQuery = { readonly agentKeys: { readonly edges: ReadonlyArray<{ readonly node: { readonly key: string } }> } };

export type GetProjectRegionQueryVariables = Exact<{
  where: InputMaybe<ProjectBoolExp>;
}>;


export type GetProjectRegionQuery = { readonly projects: { readonly edges: ReadonlyArray<{ readonly node: { readonly region: string } }> } };

export type DiscoveryKubernetesKindCountQueryVariables = Exact<{
  replicaSet: InputMaybe<KubernetesControlPointBoolExp>;
  statefulSets: InputMaybe<KubernetesControlPointBoolExp>;
  deployments: InputMaybe<KubernetesControlPointBoolExp>;
}>;


export type DiscoveryKubernetesKindCountQuery = { readonly replicaSet: { readonly totalCount: number }, readonly statefulSets: { readonly totalCount: number }, readonly deployments: { readonly totalCount: number } };

export type DiscoveryKubernetesGroupsTitlesQueryVariables = Exact<{
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  where: InputMaybe<KubernetesControlPointBoolExp>;
  distinctOn: InputMaybe<ReadonlyArray<KubernetesControlPointSelectColumn> | KubernetesControlPointSelectColumn>;
}>;


export type DiscoveryKubernetesGroupsTitlesQuery = { readonly kubernetesControlPoints: { readonly totalCount: number, readonly pageInfo: { readonly startCursor: string | null, readonly endCursor: string | null, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean }, readonly edges: ReadonlyArray<{ readonly node: { readonly name: string, readonly kind: string, readonly namespace: string, readonly apiVersion: string, readonly status: string, readonly lastSeen: any, readonly controller: { readonly name: string } | null, readonly agent: { readonly agentGroup: string } } }> } };

export type KubernetesControlPointQueryVariables = Exact<{
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  where: InputMaybe<KubernetesControlPointBoolExp>;
  distinctOn: InputMaybe<ReadonlyArray<KubernetesControlPointSelectColumn> | KubernetesControlPointSelectColumn>;
  orderBy: InputMaybe<ReadonlyArray<KubernetesControlPointOrderBy> | KubernetesControlPointOrderBy>;
}>;


export type KubernetesControlPointQuery = { readonly kubernetesControlPoints: { readonly totalCount: number, readonly pageInfo: { readonly startCursor: string | null, readonly endCursor: string | null, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean }, readonly edges: ReadonlyArray<{ readonly node: { readonly name: string, readonly kind: string, readonly namespace: string, readonly apiVersion: string, readonly status: string, readonly lastSeen: any, readonly controller: { readonly name: string } | null, readonly agent: { readonly agentGroup: string } } }> } };

export type DiscoveryKubernetesNameQueryVariables = Exact<{
  where: InputMaybe<KubernetesControlPointBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
}>;


export type DiscoveryKubernetesNameQuery = { readonly kubernetesControlPoints: { readonly edges: ReadonlyArray<{ readonly node: { readonly name: string } }> } };

export type DiscoveryKubernetesControllerNameQueryVariables = Exact<{
  where: InputMaybe<KubernetesControlPointBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
}>;


export type DiscoveryKubernetesControllerNameQuery = { readonly kubernetesControlPoints: { readonly edges: ReadonlyArray<{ readonly node: { readonly controller: { readonly name: string } | null } }> } };

export type DiscoveryKubernetesApiVersionQueryVariables = Exact<{
  where: InputMaybe<KubernetesControlPointBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
}>;


export type DiscoveryKubernetesApiVersionQuery = { readonly kubernetesControlPoints: { readonly edges: ReadonlyArray<{ readonly node: { readonly apiVersion: string } }> } };

export type DiscoveryKubernetesNamespaceQueryVariables = Exact<{
  where: InputMaybe<KubernetesControlPointBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
}>;


export type DiscoveryKubernetesNamespaceQuery = { readonly kubernetesControlPoints: { readonly edges: ReadonlyArray<{ readonly node: { readonly namespace: string } }> } };

export type DiscoveryKubernetesKindQueryVariables = Exact<{
  where: InputMaybe<KubernetesControlPointBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
}>;


export type DiscoveryKubernetesKindQuery = { readonly kubernetesControlPoints: { readonly edges: ReadonlyArray<{ readonly node: { readonly kind: string } }> } };

export type DiscoveryServicesAllAndWithControlPointsQueryVariables = Exact<{
  where: InputMaybe<ServiceBoolExp>;
  whereControlPoint: InputMaybe<ServiceBoolExp>;
}>;


export type DiscoveryServicesAllAndWithControlPointsQuery = { readonly services: { readonly totalCount: number }, readonly servicesWithControlPoint: { readonly totalCount: number } };

export type DiscoveryServicesGroupsTitlesQueryVariables = Exact<{
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  where: InputMaybe<ServiceBoolExp>;
  distinctOn: InputMaybe<ReadonlyArray<ServiceSelectColumn> | ServiceSelectColumn>;
}>;


export type DiscoveryServicesGroupsTitlesQuery = { readonly services: { readonly totalCount: number, readonly pageInfo: { readonly startCursor: string | null, readonly endCursor: string | null, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean }, readonly edges: ReadonlyArray<{ readonly node: { readonly name: string, readonly agentGroup: string, readonly status: string, readonly lastSeen: any, readonly controller: { readonly name: string }, readonly controlPoints: { readonly totalCount: number } } }> } };

export type DiscoveryServicesGroupDataQueryVariables = Exact<{
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  where: InputMaybe<ServiceBoolExp>;
  distinctOn: InputMaybe<ReadonlyArray<ServiceSelectColumn> | ServiceSelectColumn>;
  orderBy: InputMaybe<ReadonlyArray<ServiceOrderBy> | ServiceOrderBy>;
}>;


export type DiscoveryServicesGroupDataQuery = { readonly services: { readonly totalCount: number, readonly pageInfo: { readonly startCursor: string | null, readonly endCursor: string | null, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean }, readonly edges: ReadonlyArray<{ readonly node: { readonly name: string, readonly agentGroup: string, readonly status: string, readonly lastSeen: any, readonly controller: { readonly name: string }, readonly controlPoints: { readonly totalCount: number }, readonly alertsCount: ReadonlyArray<{ readonly count: number, readonly severity: string }> | null } }> } };

export type DiscoveryServicesNameQueryVariables = Exact<{
  where: InputMaybe<ServiceBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
}>;


export type DiscoveryServicesNameQuery = { readonly services: { readonly edges: ReadonlyArray<{ readonly node: { readonly name: string } }> } };

export type DiscoveryServicesAgentGroupQueryVariables = Exact<{
  where: InputMaybe<ServiceBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
}>;


export type DiscoveryServicesAgentGroupQuery = { readonly services: { readonly edges: ReadonlyArray<{ readonly node: { readonly agentGroup: string } }> } };

export type DiscoveryServicesControllerNameQueryVariables = Exact<{
  where: InputMaybe<ServiceBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
}>;


export type DiscoveryServicesControllerNameQuery = { readonly services: { readonly edges: ReadonlyArray<{ readonly node: { readonly controller: { readonly name: string } } }> } };

export type SecretsGroupTitlesQueryVariables = Exact<{
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<ApertureSecretSelectColumn> | ApertureSecretSelectColumn>;
}>;


export type SecretsGroupTitlesQuery = { readonly apertureSecrets: { readonly edges: ReadonlyArray<{ readonly node: { readonly name: string } }> } };

export type SecretsGroupDataQueryVariables = Exact<{
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  distinctOn: InputMaybe<ReadonlyArray<ApertureSecretSelectColumn> | ApertureSecretSelectColumn>;
  where: InputMaybe<ApertureSecretBoolExp>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<ApertureSecretOrderBy>> | InputMaybe<ApertureSecretOrderBy>>;
}>;


export type SecretsGroupDataQuery = { readonly apertureSecrets: { readonly totalCount: number, readonly pageInfo: { readonly startCursor: string | null, readonly endCursor: string | null, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean }, readonly edges: ReadonlyArray<{ readonly node: { readonly id: string, readonly name: string, readonly value: string, readonly createdAt: any, readonly createdBy: { readonly name: string } | null } }> } };

export type AddApertureSecretMutationVariables = Exact<{
  input: CreateApertureSecretInput;
}>;


export type AddApertureSecretMutation = { readonly createApertureSecret: { readonly apertureSecret: { readonly id: string } | null } | null };

export type DeleteApertureSecretMutationVariables = Exact<{
  input: DeleteApertureSecretInput;
}>;


export type DeleteApertureSecretMutation = { readonly deleteApertureSecret: { readonly apertureSecret: { readonly id: string } | null } | null };

export type SecretsNameQueryVariables = Exact<{
  where: InputMaybe<ApertureSecretBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
}>;


export type SecretsNameQuery = { readonly apertureSecrets: { readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly node: { readonly name: string } }> } };

export type GlobalCacheGroupsTitlesQueryVariables = Exact<{
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  where: InputMaybe<ServiceBoolExp>;
  distinctOn: InputMaybe<ReadonlyArray<ServiceSelectColumn> | ServiceSelectColumn>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<ServiceOrderBy>> | InputMaybe<ServiceOrderBy>>;
}>;


export type GlobalCacheGroupsTitlesQuery = { readonly services: { readonly totalCount: number, readonly pageInfo: { readonly startCursor: string | null, readonly endCursor: string | null, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean }, readonly edges: ReadonlyArray<{ readonly node: { readonly id: string, readonly status: string, readonly agentGroup: string, readonly controller: { readonly id: string, readonly name: string } } }> } };

export type GlobalCacheQueryVariables = Exact<{
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  where: InputMaybe<ServiceBoolExp>;
  distinctOn: InputMaybe<ReadonlyArray<ServiceSelectColumn> | ServiceSelectColumn>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<ServiceOrderBy>> | InputMaybe<ServiceOrderBy>>;
}>;


export type GlobalCacheQuery = { readonly services: { readonly totalCount: number, readonly pageInfo: { readonly startCursor: string | null, readonly endCursor: string | null, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean }, readonly edges: ReadonlyArray<{ readonly node: { readonly id: string, readonly status: string, readonly agentGroup: string, readonly controller: { readonly id: string, readonly name: string } } }> } };

export type ResultCacheAgentGroupQueryVariables = Exact<{
  where: InputMaybe<ServiceBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
}>;


export type ResultCacheAgentGroupQuery = { readonly services: { readonly edges: ReadonlyArray<{ readonly node: { readonly agentGroup: string } }> } };

export type ResultCacheControllerNameQueryVariables = Exact<{
  where: InputMaybe<ServiceBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
}>;


export type ResultCacheControllerNameQuery = { readonly services: { readonly edges: ReadonlyArray<{ readonly node: { readonly controller: { readonly name: string } } }> } };

export type ResultCacheGroupsTitlesQueryVariables = Exact<{
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  where: InputMaybe<ControlPointBoolExp>;
  distinctOn: InputMaybe<ReadonlyArray<ControlPointSelectColumn> | ControlPointSelectColumn>;
}>;


export type ResultCacheGroupsTitlesQuery = { readonly controlPoints: { readonly totalCount: number, readonly pageInfo: { readonly startCursor: string | null, readonly endCursor: string | null, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean }, readonly edges: ReadonlyArray<{ readonly node: { readonly name: string, readonly lastSeen: any, readonly status: string, readonly type: string, readonly service: { readonly id: string, readonly agentGroup: string, readonly status: string, readonly controller: { readonly name: string } } | null } }> } };

export type ResultCacheQueryVariables = Exact<{
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  where: InputMaybe<ControlPointBoolExp>;
  distinctOn: InputMaybe<ReadonlyArray<ControlPointSelectColumn> | ControlPointSelectColumn>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<ControlPointOrderBy>> | InputMaybe<ControlPointOrderBy>>;
}>;


export type ResultCacheQuery = { readonly controlPoints: { readonly totalCount: number, readonly pageInfo: { readonly startCursor: string | null, readonly endCursor: string | null, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean }, readonly edges: ReadonlyArray<{ readonly node: { readonly id: string, readonly name: string, readonly status: string, readonly type: string, readonly lastSeen: any, readonly service: { readonly id: string, readonly name: string, readonly agentGroup: string, readonly controller: { readonly name: string, readonly id: string } } | null, readonly controlPointComponentAssignments: { readonly edges: ReadonlyArray<{ readonly node: { readonly component: { readonly policy: { readonly id: string } } | null } }> } } }> } };

export type FlowControlPointsControlPointNameQueryVariables = Exact<{
  where: InputMaybe<ControlPointBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
}>;


export type FlowControlPointsControlPointNameQuery = { readonly controlPoints: { readonly edges: ReadonlyArray<{ readonly node: { readonly name: string } }> } };

export type DeleteServiceMutationVariables = Exact<{
  input: DeleteServiceInput;
}>;


export type DeleteServiceMutation = { readonly deleteService: { readonly service: { readonly id: string } | null } | null };

export type ControlPointsCountQueryVariables = Exact<{
  whereControlPoint: InputMaybe<ControlPointBoolExp>;
  whereServices: InputMaybe<ServiceBoolExp>;
}>;


export type ControlPointsCountQuery = { readonly controlPoints: { readonly totalCount: number }, readonly services: { readonly totalCount: number } };

export type ControlPointAssignmentsQueryVariables = Exact<{
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  where: InputMaybe<ControlPointBoolExp>;
  distinctOn: InputMaybe<ReadonlyArray<ControlPointSelectColumn> | ControlPointSelectColumn>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<ControlPointOrderBy>> | InputMaybe<ControlPointOrderBy>>;
}>;


export type ControlPointAssignmentsQuery = { readonly controlPoints: { readonly totalCount: number, readonly pageInfo: { readonly startCursor: string | null, readonly endCursor: string | null, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean }, readonly edges: ReadonlyArray<{ readonly node: { readonly name: string, readonly lastSeen: any, readonly status: string, readonly id: string, readonly controlPointComponentAssignments: { readonly edges: ReadonlyArray<{ readonly node: { readonly component: { readonly type: string, readonly subtype: string | null, readonly id: string, readonly policy: { readonly name: string, readonly id: string } } | null } }> }, readonly controlPointFluxMeterAssignments: { readonly edges: ReadonlyArray<{ readonly node: { readonly fluxMeter: { readonly name: string, readonly id: string, readonly policy: { readonly name: string, readonly id: string } } | null } }> }, readonly controlPointClassifierAssignments: { readonly edges: ReadonlyArray<{ readonly node: { readonly classifier: { readonly id: string, readonly labelSelector: any, readonly flowLabel: string, readonly policy: { readonly name: string, readonly id: string } } | null } }> } } }> } };

export type FlowControlGroupsTitlesQueryVariables = Exact<{
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  where: InputMaybe<ControlPointBoolExp>;
  distinctOn: InputMaybe<ReadonlyArray<ControlPointSelectColumn> | ControlPointSelectColumn>;
}>;


export type FlowControlGroupsTitlesQuery = { readonly controlPoints: { readonly totalCount: number, readonly pageInfo: { readonly startCursor: string | null, readonly endCursor: string | null, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean }, readonly edges: ReadonlyArray<{ readonly node: { readonly name: string, readonly lastSeen: any, readonly status: string, readonly type: string, readonly service: { readonly id: string, readonly agentGroup: string, readonly status: string, readonly controller: { readonly name: string } } | null } }> } };

export type FlowControlGroupDataQueryVariables = Exact<{
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  where: InputMaybe<ControlPointBoolExp>;
  distinctOn: InputMaybe<ReadonlyArray<ControlPointSelectColumn> | ControlPointSelectColumn>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<ControlPointOrderBy>> | InputMaybe<ControlPointOrderBy>>;
}>;


export type FlowControlGroupDataQuery = { readonly controlPoints: { readonly totalCount: number, readonly pageInfo: { readonly startCursor: string | null, readonly endCursor: string | null, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean }, readonly edges: ReadonlyArray<{ readonly node: { readonly id: string, readonly name: string, readonly lastSeen: any, readonly discoveredOn: any, readonly status: string, readonly type: string, readonly service: { readonly id: string, readonly name: string, readonly status: string, readonly agentGroup: string, readonly controller: { readonly name: string, readonly id: string } } | null, readonly controlPointComponentAssignments: { readonly edges: ReadonlyArray<{ readonly node: { readonly component: { readonly policy: { readonly id: string } } | null } }> } } }> } };

export type FlowControlNameQueryVariables = Exact<{
  where: InputMaybe<ControlPointBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
}>;


export type FlowControlNameQuery = { readonly controlPoints: { readonly edges: ReadonlyArray<{ readonly node: { readonly service: { readonly name: string } | null } }> } };

export type FlowControlAgentGroupQueryVariables = Exact<{
  where: InputMaybe<ServiceBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
}>;


export type FlowControlAgentGroupQuery = { readonly services: { readonly edges: ReadonlyArray<{ readonly node: { readonly agentGroup: string } }> } };

export type FlowControlControllerNameQueryVariables = Exact<{
  where: InputMaybe<ServiceBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
}>;


export type FlowControlControllerNameQuery = { readonly services: { readonly edges: ReadonlyArray<{ readonly node: { readonly controller: { readonly name: string } } }> } };

export type ControlPointsKubernetesGroupsTitlesQueryVariables = Exact<{
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  where: InputMaybe<KubernetesControlPointBoolExp>;
  distinctOn: InputMaybe<ReadonlyArray<KubernetesControlPointSelectColumn> | KubernetesControlPointSelectColumn>;
}>;


export type ControlPointsKubernetesGroupsTitlesQuery = { readonly kubernetesControlPoints: { readonly totalCount: number, readonly pageInfo: { readonly startCursor: string | null, readonly endCursor: string | null, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean }, readonly edges: ReadonlyArray<{ readonly node: { readonly name: string, readonly kind: string, readonly namespace: string, readonly apiVersion: string, readonly status: string, readonly lastSeen: any, readonly controller: { readonly name: string } | null, readonly agent: { readonly agentGroup: string } } }> } };

export type ControlPointsKubernetesGroupDataQueryVariables = Exact<{
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  where: InputMaybe<KubernetesControlPointBoolExp>;
  distinctOn: InputMaybe<ReadonlyArray<KubernetesControlPointSelectColumn> | KubernetesControlPointSelectColumn>;
  orderBy: InputMaybe<ReadonlyArray<KubernetesControlPointOrderBy> | KubernetesControlPointOrderBy>;
}>;


export type ControlPointsKubernetesGroupDataQuery = { readonly kubernetesControlPoints: { readonly totalCount: number, readonly pageInfo: { readonly startCursor: string | null, readonly endCursor: string | null, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean }, readonly edges: ReadonlyArray<{ readonly node: { readonly name: string, readonly kind: string, readonly namespace: string, readonly apiVersion: string, readonly status: string, readonly lastSeen: any, readonly discoveredOn: any, readonly controller: { readonly name: string } | null, readonly agent: { readonly agentGroup: string } } }> } };

export type ControlPointsKubernetesNameQueryVariables = Exact<{
  where: InputMaybe<KubernetesControlPointBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
}>;


export type ControlPointsKubernetesNameQuery = { readonly kubernetesControlPoints: { readonly edges: ReadonlyArray<{ readonly node: { readonly name: string } }> } };

export type ControlPointsKubernetesControllerNameQueryVariables = Exact<{
  where: InputMaybe<KubernetesControlPointBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
}>;


export type ControlPointsKubernetesControllerNameQuery = { readonly kubernetesControlPoints: { readonly edges: ReadonlyArray<{ readonly node: { readonly controller: { readonly name: string } | null } }> } };

export type ControlPointsKubernetesApiVersionQueryVariables = Exact<{
  where: InputMaybe<KubernetesControlPointBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
}>;


export type ControlPointsKubernetesApiVersionQuery = { readonly kubernetesControlPoints: { readonly edges: ReadonlyArray<{ readonly node: { readonly apiVersion: string } }> } };

export type ControlPointsKubernetesNamespaceQueryVariables = Exact<{
  where: InputMaybe<KubernetesControlPointBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
}>;


export type ControlPointsKubernetesNamespaceQuery = { readonly kubernetesControlPoints: { readonly edges: ReadonlyArray<{ readonly node: { readonly namespace: string } }> } };

export type ControlPointsKubernetesKindQueryVariables = Exact<{
  where: InputMaybe<KubernetesControlPointBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
}>;


export type ControlPointsKubernetesKindQuery = { readonly kubernetesControlPoints: { readonly edges: ReadonlyArray<{ readonly node: { readonly kind: string } }> } };

export type AgentsGroupsQueryVariables = Exact<{
  distinctOn: InputMaybe<ReadonlyArray<AgentSelectColumn> | AgentSelectColumn>;
}>;


export type AgentsGroupsQuery = { readonly agents: { readonly edges: ReadonlyArray<{ readonly node: { readonly agentGroup: string } }> } };

export type ControlPointsQueryVariables = Exact<{
  distinctOn: InputMaybe<ReadonlyArray<ControlPointSelectColumn> | ControlPointSelectColumn>;
}>;


export type ControlPointsQuery = { readonly controlPoints: { readonly edges: ReadonlyArray<{ readonly node: { readonly name: string } }> } };

export type GetCloudControllerVersionQueryVariables = Exact<{
  where: InputMaybe<ControllerBoolExp>;
}>;


export type GetCloudControllerVersionQuery = { readonly controllers: { readonly edges: ReadonlyArray<{ readonly node: { readonly id: string, readonly name: string, readonly version: string, readonly commitSha: string } }> } };

export type CreateBlueprintPolicyDefinitionMutationVariables = Exact<{
  input: CreateBlueprintPolicyDefinitionInput;
}>;


export type CreateBlueprintPolicyDefinitionMutation = { readonly createBlueprintPolicyDefinition: { readonly blueprintPolicyDefinition: { readonly blueprintName: string, readonly blueprintVersion: string, readonly id: string, readonly name: string, readonly status: string, readonly values: any, readonly editedAt: any } | null } | null };

export type CreateCustomPolicyDefinitionMutationVariables = Exact<{
  input: CreateCustomPolicyDefinitionInput;
}>;


export type CreateCustomPolicyDefinitionMutation = { readonly createCustomPolicyDefinition: { readonly customPolicyDefinition: { readonly id: string, readonly name: string, readonly body: any, readonly status: string, readonly editedAt: any } | null } | null };

export type UpdateBlueprintPolicyDefinitionMutationVariables = Exact<{
  input: UpdateBlueprintPolicyDefinitionInput;
}>;


export type UpdateBlueprintPolicyDefinitionMutation = { readonly updateBlueprintPolicyDefinition: { readonly blueprintPolicyDefinition: { readonly blueprintName: string, readonly blueprintVersion: string, readonly values: any, readonly id: string, readonly editedAt: any } | null } | null };

export type UpdateCustomPolicyDefinitionMutationVariables = Exact<{
  input: UpdateCustomPolicyDefinitionInput;
}>;


export type UpdateCustomPolicyDefinitionMutation = { readonly updateCustomPolicyDefinition: { readonly customPolicyDefinition: { readonly body: any, readonly id: string, readonly name: string, readonly editedAt: any } | null } | null };

export type BlueprintPolicyDefinitionsQueryVariables = Exact<{
  where: InputMaybe<BlueprintPolicyDefinitionBoolExp>;
}>;


export type BlueprintPolicyDefinitionsQuery = { readonly blueprintPolicyDefinitions: { readonly edges: ReadonlyArray<{ readonly node: { readonly values: any, readonly id: string, readonly name: string, readonly status: string, readonly blueprintName: string, readonly blueprintVersion: string, readonly editedAt: any } }> } };

export type CustomPolicyDefinitionsQueryVariables = Exact<{
  where: InputMaybe<CustomPolicyDefinitionBoolExp>;
}>;


export type CustomPolicyDefinitionsQuery = { readonly customPolicyDefinitions: { readonly edges: ReadonlyArray<{ readonly node: { readonly id: string, readonly name: string, readonly body: any, readonly editedAt: any, readonly status: string } }> } };

export type ApplyBlueprintPolicyMutationVariables = Exact<{
  input: ApplyBlueprintDefinedPolicyInput;
}>;


export type ApplyBlueprintPolicyMutation = { readonly applyBlueprintDefinedPolicy: { readonly workflowID: string } | null };

export type ApplyCustomDefinedPolicyMutationVariables = Exact<{
  input: ApplyCustomDefinedPolicyInput;
}>;


export type ApplyCustomDefinedPolicyMutation = { readonly applyCustomDefinedPolicy: { readonly workflowID: string } | null };

export type PoliciesQueryVariables = Exact<{
  where: PolicyBoolExp;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<PolicyOrderBy>> | InputMaybe<PolicyOrderBy>>;
  distinctOn: InputMaybe<ReadonlyArray<PolicySelectColumn> | PolicySelectColumn>;
}>;


export type PoliciesQuery = { readonly policies: { readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly node: { readonly id: string, readonly name: string, readonly body: any, readonly hash: string, readonly circuit: { readonly actuators: ReadonlyArray<{ readonly componentName: string, readonly componentId: string, readonly componentType: string, readonly componentDescription: string } | null> | null, readonly children: ReadonlyArray<{ readonly hasChildren: boolean, readonly node: { readonly componentId: string } | null } | null> | null, readonly graph: { readonly externalLinks: ReadonlyArray<{ readonly looped: string, readonly subCircuitId: string, readonly source: { readonly componentId: string, readonly portName: string } | null, readonly target: { readonly componentId: string, readonly portName: string } | null, readonly value: { readonly constantValue: number } | { readonly signalName: string } | null } | null> | null, readonly internalLinks: ReadonlyArray<{ readonly looped: string, readonly subCircuitId: string, readonly source: { readonly componentId: string, readonly portName: string } | null, readonly target: { readonly componentId: string, readonly portName: string } | null, readonly value: { readonly constantValue: number } | { readonly signalName: string } | null } | null> | null, readonly internalComponents: ReadonlyArray<{ readonly component: any, readonly componentId: string, readonly componentName: string, readonly componentType: string, readonly componentDescription: string, readonly inPorts: ReadonlyArray<{ readonly looped: boolean, readonly portName: string, readonly subCircuitId: string, readonly value: { readonly constantValue: number } | { readonly signalName: string } | null } | null> | null, readonly outPorts: ReadonlyArray<{ readonly looped: boolean, readonly portName: string, readonly subCircuitId: string, readonly value: { readonly constantValue: number } | { readonly signalName: string } | null } | null> | null } | null> | null, readonly externalComponents: ReadonlyArray<{ readonly component: any, readonly componentId: string, readonly componentName: string, readonly componentType: string, readonly componentDescription: string, readonly inPorts: ReadonlyArray<{ readonly looped: boolean, readonly portName: string, readonly subCircuitId: string, readonly value: { readonly constantValue: number } | { readonly signalName: string } | null } | null> | null, readonly outPorts: ReadonlyArray<{ readonly looped: boolean, readonly portName: string, readonly subCircuitId: string, readonly value: { readonly constantValue: number } | { readonly signalName: string } | null } | null> | null } | null> | null } | null, readonly node: { readonly componentId: string } | null }, readonly controller: { readonly name: string }, readonly classifiers: { readonly edges: ReadonlyArray<{ readonly node: { readonly id: string, readonly flowLabel: string, readonly policy: { readonly id: string, readonly name: string, readonly body: any, readonly controller: { readonly name: string } } } }> }, readonly fluxMeters: { readonly edges: ReadonlyArray<{ readonly node: { readonly name: string, readonly id: string, readonly policy: { readonly id: string, readonly name: string, readonly controller: { readonly name: string } } } }> } } }> } };

export type PoliciesGroupsTitlesQueryVariables = Exact<{
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  where: InputMaybe<PolicyWithDefinitionBoolExp>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<PolicyWithDefinitionOrderBy>> | InputMaybe<PolicyWithDefinitionOrderBy>>;
  distinctOn: InputMaybe<ReadonlyArray<PolicyWithDefinitionSelectColumn> | PolicyWithDefinitionSelectColumn>;
}>;


export type PoliciesGroupsTitlesQuery = { readonly policiesWithDefinition: { readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly node: { readonly name: string, readonly origin: string, readonly status: string, readonly policy: { readonly start: string, readonly lastSeen: any, readonly controller: { readonly name: string, readonly id: string } } | null } }> } };

export type PoliciesGroupDataQueryVariables = Exact<{
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  where: InputMaybe<PolicyWithDefinitionBoolExp>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<PolicyWithDefinitionOrderBy>> | InputMaybe<PolicyWithDefinitionOrderBy>>;
}>;


export type PoliciesGroupDataQuery = { readonly policiesWithDefinition: { readonly totalCount: number, readonly pageInfo: { readonly startCursor: string | null, readonly endCursor: string | null, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean }, readonly edges: ReadonlyArray<{ readonly node: { readonly name: string, readonly origin: string, readonly status: string, readonly policy: { readonly id: string, readonly start: string, readonly lastSeen: any, readonly controller: { readonly id: string, readonly name: string } } | null, readonly blueprintPolicyDefinition: { readonly id: string, readonly message: string | null, readonly createdBy: { readonly name: string } | null, readonly lastModifiedBy: { readonly name: string } | null } | null, readonly customPolicyDefinition: { readonly id: string, readonly message: string | null, readonly createdBy: { readonly name: string } | null, readonly lastModifiedBy: { readonly name: string } | null } | null } }> } };

export type RemoveBlueprintDefinedPolicyMutationVariables = Exact<{
  input: RemoveBlueprintDefinedPolicyInput;
}>;


export type RemoveBlueprintDefinedPolicyMutation = { readonly removeBlueprintDefinedPolicy: { readonly workflowID: string } | null };

export type RemoveCustomDefinedPolicyMutationVariables = Exact<{
  input: RemoveCustomDefinedPolicyInput;
}>;


export type RemoveCustomDefinedPolicyMutation = { readonly removeCustomDefinedPolicy: { readonly workflowID: string } | null };

export type ClassifierDashboardQueryVariables = Exact<{
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  where: InputMaybe<ClassifierBoolExp>;
  distinctOn: InputMaybe<ReadonlyArray<ClassifierSelectColumn> | ClassifierSelectColumn>;
}>;


export type ClassifierDashboardQuery = { readonly classifiers: { readonly totalCount: number, readonly pageInfo: { readonly startCursor: string | null, readonly endCursor: string | null, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean }, readonly edges: ReadonlyArray<{ readonly cursor: string, readonly node: { readonly id: string, readonly flowLabel: string, readonly policy: { readonly id: string, readonly name: string, readonly body: any, readonly controller: { readonly name: string } } } }> } };

export type FluxMeterDashboardQueryVariables = Exact<{
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  where: InputMaybe<FluxMeterBoolExp>;
  distinctOn: InputMaybe<ReadonlyArray<FluxMeterSelectColumn> | FluxMeterSelectColumn>;
}>;


export type FluxMeterDashboardQuery = { readonly fluxMeters: { readonly totalCount: number, readonly pageInfo: { readonly startCursor: string | null, readonly endCursor: string | null, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean }, readonly edges: ReadonlyArray<{ readonly node: { readonly name: string, readonly id: string, readonly policy: { readonly id: string, readonly name: string, readonly controller: { readonly name: string } } } }> } };

export type CircuitDashboardQueryVariables = Exact<{
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  where: InputMaybe<PolicyBoolExp>;
  distinctOn: InputMaybe<ReadonlyArray<PolicySelectColumn> | PolicySelectColumn>;
}>;


export type CircuitDashboardQuery = { readonly policies: { readonly totalCount: number, readonly pageInfo: { readonly startCursor: string | null, readonly endCursor: string | null, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean }, readonly edges: ReadonlyArray<{ readonly node: { readonly name: string, readonly id: string, readonly hash: string, readonly body: any, readonly circuit: { readonly actuators: ReadonlyArray<{ readonly component: any, readonly componentId: string, readonly componentName: string, readonly componentType: string, readonly componentDescription: string } | null> | null, readonly graph: { readonly internalLinks: ReadonlyArray<{ readonly subCircuitId: string, readonly looped: string, readonly source: { readonly componentId: string, readonly portName: string } | null, readonly target: { readonly componentId: string, readonly portName: string } | null, readonly value: { readonly constantValue: number } | { readonly signalName: string } | null } | null> | null, readonly externalLinks: ReadonlyArray<{ readonly subCircuitId: string, readonly looped: string, readonly source: { readonly componentId: string, readonly portName: string } | null, readonly target: { readonly componentId: string, readonly portName: string } | null, readonly value: { readonly constantValue: number } | { readonly signalName: string } | null } | null> | null } | null, readonly children: ReadonlyArray<{ readonly hasChildren: boolean, readonly node: { readonly componentId: string, readonly componentDescription: string, readonly componentType: string, readonly component: any, readonly componentName: string, readonly inPorts: ReadonlyArray<{ readonly subCircuitId: string, readonly portName: string, readonly looped: boolean, readonly value: { readonly constantValue: number } | { readonly signalName: string } | null } | null> | null, readonly outPorts: ReadonlyArray<{ readonly subCircuitId: string, readonly portName: string, readonly looped: boolean, readonly value: { readonly constantValue: number } | { readonly signalName: string } | null } | null> | null } | null } | null> | null }, readonly controller: { readonly name: string } } }> } };

export type PolicyControllerQueryVariables = Exact<{
  where: InputMaybe<PolicyBoolExp>;
}>;


export type PolicyControllerQuery = { readonly policies: { readonly edges: ReadonlyArray<{ readonly node: { readonly name: string, readonly hash: string, readonly controller: { readonly id: string } } }> } };

export type ChangeUserNameMutationVariables = Exact<{
  input: UpdateUserNameInput;
}>;


export type ChangeUserNameMutation = { readonly updateUserName: { readonly user: { readonly id: string, readonly name: string } | null } | null };

export type GetOrganizationMembersQueryVariables = Exact<{
  first: InputMaybe<Scalars['Int']['input']>;
  where: UserBoolExp;
}>;


export type GetOrganizationMembersQuery = { readonly users: { readonly edges: ReadonlyArray<{ readonly node: { readonly email: string, readonly name: string, readonly id: string, readonly organizationMemberships: { readonly edges: ReadonlyArray<{ readonly node: { readonly id: string } }> } } }> } };

export type UpdateUserRoleMutationVariables = Exact<{
  input: UpdateUserRoleInput;
}>;


export type UpdateUserRoleMutation = { readonly updateUserRole: { readonly organizationMembership: { readonly role: string, readonly user: { readonly id: string } } | null } | null };

export type GetOrganizationOwnersQueryVariables = Exact<{
  where: InputMaybe<OrganizationMembershipBoolExp>;
}>;


export type GetOrganizationOwnersQuery = { readonly organizationMemberships: { readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly node: { readonly role: string, readonly id: string, readonly user: { readonly name: string, readonly email: string, readonly id: string } } }> } };

export type UserApiKeysDataQueryVariables = Exact<{
  where: InputMaybe<UserApiKeyBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<UserApiKeyOrderBy>> | InputMaybe<UserApiKeyOrderBy>>;
}>;


export type UserApiKeysDataQuery = { readonly userAPIKeys: { readonly totalCount: number, readonly pageInfo: { readonly startCursor: string | null, readonly endCursor: string | null, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean }, readonly edges: ReadonlyArray<{ readonly node: { readonly key: string, readonly id: string, readonly createdAt: any, readonly expiresAt: any } }> } };

export type GenerateUserApiKeyMutationVariables = Exact<{ [key: string]: never; }>;


export type GenerateUserApiKeyMutation = { readonly generateUserAPIKey: { readonly userAPIKey: { readonly id: string, readonly key: string, readonly createdAt: any } | null } | null };

export type RevokeUserApiKeyMutationVariables = Exact<{
  input: RevokeUserApiKeyInput;
}>;


export type RevokeUserApiKeyMutation = { readonly revokeUserAPIKey: { readonly userAPIKey: { readonly key: string, readonly id: string, readonly createdAt: any, readonly expiresAt: any } | null } | null };

export type GetProjectNamesQueryVariables = Exact<{
  where: InputMaybe<ProjectBoolExp>;
}>;


export type GetProjectNamesQuery = { readonly projects: { readonly edges: ReadonlyArray<{ readonly node: { readonly name: string, readonly id: string } }> } };

export type CreateUserGroupMutationVariables = Exact<{
  input: CreateUserGroupInput;
}>;


export type CreateUserGroupMutation = { readonly createUserGroup: { readonly userGroup: { readonly name: string } | null } | null };

export type UpdateOrganizationNameMutationVariables = Exact<{
  input: UpdateOrganizationNameInput;
}>;


export type UpdateOrganizationNameMutation = { readonly updateOrganizationName: { readonly organization: { readonly name: string } | null } | null };

export type GetOrganizationDefaultRoleQueryVariables = Exact<{
  where: InputMaybe<OrganizationBoolExp>;
}>;


export type GetOrganizationDefaultRoleQuery = { readonly organizations: { readonly edges: ReadonlyArray<{ readonly node: { readonly defaultRole: string } }> } };

export type UpdateOrganizationDefaultRoleMutationVariables = Exact<{
  input: UpdateOrganizationDefaultRoleInput;
}>;


export type UpdateOrganizationDefaultRoleMutation = { readonly updateOrganizationDefaultRole: { readonly organization: { readonly defaultRole: string } | null } | null };

export type GetUserGroupPerMembershipQueryVariables = Exact<{
  yours: InputMaybe<UserGroupBoolExp>;
  others: InputMaybe<UserGroupBoolExp>;
}>;


export type GetUserGroupPerMembershipQuery = { readonly yours: { readonly edges: ReadonlyArray<{ readonly node: { readonly id: string, readonly name: string, readonly userGroupMemberships: { readonly totalCount: number } } }> }, readonly others: { readonly edges: ReadonlyArray<{ readonly node: { readonly id: string, readonly name: string, readonly userGroupMemberships: { readonly totalCount: number } } }> } };

export type GetAllUserGroupsQueryVariables = Exact<{
  first: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<UserGroupBoolExp>;
}>;


export type GetAllUserGroupsQuery = { readonly userGroups: { readonly edges: ReadonlyArray<{ readonly node: { readonly id: string, readonly name: string, readonly userGroupMemberships: { readonly totalCount: number } } }> } };

export type AddUserGroupToProjectMutationVariables = Exact<{
  input: CreateUserGroupProjectAssignmentInput;
}>;


export type AddUserGroupToProjectMutation = { readonly addUserGroupToProject: { readonly userGroupProjectAssignment: { readonly id: string, readonly project: { readonly name: string } } | null } | null };

export type GetOrgUsersQueryVariables = Exact<{
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<UserOrderBy>> | InputMaybe<UserOrderBy>>;
  where: InputMaybe<UserBoolExp>;
}>;


export type GetOrgUsersQuery = { readonly users: { readonly totalCount: number, readonly pageInfo: { readonly startCursor: string | null, readonly endCursor: string | null, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean }, readonly edges: ReadonlyArray<{ readonly node: { readonly id: string, readonly email: string, readonly name: string, readonly userGroupMemberships: { readonly totalCount: number }, readonly organizationMemberships: { readonly edges: ReadonlyArray<{ readonly node: { readonly id: string, readonly role: string, readonly status: string, readonly end: string | null } }> } } }> } };

export type UserOrgMembershipsQueryVariables = Exact<{
  where: InputMaybe<OrganizationMembershipBoolExp>;
}>;


export type UserOrgMembershipsQuery = { readonly organizationMemberships: { readonly totalCount: number } };

export type UserUserGroupByIdQueryVariables = Exact<{
  where: InputMaybe<UserGroupBoolExp>;
}>;


export type UserUserGroupByIdQuery = { readonly userGroups: { readonly edges: ReadonlyArray<{ readonly node: { readonly id: string, readonly name: string, readonly userGroupMemberships: { readonly totalCount: number } } }> } };

export type GetUserByIdQueryVariables = Exact<{
  where: UserBoolExp;
}>;


export type GetUserByIdQuery = { readonly users: { readonly edges: ReadonlyArray<{ readonly node: { readonly id: string, readonly email: string, readonly name: string, readonly organizationMemberships: { readonly edges: ReadonlyArray<{ readonly node: { readonly id: string, readonly start: string, readonly role: string, readonly status: string } }> } } }> } };

export type CreateUserGroupSettingsMutationVariables = Exact<{
  input: CreateUserGroupInput;
}>;


export type CreateUserGroupSettingsMutation = { readonly createUserGroup: { readonly userGroup: { readonly id: string } | null } | null };

export type CreateProjectMutationVariables = Exact<{
  input: CreateProjectInput;
}>;


export type CreateProjectMutation = { readonly createProject: { readonly project: { readonly name: string, readonly id: string } | null } | null };

export type GetProjectsSettingsQueryVariables = Exact<{
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<ProjectOrderBy>> | InputMaybe<ProjectOrderBy>>;
  where: InputMaybe<ProjectBoolExp>;
}>;


export type GetProjectsSettingsQuery = { readonly projects: { readonly totalCount: number, readonly pageInfo: { readonly startCursor: string | null, readonly endCursor: string | null, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean }, readonly edges: ReadonlyArray<{ readonly node: { readonly id: string, readonly name: string, readonly status: string, readonly region: string, readonly cloud_provider: string, readonly userGroupProjectAssignments: { readonly totalCount: number } } }> } };

export type GetProjectCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectCountQuery = { readonly projects: { readonly totalCount: number } };

export type GetProjectsByIdQueryVariables = Exact<{
  where: InputMaybe<ProjectBoolExp>;
}>;


export type GetProjectsByIdQuery = { readonly projects: { readonly edges: ReadonlyArray<{ readonly node: { readonly id: string, readonly name: string, readonly description: string, readonly status: string, readonly region: string, readonly cloud_provider: string, readonly userGroupProjectAssignments: { readonly edges: ReadonlyArray<{ readonly node: { readonly id: string, readonly permissions: string | null } }> } } }> } };

export type RemoveProjectMutationVariables = Exact<{
  input: DeleteProjectInput;
}>;


export type RemoveProjectMutation = { readonly deleteProject: { readonly project: { readonly name: string } | null } | null };

export type GetAllUserGroupsToAddQueryVariables = Exact<{
  first: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<UserGroupBoolExp>;
}>;


export type GetAllUserGroupsToAddQuery = { readonly userGroups: { readonly edges: ReadonlyArray<{ readonly node: { readonly id: string, readonly name: string, readonly userGroupProjectAssignments: { readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly node: { readonly project: { readonly id: string } } }> } } }> } };

export type UserGroupProjectAssignmentQueryVariables = Exact<{
  where: InputMaybe<UserGroupProjectAssignmentBoolExp>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<UserGroupProjectAssignmentOrderBy>> | InputMaybe<UserGroupProjectAssignmentOrderBy>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
}>;


export type UserGroupProjectAssignmentQuery = { readonly userGroupProjectAssignments: { readonly totalCount: number, readonly pageInfo: { readonly startCursor: string | null, readonly endCursor: string | null, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean }, readonly edges: ReadonlyArray<{ readonly node: { readonly id: string, readonly permissions: string | null, readonly userGroup: { readonly id: string, readonly name: string, readonly userGroupMemberships: { readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly node: { readonly user: { readonly id: string } } }> } } } }> } };

export type ChangeProjectNameMutationVariables = Exact<{
  input: UpdateProjectNameInput;
}>;


export type ChangeProjectNameMutation = { readonly updateProjectName: { readonly project: { readonly id: string, readonly name: string } | null } | null };

export type UpdateProjectRegionMutationVariables = Exact<{
  input: UpdateProjectRegionInput;
}>;


export type UpdateProjectRegionMutation = { readonly updateProjectRegion: { readonly project: { readonly id: string, readonly region: string, readonly cloud_provider: string } | null } | null };

export type ChangeProjectDescriptionMutationVariables = Exact<{
  input: UpdateProjectDescriptionInput;
}>;


export type ChangeProjectDescriptionMutation = { readonly updateProjectDescription: { readonly project: { readonly id: string, readonly description: string } | null } | null };

export type UpdateUserGroupProjectAssignmentPermissionsMutationVariables = Exact<{
  input: UpdateUserGroupProjectAssignmentPermissionsInput;
}>;


export type UpdateUserGroupProjectAssignmentPermissionsMutation = { readonly updateUserGroupProjectAssignmentPermissions: { readonly userGroupProjectAssignment: { readonly id: string, readonly permissions: string | null, readonly userGroup: { readonly name: string } } | null } | null };

export type GetUserGroupsQueryVariables = Exact<{
  where: InputMaybe<UserGroupBoolExp>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<UserGroupOrderBy>> | InputMaybe<UserGroupOrderBy>>;
}>;


export type GetUserGroupsQuery = { readonly userGroups: { readonly totalCount: number, readonly pageInfo: { readonly startCursor: string | null, readonly endCursor: string | null, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean }, readonly edges: ReadonlyArray<{ readonly node: { readonly id: string, readonly name: string, readonly userGroupMemberships: { readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly node: { readonly user: { readonly id: string } } }> }, readonly userGroupProjectAssignments: { readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly node: { readonly project: { readonly id: string, readonly name: string } } }> } } }> } };

export type DeleteUserGroupMutationVariables = Exact<{
  input: DeleteUserGroupInput;
}>;


export type DeleteUserGroupMutation = { readonly deleteUserGroup: { readonly userGroup: { readonly id: string } | null } | null };

export type GetUserGroupMembershipsByIdQueryVariables = Exact<{
  where: InputMaybe<UserGroupMembershipBoolExp>;
}>;


export type GetUserGroupMembershipsByIdQuery = { readonly userGroupMemberships: { readonly edges: ReadonlyArray<{ readonly node: { readonly id: string } }> } };

export type GetOrganizationEmailListQueryVariables = Exact<{
  first: InputMaybe<Scalars['Int']['input']>;
  where: UserBoolExp;
}>;


export type GetOrganizationEmailListQuery = { readonly users: { readonly edges: ReadonlyArray<{ readonly node: { readonly email: string, readonly id: string } }> } };

export type RemoveUserFromUserGroupMutationVariables = Exact<{
  input: DeleteUserGroupMembershipInput;
}>;


export type RemoveUserFromUserGroupMutation = { readonly removeUserFromUserGroup: { readonly userGroupMembership: { readonly id: string, readonly userGroup: { readonly id: string }, readonly user: { readonly email: string } } | null } | null };

export type GetUserGroupMembershipsQueryVariables = Exact<{
  where: UserGroupMembershipBoolExp;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserGroupMembershipsQuery = { readonly userGroupMemberships: { readonly totalCount: number, readonly pageInfo: { readonly startCursor: string | null, readonly endCursor: string | null, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean }, readonly edges: ReadonlyArray<{ readonly node: { readonly id: string, readonly user: { readonly id: string, readonly name: string, readonly email: string, readonly organizationMemberships: { readonly edges: ReadonlyArray<{ readonly node: { readonly role: string, readonly status: string } }> } } } }> } };

export type ProjectsQueryVariables = Exact<{
  first: InputMaybe<Scalars['Int']['input']>;
  where: ProjectBoolExp;
}>;


export type ProjectsQuery = { readonly projects: { readonly edges: ReadonlyArray<{ readonly node: { readonly id: string, readonly name: string, readonly userGroupProjectAssignments: { readonly edges: ReadonlyArray<{ readonly node: { readonly userGroup: { readonly id: string } } }> } } }> } };

export type RemoveUserGroupFromProjectMutationVariables = Exact<{
  input: DeleteUserGroupProjectAssignmentInput;
}>;


export type RemoveUserGroupFromProjectMutation = { readonly removeUserGroupFromProject: { readonly userGroupProjectAssignment: { readonly project: { readonly name: string } } | null } | null };

export type UserGroupAssignedProjectsQueryVariables = Exact<{
  where: InputMaybe<UserGroupProjectAssignmentBoolExp>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<UserGroupProjectAssignmentOrderBy>> | InputMaybe<UserGroupProjectAssignmentOrderBy>>;
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
}>;


export type UserGroupAssignedProjectsQuery = { readonly userGroupProjectAssignments: { readonly totalCount: number, readonly pageInfo: { readonly startCursor: string | null, readonly endCursor: string | null, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean }, readonly edges: ReadonlyArray<{ readonly node: { readonly id: string, readonly permissions: string | null, readonly userGroup: { readonly id: string, readonly name: string }, readonly project: { readonly name: string, readonly id: string } } }> } };

export type UserGroupsQueryVariables = Exact<{
  where: UserGroupBoolExp;
}>;


export type UserGroupsQuery = { readonly userGroups: { readonly edges: ReadonlyArray<{ readonly node: { readonly id: string, readonly name: string } }> } };

export type GetProjectDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectDetailsQuery = { readonly projects: { readonly edges: ReadonlyArray<{ readonly node: { readonly name: string, readonly id: string, readonly region: string, readonly status: string } }> } };

export type GetProjectStatusQueryVariables = Exact<{
  where: InputMaybe<ProjectBoolExp>;
}>;


export type GetProjectStatusQuery = { readonly projects: { readonly edges: ReadonlyArray<{ readonly node: { readonly status: string } }> } };

export type GetProjectQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectQuery = { readonly projects: { readonly totalCount: number } };

export type GetOrganizationQueryVariables = Exact<{
  where: InputMaybe<OrganizationBoolExp>;
}>;


export type GetOrganizationQuery = { readonly organizations: { readonly edges: ReadonlyArray<{ readonly node: { readonly name: string, readonly domainName: string, readonly id: string } }> } };

export type GetDefaultUserGroupQueryVariables = Exact<{
  where: InputMaybe<UserGroupBoolExp>;
}>;


export type GetDefaultUserGroupQuery = { readonly userGroups: { readonly edges: ReadonlyArray<{ readonly node: { readonly id: string, readonly name: string } }> } };

export type WelcomeScreenUserGroupNameChangeMutationVariables = Exact<{
  input: UpdateUserGroupNameInput;
}>;


export type WelcomeScreenUserGroupNameChangeMutation = { readonly updateUserGroupName: { readonly userGroup: { readonly id: string } | null } | null };

export type GetDefaultProjectQueryVariables = Exact<{
  where: InputMaybe<ProjectBoolExp>;
}>;


export type GetDefaultProjectQuery = { readonly projects: { readonly edges: ReadonlyArray<{ readonly node: { readonly id: string, readonly name: string, readonly cloud_provider: string, readonly region: string, readonly description: string } }> } };

export type WelcomeScreenProjectNameChangeMutationVariables = Exact<{
  input: UpdateProjectNameInput;
}>;


export type WelcomeScreenProjectNameChangeMutation = { readonly updateProjectName: { readonly project: { readonly id: string } | null } | null };

export type WelcomeScreenProjectDescriptionChangeMutationVariables = Exact<{
  input: UpdateProjectDescriptionInput;
}>;


export type WelcomeScreenProjectDescriptionChangeMutation = { readonly updateProjectDescription: { readonly project: { readonly id: string } | null } | null };

export type WelcomeScreenProjectRegionChangeMutationVariables = Exact<{
  input: UpdateProjectRegionInput;
}>;


export type WelcomeScreenProjectRegionChangeMutation = { readonly updateProjectRegion: { readonly project: { readonly id: string } | null } | null };

export type WelcomePageOnBoardingMutationVariables = Exact<{
  input: OnboardOrganizationInput;
}>;


export type WelcomePageOnBoardingMutation = { readonly onboardOrganization: { readonly organization: { readonly name: string } | null } | null };

export type GetAgentsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgentsCountQuery = { readonly agents: { readonly totalCount: number } };

export type GetUsersQueryVariables = Exact<{
  first: InputMaybe<Scalars['Int']['input']>;
  last: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  before: InputMaybe<Scalars['String']['input']>;
  orderBy: InputMaybe<ReadonlyArray<InputMaybe<UserOrderBy>> | InputMaybe<UserOrderBy>>;
  where: InputMaybe<UserBoolExp>;
}>;


export type GetUsersQuery = { readonly users: { readonly totalCount: number, readonly pageInfo: { readonly startCursor: string | null, readonly endCursor: string | null, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean }, readonly edges: ReadonlyArray<{ readonly node: { readonly id: string, readonly email: string, readonly name: string, readonly organizationMemberships: { readonly edges: ReadonlyArray<{ readonly node: { readonly id: string, readonly role: string, readonly status: string, readonly end: string | null } }> } } }> } };

export type NullQueryVariables = Exact<{ [key: string]: never; }>;


export type NullQuery = { readonly users: { readonly totalCount: number } };
